*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured `sans` font-family by default.
5. Use the user's configured `sans` font-feature-settings by default.
6. Use the user's configured `sans` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from `html` so users can set them as a class directly on the `html` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured `mono` font-family by default.
2. Use the user's configured `mono` font-feature-settings by default.
3. Use the user's configured `mono` font-variation-settings by default.
4. Correct the odd `em` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent `sub` and `sup` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to `inherit` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

:root {
  --oui-font-family: "Manrope", "PingFang SC", "Noto Sans CJK SC", "Noto Sans", sans-serif;
  --oui-color-primary: 156 117 255;
  --oui-color-primary-light: 156 117 255;
  --oui-color-primary-darken: 103 0 206;
  --oui-color-primary-contrast: 255 255 255;
  --oui-color-link: 156 117 255;
  --oui-color-link-light: 156 117 255;
  --oui-color-secondary: 255 255 255;
  --oui-color-tertiary: 132 131 136;
  --oui-color-quaternary: 98 96 102;
  --oui-color-danger: 233 77 122;
  --oui-color-danger-light: 233 77 122;
  --oui-color-danger-darken: 233 77 122;
  --oui-color-danger-contrast: 9 6 16;
  --oui-color-success: 2 181 137;
  --oui-color-success-light: 2 181 137;
  --oui-color-success-darken: 2 181 137;
  --oui-color-success-contrast: 9 6 16;
  --oui-color-warning: 217 171 82;
  --oui-color-warning-light: 217 171 82;
  --oui-color-warning-darken: 217 171 82;
  --oui-color-warning-contrast: 9 6 16;
  --oui-color-fill: 29 25 41;
  --oui-color-fill-active: 43 39 54;
  --oui-color-base-1: 66 61 75;
  --oui-color-base-2: 57 53 65;
  --oui-color-base-3: 54 50 64;
  --oui-color-base-4: 51 47 62;
  --oui-color-base-5: 43 39 54;
  --oui-color-base-6: 29 25 41;
  --oui-color-base-7: 25 22 36;
  --oui-color-base-8: 22 18 32;
  --oui-color-base-9: 19 14 29;
  --oui-color-base-10: 9 6 16;
  --oui-color-base-foreground: 255 255 255;
  --oui-color-line: 255 255 255;
  --oui-color-base-static: 255 255 255;
  --oui-color-base-static-contrast: 0 0 0;
  --oui-color-trading-loss: 233 77 122;
  --oui-color-trading-loss-contrast: 9 6 16;
  --oui-color-trading-profit: 2 181 137;
  --oui-color-trading-profit-contrast: 9 6 16;
  --oui-gradient-primary-start: 156 117 255;
  --oui-gradient-primary-end: 156 117 255;
  --oui-gradient-secondary-start: 156 117 255;
  --oui-gradient-secondary-end: 156 117 255;
  --oui-gradient-success-start: 2 181 137;
  --oui-gradient-success-end: 2 181 137;
  --oui-gradient-danger-start: 233 77 122;
  --oui-gradient-danger-end: 233 77 122;
  --oui-gradient-warning-start: 217 171 82;
  --oui-gradient-warning-end: 217 171 82;
  --oui-gradient-neutral-start: 29 25 41;
  --oui-gradient-neutral-end: 29 25 41;
  --oui-gradient-brand-start: 156 117 255;
  --oui-gradient-brand-end: 156 117 255;
  --oui-gradient-brand-stop-start: 6.62%;
  --oui-gradient-brand-stop-end: 86.5%;
  --oui-gradient-brand-angle: 17.44deg;
  --oui-rounded-sm: 2px;
  --oui-rounded: 4px;
  --oui-rounded-md: 6px;
  --oui-rounded-lg: 8px;
  --oui-rounded-xl: 12px;
  --oui-rounded-2xl: 16px;
  --oui-rounded-full: 9999px;
  --oui-spacing-xs: 20rem;
  --oui-spacing-sm: 22.5rem;
  --oui-spacing-md: 26.25rem;
  --oui-spacing-lg: 30rem;
  --oui-spacing-xl: 33.75rem;
}

html {
  background-color: rgb(var(--oui-color-base-10));
  color: rgb(var(--oui-color-base-foreground) / 0.98);
  font-family: var(--oui-font-family);
}

body {
  background-color: rgb(var(--oui-color-base-10));
  color: rgb(var(--oui-color-base-foreground) / 0.98);
  font-family: var(--oui-font-family);
  font-weight: 500;
  font-feature-settings: "ss02" 1, "ss03" 1, "ss05" 1, "ss06" 1;
}

h1, h2, h3, h4, h5, h6, [role='heading'] {
  font-weight: 600;
}

:where(.oui-text-2xl, .oui-text-3xl, .oui-text-4xl, .oui-text-5xl) {
  font-weight: 600;
}

:where(.oui-text-2xs, .oui-text-xs, .oui-text-sm) {
  font-weight: 500;
}
.oui-size-height {
  height: var(--oui-height, unset);
}
.oui-size-width {
  width: var(--oui-width, unset);
}
.xAxis .recharts-cartesian-axis-tick:first-child text {
  text-anchor: start;
}
.xAxis .recharts-cartesian-axis-tick:last-child text {
  text-anchor: end;
}
.oui-position {
  left: var(--oui-left, unset);
  top: var(--oui-top, unset);
  right: var(--oui-right, unset);
  bottom: var(--oui-bottom, unset);
}
.oui-card {
  color: red;
}
.oui-card:has(.oui-header-list) {
  padding-top: 0px;
  padding-bottom: 0px;
}
.oui-custom-scrollbar::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.oui-custom-scrollbar::-webkit-scrollbar-track {
  background-color: transparent;
  border-radius: 4px;
  padding-top: 20px;
}
.oui-custom-scrollbar::-webkit-scrollbar-thumb {
  border-radius: 3px;
  border-style: dashed;
  border-color: transparent;
  border-width: 1px;
  background-color: rgb(var(--oui-color-base-7));
  background-clip: padding-box;
}
.oui-custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: rgb(var(--oui-color-base-5));
  border-radius: 3px;
}
.oui-custom-scrollbar::-webkit-scrollbar-corner {
  background-color: transparent;
}
.oui-hide-scrollbar::-webkit-scrollbar {
  display: none;
}
.oui-hide-scrollbar::-webkit-scrollbar-thumb {
  display: none;
}
  @property --gradientAngle {
    syntax: "<angle>";
    inherits: false;
    initial-value: 0deg;
  }
  @keyframes angleRotateChange {
    0% {
      --gradientAngle: 0deg;
    }
    100% {
      --gradientAngle: 360deg;
    }
  }
.oui-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.oui-pointer-events-none {
  pointer-events: none;
}
.oui-pointer-events-auto {
  pointer-events: auto;
}
.oui-visible {
  visibility: visible;
}
.oui-invisible {
  visibility: hidden;
}
.oui-static {
  position: static;
}
.oui-fixed {
  position: fixed;
}
.\!oui-absolute {
  position: absolute !important;
}
.oui-absolute {
  position: absolute;
}
.oui-relative {
  position: relative;
}
.oui-sticky {
  position: sticky;
}
.oui-inset-0 {
  inset: 0px;
}
.oui-inset-3 {
  inset: 0.75rem;
}
.oui-inset-x-0 {
  left: 0px;
  right: 0px;
}
.oui-inset-x-\[50px\] {
  left: 50px;
  right: 50px;
}
.oui-inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.\!oui-bottom-\[30px\] {
  bottom: 30px !important;
}
.\!oui-bottom-\[40px\] {
  bottom: 40px !important;
}
.\!oui-end-1 {
  inset-inline-end: 0.25rem !important;
}
.\!oui-top-1 {
  top: 0.25rem !important;
}
.-oui-end-3 {
  inset-inline-end: -0.75rem;
}
.-oui-end-\[1px\] {
  inset-inline-end: -1px;
}
.-oui-end-\[6px\] {
  inset-inline-end: -6px;
}
.-oui-end-px {
  inset-inline-end: -1px;
}
.-oui-top-4 {
  top: -1rem;
}
.-oui-top-\[1px\] {
  top: -1px;
}
.-oui-top-\[5px\] {
  top: -5px;
}
.-oui-top-\[6px\] {
  top: -6px;
}
.-oui-top-\[calc\(100vh\/2\)\] {
  top: calc(calc(100vh / 2) * -1);
}
.-oui-top-px {
  top: -1px;
}
.oui--bottom-12 {
  bottom: -3rem;
}
.oui--end-12 {
  inset-inline-end: -3rem;
}
.oui--start-12 {
  inset-inline-start: -3rem;
}
.oui--top-12 {
  top: -3rem;
}
.oui-bottom-0 {
  bottom: 0px;
}
.oui-bottom-1 {
  bottom: 0.25rem;
}
.oui-bottom-6 {
  bottom: 1.5rem;
}
.oui-bottom-\[-1\.5px\] {
  bottom: -1.5px;
}
.oui-bottom-\[-12px\] {
  bottom: -12px;
}
.oui-bottom-\[38px\] {
  bottom: 38px;
}
.oui-bottom-\[calc\(env\(safe-area-inset-bottom\)\+8px\)\] {
  bottom: calc(env(safe-area-inset-bottom) + 8px);
}
.oui-bottom-full {
  bottom: 100%;
}
.oui-end-0 {
  inset-inline-end: 0px;
}
.oui-end-1 {
  inset-inline-end: 0.25rem;
}
.oui-end-2 {
  inset-inline-end: 0.5rem;
}
.oui-end-3 {
  inset-inline-end: 0.75rem;
}
.oui-end-4 {
  inset-inline-end: 1rem;
}
.oui-end-\[-1\.5px\] {
  inset-inline-end: -1.5px;
}
.oui-end-\[-100\%\] {
  inset-inline-end: -100%;
}
.oui-end-\[-20px\] {
  inset-inline-end: -20px;
}
.oui-end-\[1px\] {
  inset-inline-end: 1px;
}
.oui-left-0 {
  left: 0px;
}
.oui-left-\[50\%\] {
  left: 50%;
}
.oui-start-0 {
  inset-inline-start: 0px;
}
.oui-start-1 {
  inset-inline-start: 0.25rem;
}
.oui-start-1\/2 {
  inset-inline-start: 50%;
}
.oui-start-2 {
  inset-inline-start: 0.5rem;
}
.oui-start-3 {
  inset-inline-start: 0.75rem;
}
.oui-start-6 {
  inset-inline-start: 1.5rem;
}
.oui-start-\[-1\.5px\] {
  inset-inline-start: -1.5px;
}
.oui-start-\[-100\%\] {
  inset-inline-start: -100%;
}
.oui-start-\[-9px\] {
  inset-inline-start: -9px;
}
.oui-start-\[10px\] {
  inset-inline-start: 10px;
}
.oui-start-\[30px\] {
  inset-inline-start: 30px;
}
.oui-start-\[4px\] {
  inset-inline-start: 4px;
}
.oui-top-0 {
  top: 0px;
}
.oui-top-0\.5 {
  top: 0.125rem;
}
.oui-top-1 {
  top: 0.25rem;
}
.oui-top-1\/2 {
  top: 50%;
}
.oui-top-2 {
  top: 0.5rem;
}
.oui-top-2\/4 {
  top: 50%;
}
.oui-top-4 {
  top: 1rem;
}
.oui-top-\[-1\.5px\] {
  top: -1.5px;
}
.oui-top-\[-12px\] {
  top: -12px;
}
.oui-top-\[-28px\] {
  top: -28px;
}
.oui-top-\[-300px\] {
  top: -300px;
}
.oui-top-\[0px\] {
  top: 0px;
}
.oui-top-\[100px\] {
  top: 100px;
}
.oui-top-\[10px\] {
  top: 10px;
}
.oui-top-\[16px\] {
  top: 16px;
}
.oui-top-\[18px\] {
  top: 18px;
}
.oui-top-\[1px\] {
  top: 1px;
}
.oui-top-\[20px\] {
  top: 20px;
}
.oui-top-\[3px\] {
  top: 3px;
}
.oui-top-\[44px\] {
  top: 44px;
}
.oui-top-\[48px\] {
  top: 48px;
}
.oui-top-\[50\%\] {
  top: 50%;
}
.oui-top-\[5px\] {
  top: 5px;
}
.oui-top-\[6\.5px\] {
  top: 6.5px;
}
.oui-top-\[7px\] {
  top: 7px;
}
.oui-top-full {
  top: 100%;
}
.oui-isolate {
  isolation: isolate;
}
.oui-z-0 {
  z-index: 0;
}
.oui-z-10 {
  z-index: 10;
}
.oui-z-20 {
  z-index: 20;
}
.oui-z-30 {
  z-index: 30;
}
.oui-z-40 {
  z-index: 40;
}
.oui-z-50 {
  z-index: 50;
}
.oui-z-\[-1\] {
  z-index: -1;
}
.oui-z-\[100\] {
  z-index: 100;
}
.oui-z-\[1\] {
  z-index: 1;
}
.oui-z-\[2\] {
  z-index: 2;
}
.oui-z-\[3\] {
  z-index: 3;
}
.oui-z-\[60\] {
  z-index: 60;
}
.oui-z-\[65\] {
  z-index: 65;
}
.oui-z-\[99\] {
  z-index: 99;
}
.oui-z-auto {
  z-index: auto;
}
.oui-order-1 {
  order: 1;
}
.oui-order-2 {
  order: 2;
}
.oui-col-auto {
  grid-column: auto;
}
.oui-col-span-1 {
  grid-column: span 1 / span 1;
}
.oui-col-span-2 {
  grid-column: span 2 / span 2;
}
.oui-col-span-3 {
  grid-column: span 3 / span 3;
}
.oui-col-span-4 {
  grid-column: span 4 / span 4;
}
.oui-col-span-5 {
  grid-column: span 5 / span 5;
}
.oui-col-span-6 {
  grid-column: span 6 / span 6;
}
.oui-col-span-7 {
  grid-column: span 7 / span 7;
}
.oui-col-span-8 {
  grid-column: span 8 / span 8;
}
.oui-col-span-9 {
  grid-column: span 9 / span 9;
}
.oui-col-start-3 {
  grid-column-start: 3;
}
.oui-row-auto {
  grid-row: auto;
}
.oui-row-span-1 {
  grid-row: span 1 / span 1;
}
.oui-row-span-2 {
  grid-row: span 2 / span 2;
}
.oui-row-span-3 {
  grid-row: span 3 / span 3;
}
.oui-row-span-4 {
  grid-row: span 4 / span 4;
}
.oui-row-span-5 {
  grid-row: span 5 / span 5;
}
.oui-row-span-6 {
  grid-row: span 6 / span 6;
}
.oui-row-span-7 {
  grid-row: span 7 / span 7;
}
.oui-row-span-8 {
  grid-row: span 8 / span 8;
}
.oui-row-span-9 {
  grid-row: span 9 / span 9;
}
.oui-m-0 {
  margin: 0px;
}
.oui-m-1 {
  margin: 0.25rem;
}
.oui-m-10 {
  margin: 2.5rem;
}
.oui-m-2 {
  margin: 0.5rem;
}
.oui-m-3 {
  margin: 0.75rem;
}
.oui-m-4 {
  margin: 1rem;
}
.oui-m-5 {
  margin: 1.25rem;
}
.oui-m-6 {
  margin: 1.5rem;
}
.oui-m-7 {
  margin: 1.75rem;
}
.oui-m-8 {
  margin: 2rem;
}
.oui-m-9 {
  margin: 2.25rem;
}
.\!oui-mx-\[3px\] {
  margin-left: 3px !important;
  margin-right: 3px !important;
}
.\!oui-my-\[3px\] {
  margin-top: 3px !important;
  margin-bottom: 3px !important;
}
.-oui-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.oui-mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}
.oui-mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.oui-mx-10 {
  margin-left: 2.5rem;
  margin-right: 2.5rem;
}
.oui-mx-11 {
  margin-left: 2.75rem;
  margin-right: 2.75rem;
}
.oui-mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.oui-mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.oui-mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.oui-mx-5 {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.oui-mx-6 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.oui-mx-7 {
  margin-left: 1.75rem;
  margin-right: 1.75rem;
}
.oui-mx-8 {
  margin-left: 2rem;
  margin-right: 2rem;
}
.oui-mx-9 {
  margin-left: 2.25rem;
  margin-right: 2.25rem;
}
.oui-mx-\[-8px\] {
  margin-left: -8px;
  margin-right: -8px;
}
.oui-mx-\[5px\] {
  margin-left: 5px;
  margin-right: 5px;
}
.oui-mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.oui-my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}
.oui-my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.oui-my-1\.5 {
  margin-top: 0.375rem;
  margin-bottom: 0.375rem;
}
.oui-my-10 {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}
.oui-my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.oui-my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.oui-my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.oui-my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.oui-my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.oui-my-7 {
  margin-top: 1.75rem;
  margin-bottom: 1.75rem;
}
.oui-my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.oui-my-9 {
  margin-top: 2.25rem;
  margin-bottom: 2.25rem;
}
.oui-my-\[6px\] {
  margin-top: 6px;
  margin-bottom: 6px;
}
.oui-my-px {
  margin-top: 1px;
  margin-bottom: 1px;
}
.\!oui-mb-\[6px\] {
  margin-bottom: 6px !important;
}
.-oui-mb-1 {
  margin-bottom: -0.25rem;
}
.-oui-mb-2 {
  margin-bottom: -0.5rem;
}
.-oui-mb-5 {
  margin-bottom: -1.25rem;
}
.-oui-me-4 {
  margin-inline-end: -1rem;
}
.-oui-me-\[4px\] {
  margin-inline-end: -4px;
}
.-oui-ms-2 {
  margin-inline-start: -0.5rem;
}
.-oui-ms-4 {
  margin-inline-start: -1rem;
}
.-oui-mt-2 {
  margin-top: -0.5rem;
}
.-oui-mt-4 {
  margin-top: -1rem;
}
.oui--mb-\[22px\] {
  margin-bottom: -22px;
}
.oui--ml-4 {
  margin-left: -1rem;
}
.oui--mt-1 {
  margin-top: -0.25rem;
}
.oui--mt-12 {
  margin-top: -3rem;
}
.oui--mt-4 {
  margin-top: -1rem;
}
.oui--mt-6 {
  margin-top: -1.5rem;
}
.oui-mb-0 {
  margin-bottom: 0px;
}
.oui-mb-1 {
  margin-bottom: 0.25rem;
}
.oui-mb-10 {
  margin-bottom: 2.5rem;
}
.oui-mb-2 {
  margin-bottom: 0.5rem;
}
.oui-mb-3 {
  margin-bottom: 0.75rem;
}
.oui-mb-4 {
  margin-bottom: 1rem;
}
.oui-mb-5 {
  margin-bottom: 1.25rem;
}
.oui-mb-6 {
  margin-bottom: 1.5rem;
}
.oui-mb-7 {
  margin-bottom: 1.75rem;
}
.oui-mb-8 {
  margin-bottom: 2rem;
}
.oui-mb-9 {
  margin-bottom: 2.25rem;
}
.oui-mb-\[-8px\] {
  margin-bottom: -8px;
}
.oui-mb-\[10px\] {
  margin-bottom: 10px;
}
.oui-mb-\[32px\] {
  margin-bottom: 32px;
}
.oui-mb-\[3px\] {
  margin-bottom: 3px;
}
.oui-mb-\[clamp\(2rem\,3vw\,3rem\)\] {
  margin-bottom: clamp(2rem, 3vw, 3rem);
}
.oui-mb-\[clamp\(4rem\,6vw\,6rem\)\] {
  margin-bottom: clamp(4rem, 6vw, 6rem);
}
.oui-me-1 {
  margin-inline-end: 0.25rem;
}
.oui-me-2 {
  margin-inline-end: 0.5rem;
}
.oui-me-3 {
  margin-inline-end: 0.75rem;
}
.oui-me-4 {
  margin-inline-end: 1rem;
}
.oui-me-6 {
  margin-inline-end: 1.5rem;
}
.oui-me-\[2px\] {
  margin-inline-end: 2px;
}
.oui-me-\[6px\] {
  margin-inline-end: 6px;
}
.oui-ml-0 {
  margin-left: 0px;
}
.oui-ml-1 {
  margin-left: 0.25rem;
}
.oui-ml-10 {
  margin-left: 2.5rem;
}
.oui-ml-2 {
  margin-left: 0.5rem;
}
.oui-ml-3 {
  margin-left: 0.75rem;
}
.oui-ml-4 {
  margin-left: 1rem;
}
.oui-ml-5 {
  margin-left: 1.25rem;
}
.oui-ml-6 {
  margin-left: 1.5rem;
}
.oui-ml-7 {
  margin-left: 1.75rem;
}
.oui-ml-8 {
  margin-left: 2rem;
}
.oui-ml-9 {
  margin-left: 2.25rem;
}
.oui-mr-0 {
  margin-right: 0px;
}
.oui-mr-1 {
  margin-right: 0.25rem;
}
.oui-mr-10 {
  margin-right: 2.5rem;
}
.oui-mr-2 {
  margin-right: 0.5rem;
}
.oui-mr-3 {
  margin-right: 0.75rem;
}
.oui-mr-4 {
  margin-right: 1rem;
}
.oui-mr-5 {
  margin-right: 1.25rem;
}
.oui-mr-6 {
  margin-right: 1.5rem;
}
.oui-mr-7 {
  margin-right: 1.75rem;
}
.oui-mr-8 {
  margin-right: 2rem;
}
.oui-mr-9 {
  margin-right: 2.25rem;
}
.oui-ms-0 {
  margin-inline-start: 0px;
}
.oui-ms-0\.5 {
  margin-inline-start: 0.125rem;
}
.oui-ms-1 {
  margin-inline-start: 0.25rem;
}
.oui-ms-2 {
  margin-inline-start: 0.5rem;
}
.oui-ms-2\.5 {
  margin-inline-start: 0.625rem;
}
.oui-ms-3 {
  margin-inline-start: 0.75rem;
}
.oui-ms-4 {
  margin-inline-start: 1rem;
}
.oui-ms-\[2px\] {
  margin-inline-start: 2px;
}
.oui-ms-\[5px\] {
  margin-inline-start: 5px;
}
.oui-ms-auto {
  margin-inline-start: auto;
}
.oui-ms-px {
  margin-inline-start: 1px;
}
.oui-mt-0 {
  margin-top: 0px;
}
.oui-mt-0\.5 {
  margin-top: 0.125rem;
}
.oui-mt-1 {
  margin-top: 0.25rem;
}
.oui-mt-10 {
  margin-top: 2.5rem;
}
.oui-mt-2 {
  margin-top: 0.5rem;
}
.oui-mt-2\.5 {
  margin-top: 0.625rem;
}
.oui-mt-3 {
  margin-top: 0.75rem;
}
.oui-mt-4 {
  margin-top: 1rem;
}
.oui-mt-5 {
  margin-top: 1.25rem;
}
.oui-mt-6 {
  margin-top: 1.5rem;
}
.oui-mt-7 {
  margin-top: 1.75rem;
}
.oui-mt-8 {
  margin-top: 2rem;
}
.oui-mt-9 {
  margin-top: 2.25rem;
}
.oui-mt-\[-1px\] {
  margin-top: -1px;
}
.oui-mt-\[-30px\] {
  margin-top: -30px;
}
.oui-mt-\[-8px\] {
  margin-top: -8px;
}
.oui-mt-\[2px\] {
  margin-top: 2px;
}
.oui-mt-\[35px\] {
  margin-top: 35px;
}
.oui-mt-\[6px\] {
  margin-top: 6px;
}
.oui-mt-\[7px\] {
  margin-top: 7px;
}
.oui-mt-\[9px\] {
  margin-top: 9px;
}
.oui-mt-\[clamp\(1\.5rem\,2vw\,2rem\)\] {
  margin-top: clamp(1.5rem, 2vw, 2rem);
}
.oui-mt-auto {
  margin-top: auto;
}
.oui-mt-px {
  margin-top: 1px;
}
.oui-box-border {
  box-sizing: border-box;
}
.oui-box-content {
  box-sizing: content-box;
}
.oui-line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.oui-line-clamp-5 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
}
.oui-block {
  display: block;
}
.oui-inline-block {
  display: inline-block;
}
.oui-flex {
  display: flex;
}
.oui-inline-flex {
  display: inline-flex;
}
.oui-grid {
  display: grid;
}
.oui-inline-grid {
  display: inline-grid;
}
.oui-list-item {
  display: list-item;
}
.oui-hidden {
  display: none;
}
.oui-aspect-square {
  aspect-ratio: 1 / 1;
}
.oui-size-1 {
  width: 0.25rem;
  height: 0.25rem;
}
.oui-size-10 {
  width: 2.5rem;
  height: 2.5rem;
}
.oui-size-11 {
  width: 2.75rem;
  height: 2.75rem;
}
.oui-size-12 {
  width: 3rem;
  height: 3rem;
}
.oui-size-2 {
  width: 0.5rem;
  height: 0.5rem;
}
.oui-size-3 {
  width: 0.75rem;
  height: 0.75rem;
}
.oui-size-4 {
  width: 1rem;
  height: 1rem;
}
.oui-size-5 {
  width: 1.25rem;
  height: 1.25rem;
}
.oui-size-6 {
  width: 1.5rem;
  height: 1.5rem;
}
.oui-size-8 {
  width: 2rem;
  height: 2rem;
}
.oui-size-\[10px\] {
  width: 10px;
  height: 10px;
}
.oui-size-\[12px\] {
  width: 12px;
  height: 12px;
}
.oui-size-\[140px\] {
  width: 140px;
  height: 140px;
}
.oui-size-\[14px\] {
  width: 14px;
  height: 14px;
}
.oui-size-\[15px\] {
  width: 15px;
  height: 15px;
}
.oui-size-\[16px\] {
  width: 16px;
  height: 16px;
}
.oui-size-\[18px\] {
  width: 18px;
  height: 18px;
}
.oui-size-\[20px\] {
  width: 20px;
  height: 20px;
}
.oui-size-\[335px\] {
  width: 335px;
  height: 335px;
}
.oui-size-\[48px\] {
  width: 48px;
  height: 48px;
}
.oui-size-\[4px\] {
  width: 4px;
  height: 4px;
}
.oui-size-\[64px\] {
  width: 64px;
  height: 64px;
}
.oui-size-\[6px\] {
  width: 6px;
  height: 6px;
}
.oui-size-full {
  width: 100%;
  height: 100%;
}
.\!oui-h-\[14px\] {
  height: 14px !important;
}
.\!oui-h-\[2px\] {
  height: 2px !important;
}
.\!oui-h-\[34px\] {
  height: 34px !important;
}
.\!oui-h-\[42px\] {
  height: 42px !important;
}
.\!oui-h-\[54px\] {
  height: 54px !important;
}
.\!oui-h-\[600px\] {
  height: 600px !important;
}
.\!oui-h-\[680px\] {
  height: 680px !important;
}
.\!oui-h-\[calc\(100\%_-_49px\)\] {
  height: calc(100% - 49px) !important;
}
.\!oui-h-\[calc\(100\%_-_53px_-_8px\)\] {
  height: calc(100% - 53px - 8px) !important;
}
.\!oui-h-auto {
  height: auto !important;
}
.oui-h-0 {
  height: 0px;
}
.oui-h-1 {
  height: 0.25rem;
}
.oui-h-1\.5 {
  height: 0.375rem;
}
.oui-h-10 {
  height: 2.5rem;
}
.oui-h-11 {
  height: 2.75rem;
}
.oui-h-12 {
  height: 3rem;
}
.oui-h-13 {
  height: 3.25rem;
}
.oui-h-2 {
  height: 0.5rem;
}
.oui-h-3 {
  height: 0.75rem;
}
.oui-h-3\.5 {
  height: 0.875rem;
}
.oui-h-4 {
  height: 1rem;
}
.oui-h-5 {
  height: 1.25rem;
}
.oui-h-6 {
  height: 1.5rem;
}
.oui-h-7 {
  height: 1.75rem;
}
.oui-h-8 {
  height: 2rem;
}
.oui-h-9 {
  height: 2.25rem;
}
.oui-h-\[100px\] {
  height: 100px;
}
.oui-h-\[10px\] {
  height: 10px;
}
.oui-h-\[110px\] {
  height: 110px;
}
.oui-h-\[112px\] {
  height: 112px;
}
.oui-h-\[114px\] {
  height: 114px;
}
.oui-h-\[120px\] {
  height: 120px;
}
.oui-h-\[124px\] {
  height: 124px;
}
.oui-h-\[12px\] {
  height: 12px;
}
.oui-h-\[13px\] {
  height: 13px;
}
.oui-h-\[14px\] {
  height: 14px;
}
.oui-h-\[152px\] {
  height: 152px;
}
.oui-h-\[15px\] {
  height: 15px;
}
.oui-h-\[160px\] {
  height: 160px;
}
.oui-h-\[168px\] {
  height: 168px;
}
.oui-h-\[16px\] {
  height: 16px;
}
.oui-h-\[170px\] {
  height: 170px;
}
.oui-h-\[188px\] {
  height: 188px;
}
.oui-h-\[18px\] {
  height: 18px;
}
.oui-h-\[197px\] {
  height: 197px;
}
.oui-h-\[19px\] {
  height: 19px;
}
.oui-h-\[1px\] {
  height: 1px;
}
.oui-h-\[200px\] {
  height: 200px;
}
.oui-h-\[20px\] {
  height: 20px;
}
.oui-h-\[22px\] {
  height: 22px;
}
.oui-h-\[236px\] {
  height: 236px;
}
.oui-h-\[238px\] {
  height: 238px;
}
.oui-h-\[23px\] {
  height: 23px;
}
.oui-h-\[240px\] {
  height: 240px;
}
.oui-h-\[24px\] {
  height: 24px;
}
.oui-h-\[256px\] {
  height: 256px;
}
.oui-h-\[25px\] {
  height: 25px;
}
.oui-h-\[26px\] {
  height: 26px;
}
.oui-h-\[276px\] {
  height: 276px;
}
.oui-h-\[28px\] {
  height: 28px;
}
.oui-h-\[2px\] {
  height: 2px;
}
.oui-h-\[300px\] {
  height: 300px;
}
.oui-h-\[308px\] {
  height: 308px;
}
.oui-h-\[30px\] {
  height: 30px;
}
.oui-h-\[31px\] {
  height: 31px;
}
.oui-h-\[320px\] {
  height: 320px;
}
.oui-h-\[32px\] {
  height: 32px;
}
.oui-h-\[34px\] {
  height: 34px;
}
.oui-h-\[360px\] {
  height: 360px;
}
.oui-h-\[36px\] {
  height: 36px;
}
.oui-h-\[38px\] {
  height: 38px;
}
.oui-h-\[400px\] {
  height: 400px;
}
.oui-h-\[40px\] {
  height: 40px;
}
.oui-h-\[41px\] {
  height: 41px;
}
.oui-h-\[42px\] {
  height: 42px;
}
.oui-h-\[435px\] {
  height: 435px;
}
.oui-h-\[44px\] {
  height: 44px;
}
.oui-h-\[45px\] {
  height: 45px;
}
.oui-h-\[46px\] {
  height: 46px;
}
.oui-h-\[48px\] {
  height: 48px;
}
.oui-h-\[496px\] {
  height: 496px;
}
.oui-h-\[4px\] {
  height: 4px;
}
.oui-h-\[500px\] {
  height: 500px;
}
.oui-h-\[50px\] {
  height: 50px;
}
.oui-h-\[52px\] {
  height: 52px;
}
.oui-h-\[53px\] {
  height: 53px;
}
.oui-h-\[54px\] {
  height: 54px;
}
.oui-h-\[55px\] {
  height: 55px;
}
.oui-h-\[59px\] {
  height: 59px;
}
.oui-h-\[634px\] {
  height: 634px;
}
.oui-h-\[64px\] {
  height: 64px;
}
.oui-h-\[68px\] {
  height: 68px;
}
.oui-h-\[6px\] {
  height: 6px;
}
.oui-h-\[78px\] {
  height: 78px;
}
.oui-h-\[8\.3px\] {
  height: 8.3px;
}
.oui-h-\[88px\] {
  height: 88px;
}
.oui-h-\[8px\] {
  height: 8px;
}
.oui-h-\[calc\(100\%_-_28px\)\] {
  height: calc(100% - 28px);
}
.oui-h-\[calc\(100\%_-_32px\)\] {
  height: calc(100% - 32px);
}
.oui-h-\[calc\(100\%_-_36px\)\] {
  height: calc(100% - 36px);
}
.oui-h-\[calc\(100\%_-_40px\)\] {
  height: calc(100% - 40px);
}
.oui-h-\[calc\(100\%_-_49px\)\] {
  height: calc(100% - 49px);
}
.oui-h-\[calc\(100\%_-_59px\)\] {
  height: calc(100% - 59px);
}
.oui-h-\[calc\(100\%_-_60px\)\] {
  height: calc(100% - 60px);
}
.oui-h-\[calc\(100\%_-_70px\)\] {
  height: calc(100% - 70px);
}
.oui-h-\[calc\(100\%_-_92px\)\] {
  height: calc(100% - 92px);
}
.oui-h-\[calc\(100vh-100px\)\] {
  height: calc(100vh - 100px);
}
.oui-h-\[calc\(100vh-200px\)\] {
  height: calc(100vh - 200px);
}
.oui-h-\[calc\(100vh-260px\)\] {
  height: calc(100vh - 260px);
}
.oui-h-\[calc\(100vh-80px\)\] {
  height: calc(100vh - 80px);
}
.oui-h-\[calc\(100vh_-_48px_-_29px\)\] {
  height: calc(100vh - 48px - 29px);
}
.oui-h-\[calc\(80vh_-_104px\)\] {
  height: calc(80vh - 104px);
}
.oui-h-\[calc\(80vh_-_132px_-_8px\)\] {
  height: calc(80vh - 132px - 8px);
}
.oui-h-\[env\(safe-area-inset-bottom\)\] {
  height: env(safe-area-inset-bottom);
}
.oui-h-\[var\(--radix-select-trigger-height\)\] {
  height: var(--radix-select-trigger-height);
}
.oui-h-auto {
  height: auto;
}
.oui-h-full {
  height: 100%;
}
.oui-h-px {
  height: 1px;
}
.oui-h-screen {
  height: 100vh;
}
.oui-max-h-0 {
  max-height: 0px;
}
.oui-max-h-8 {
  max-height: 2rem;
}
.oui-max-h-96 {
  max-height: 24rem;
}
.oui-max-h-\[100px\] {
  max-height: 100px;
}
.oui-max-h-\[104px\] {
  max-height: 104px;
}
.oui-max-h-\[119px\] {
  max-height: 119px;
}
.oui-max-h-\[120px\] {
  max-height: 120px;
}
.oui-max-h-\[1250px\] {
  max-height: 1250px;
}
.oui-max-h-\[144px\] {
  max-height: 144px;
}
.oui-max-h-\[200px\] {
  max-height: 200px;
}
.oui-max-h-\[202px\] {
  max-height: 202px;
}
.oui-max-h-\[205px\] {
  max-height: 205px;
}
.oui-max-h-\[240px\] {
  max-height: 240px;
}
.oui-max-h-\[254px\] {
  max-height: 254px;
}
.oui-max-h-\[288px\] {
  max-height: 288px;
}
.oui-max-h-\[348px\] {
  max-height: 348px;
}
.oui-max-h-\[356px\] {
  max-height: 356px;
}
.oui-max-h-\[396px\] {
  max-height: 396px;
}
.oui-max-h-\[400px\] {
  max-height: 400px;
}
.oui-max-h-\[60vh\] {
  max-height: 60vh;
}
.oui-max-h-\[700px\] {
  max-height: 700px;
}
.oui-max-h-\[70vh\] {
  max-height: 70vh;
}
.oui-max-h-\[80vh\] {
  max-height: 80vh;
}
.oui-max-h-full {
  max-height: 100%;
}
.\!oui-min-h-\[100px\] {
  min-height: 100px !important;
}
.\!oui-min-h-\[130px\] {
  min-height: 130px !important;
}
.\!oui-min-h-\[170px\] {
  min-height: 170px !important;
}
.\!oui-min-h-\[2px\] {
  min-height: 2px !important;
}
.oui-min-h-0 {
  min-height: 0px;
}
.oui-min-h-10 {
  min-height: 2.5rem;
}
.oui-min-h-11 {
  min-height: 2.75rem;
}
.oui-min-h-12 {
  min-height: 3rem;
}
.oui-min-h-40 {
  min-height: 10rem;
}
.oui-min-h-\[141px\] {
  min-height: 141px;
}
.oui-min-h-\[160px\] {
  min-height: 160px;
}
.oui-min-h-\[162px\] {
  min-height: 162px;
}
.oui-min-h-\[170px\] {
  min-height: 170px;
}
.oui-min-h-\[176px\] {
  min-height: 176px;
}
.oui-min-h-\[180px\] {
  min-height: 180px;
}
.oui-min-h-\[2\.4em\] {
  min-height: 2.4em;
}
.oui-min-h-\[20px\] {
  min-height: 20px;
}
.oui-min-h-\[300px\] {
  min-height: 300px;
}
.oui-min-h-\[400px\] {
  min-height: 400px;
}
.oui-min-h-\[420px\] {
  min-height: 420px;
}
.oui-min-h-\[48px\] {
  min-height: 48px;
}
.oui-min-h-\[4px\] {
  min-height: 4px;
}
.oui-min-h-\[50px\] {
  min-height: 50px;
}
.oui-min-h-\[56px\] {
  min-height: 56px;
}
.oui-min-h-\[600px\] {
  min-height: 600px;
}
.oui-min-h-\[calc\(100vh-44px\)\] {
  min-height: calc(100vh - 44px);
}
.oui-min-h-\[clamp\(6\.5rem\,15vw\,8\.25rem\)\] {
  min-height: clamp(6.5rem, 15vw, 8.25rem);
}
.oui-min-h-\[clamp\(6\.5rem\,8vw\,8\.25rem\)\] {
  min-height: clamp(6.5rem, 8vw, 8.25rem);
}
.oui-min-h-full {
  min-height: 100%;
}
.oui-min-h-screen {
  min-height: 100vh;
}
.\!oui-w-\[180px\] {
  width: 180px !important;
}
.\!oui-w-\[2px\] {
  width: 2px !important;
}
.\!oui-w-\[90\%\] {
  width: 90% !important;
}
.\!oui-w-full {
  width: 100% !important;
}
.oui-w-0 {
  width: 0px;
}
.oui-w-1 {
  width: 0.25rem;
}
.oui-w-1\/2 {
  width: 50%;
}
.oui-w-1\/3 {
  width: 33.333333%;
}
.oui-w-1\/4 {
  width: 25%;
}
.oui-w-1\/5 {
  width: 20%;
}
.oui-w-10 {
  width: 2.5rem;
}
.oui-w-11 {
  width: 2.75rem;
}
.oui-w-12 {
  width: 3rem;
}
.oui-w-2 {
  width: 0.5rem;
}
.oui-w-24 {
  width: 6rem;
}
.oui-w-28 {
  width: 7rem;
}
.oui-w-3 {
  width: 0.75rem;
}
.oui-w-3\.5 {
  width: 0.875rem;
}
.oui-w-3\/4 {
  width: 75%;
}
.oui-w-3\/5 {
  width: 60%;
}
.oui-w-4 {
  width: 1rem;
}
.oui-w-5 {
  width: 1.25rem;
}
.oui-w-6 {
  width: 1.5rem;
}
.oui-w-64 {
  width: 16rem;
}
.oui-w-7 {
  width: 1.75rem;
}
.oui-w-72 {
  width: 18rem;
}
.oui-w-8 {
  width: 2rem;
}
.oui-w-9 {
  width: 2.25rem;
}
.oui-w-\[--radix-select-content-available-width\] {
  width: var(--radix-select-content-available-width);
}
.oui-w-\[100\%\] {
  width: 100%;
}
.oui-w-\[10px\] {
  width: 10px;
}
.oui-w-\[120px\] {
  width: 120px;
}
.oui-w-\[124px\] {
  width: 124px;
}
.oui-w-\[12px\] {
  width: 12px;
}
.oui-w-\[13px\] {
  width: 13px;
}
.oui-w-\[140px\] {
  width: 140px;
}
.oui-w-\[148px\] {
  width: 148px;
}
.oui-w-\[14px\] {
  width: 14px;
}
.oui-w-\[154px\] {
  width: 154px;
}
.oui-w-\[15px\] {
  width: 15px;
}
.oui-w-\[162px\] {
  width: 162px;
}
.oui-w-\[16px\] {
  width: 16px;
}
.oui-w-\[180px\] {
  width: 180px;
}
.oui-w-\[184px\] {
  width: 184px;
}
.oui-w-\[187px\] {
  width: 187px;
}
.oui-w-\[18px\] {
  width: 18px;
}
.oui-w-\[190px\] {
  width: 190px;
}
.oui-w-\[1px\] {
  width: 1px;
}
.oui-w-\[200px\] {
  width: 200px;
}
.oui-w-\[20px\] {
  width: 20px;
}
.oui-w-\[225px\] {
  width: 225px;
}
.oui-w-\[230px\] {
  width: 230px;
}
.oui-w-\[240px\] {
  width: 240px;
}
.oui-w-\[256px\] {
  width: 256px;
}
.oui-w-\[260px\] {
  width: 260px;
}
.oui-w-\[275px\] {
  width: 275px;
}
.oui-w-\[276px\] {
  width: 276px;
}
.oui-w-\[280px\] {
  width: 280px;
}
.oui-w-\[284px\] {
  width: 284px;
}
.oui-w-\[28px\] {
  width: 28px;
}
.oui-w-\[2px\] {
  width: 2px;
}
.oui-w-\[300px\] {
  width: 300px;
}
.oui-w-\[320px\] {
  width: 320px;
}
.oui-w-\[32px\] {
  width: 32px;
}
.oui-w-\[342px\] {
  width: 342px;
}
.oui-w-\[360px\] {
  width: 360px;
}
.oui-w-\[368px\] {
  width: 368px;
}
.oui-w-\[36px\] {
  width: 36px;
}
.oui-w-\[378px\] {
  width: 378px;
}
.oui-w-\[420px\] {
  width: 420px;
}
.oui-w-\[456px\] {
  width: 456px;
}
.oui-w-\[45px\] {
  width: 45px;
}
.oui-w-\[49px\] {
  width: 49px;
}
.oui-w-\[50\%\] {
  width: 50%;
}
.oui-w-\[55px\] {
  width: 55px;
}
.oui-w-\[590px\] {
  width: 590px;
}
.oui-w-\[620px\] {
  width: 620px;
}
.oui-w-\[63px\] {
  width: 63px;
}
.oui-w-\[640px\] {
  width: 640px;
}
.oui-w-\[6px\] {
  width: 6px;
}
.oui-w-\[74px\] {
  width: 74px;
}
.oui-w-\[8\.3px\] {
  width: 8.3px;
}
.oui-w-\[80px\] {
  width: 80px;
}
.oui-w-\[85\%\] {
  width: 85%;
}
.oui-w-\[94px\] {
  width: 94px;
}
.oui-w-\[96px\] {
  width: 96px;
}
.oui-w-\[calc\(\(100\%_-_4px\)\/2\)\] {
  width: calc((100% - 4px) / 2);
}
.oui-w-\[calc\(100\%\+2\.5rem\)\] {
  width: calc(100% + 2.5rem);
}
.oui-w-\[calc\(100\%-60px\)\] {
  width: calc(100% - 60px);
}
.oui-w-\[calc\(100\%-64px\)\] {
  width: calc(100% - 64px);
}
.oui-w-\[calc\(100\%_-_16px\)\] {
  width: calc(100% - 16px);
}
.oui-w-\[calc\(100\%_-_280px_-_12px\)\] {
  width: calc(100% - 280px - 12px);
}
.oui-w-\[calc\(100vw-24px\)\] {
  width: calc(100vw - 24px);
}
.oui-w-\[calc\(50\%-6px\)\] {
  width: calc(50% - 6px);
}
.oui-w-\[var\(--radix-dropdown-menu-trigger-width\)\] {
  width: var(--radix-dropdown-menu-trigger-width);
}
.oui-w-\[var\(_--radix-popover-trigger-width\)\] {
  width: var( --radix-popover-trigger-width);
}
.oui-w-auto {
  width: auto;
}
.oui-w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.oui-w-full {
  width: 100%;
}
.oui-w-px {
  width: 1px;
}
.oui-w-screen {
  width: 100vw;
}
.\!oui-min-w-\[2px\] {
  min-width: 2px !important;
}
.oui-min-w-0 {
  min-width: 0px;
}
.oui-min-w-11 {
  min-width: 2.75rem;
}
.oui-min-w-14 {
  min-width: 3.5rem;
}
.oui-min-w-24 {
  min-width: 6rem;
}
.oui-min-w-6 {
  min-width: 1.5rem;
}
.oui-min-w-\[100px\] {
  min-width: 100px;
}
.oui-min-w-\[1018px\] {
  min-width: 1018px;
}
.oui-min-w-\[102px\] {
  min-width: 102px;
}
.oui-min-w-\[105px\] {
  min-width: 105px;
}
.oui-min-w-\[120px\] {
  min-width: 120px;
}
.oui-min-w-\[160px\] {
  min-width: 160px;
}
.oui-min-w-\[180px\] {
  min-width: 180px;
}
.oui-min-w-\[204px\] {
  min-width: 204px;
}
.oui-min-w-\[22px\] {
  min-width: 22px;
}
.oui-min-w-\[240px\] {
  min-width: 240px;
}
.oui-min-w-\[30px\] {
  min-width: 30px;
}
.oui-min-w-\[322px\] {
  min-width: 322px;
}
.oui-min-w-\[40px\] {
  min-width: 40px;
}
.oui-min-w-\[500px\] {
  min-width: 500px;
}
.oui-min-w-\[70px\] {
  min-width: 70px;
}
.oui-min-w-\[80px\] {
  min-width: 80px;
}
.oui-min-w-\[8rem\] {
  min-width: 8rem;
}
.oui-min-w-\[96px\] {
  min-width: 96px;
}
.oui-min-w-\[994px\] {
  min-width: 994px;
}
.oui-min-w-\[var\(--radix-select-trigger-width\)\] {
  min-width: var(--radix-select-trigger-width);
}
.\!oui-max-w-\[360px\] {
  max-width: 360px !important;
}
.\!oui-max-w-\[624px\] {
  max-width: 624px !important;
}
.\!oui-max-w-none {
  max-width: none !important;
}
.oui-max-w-4xl {
  max-width: 56rem;
}
.oui-max-w-64 {
  max-width: 16rem;
}
.oui-max-w-72 {
  max-width: 18rem;
}
.oui-max-w-\[110px\] {
  max-width: 110px;
}
.oui-max-w-\[1200px\] {
  max-width: 1200px;
}
.oui-max-w-\[188px\] {
  max-width: 188px;
}
.oui-max-w-\[200px\] {
  max-width: 200px;
}
.oui-max-w-\[240px\] {
  max-width: 240px;
}
.oui-max-w-\[244px\] {
  max-width: 244px;
}
.oui-max-w-\[260px\] {
  max-width: 260px;
}
.oui-max-w-\[270px\] {
  max-width: 270px;
}
.oui-max-w-\[274px\] {
  max-width: 274px;
}
.oui-max-w-\[275px\] {
  max-width: 275px;
}
.oui-max-w-\[280px\] {
  max-width: 280px;
}
.oui-max-w-\[298px\] {
  max-width: 298px;
}
.oui-max-w-\[300px\] {
  max-width: 300px;
}
.oui-max-w-\[320px\] {
  max-width: 320px;
}
.oui-max-w-\[330px\] {
  max-width: 330px;
}
.oui-max-w-\[348px\] {
  max-width: 348px;
}
.oui-max-w-\[34ch\] {
  max-width: 34ch;
}
.oui-max-w-\[360px\] {
  max-width: 360px;
}
.oui-max-w-\[382px\] {
  max-width: 382px;
}
.oui-max-w-\[396px\] {
  max-width: 396px;
}
.oui-max-w-\[400px\] {
  max-width: 400px;
}
.oui-max-w-\[450px\] {
  max-width: 450px;
}
.oui-max-w-\[726px\] {
  max-width: 726px;
}
.oui-max-w-\[83px\] {
  max-width: 83px;
}
.oui-max-w-\[960px\] {
  max-width: 960px;
}
.oui-max-w-\[992px\] {
  max-width: 992px;
}
.oui-max-w-\[calc\(100\%-187px\)\] {
  max-width: calc(100% - 187px);
}
.oui-max-w-fit {
  max-width: -moz-fit-content;
  max-width: fit-content;
}
.oui-max-w-full {
  max-width: 100%;
}
.oui-max-w-lg {
  max-width: var(--oui-spacing-lg, 30rem);
}
.oui-max-w-md {
  max-width: var(--oui-spacing-md, 26.25rem);
}
.oui-max-w-sm {
  max-width: var(--oui-spacing-sm, 22.5rem);
}
.oui-max-w-xl {
  max-width: var(--oui-spacing-xl, 33.75rem);
}
.oui-max-w-xs {
  max-width: var(--oui-spacing-xs, 20rem);
}
.oui-flex-1 {
  flex: 1 1 0%;
}
.oui-flex-none {
  flex: none;
}
.oui-flex-shrink {
  flex-shrink: 1;
}
.oui-flex-shrink-0 {
  flex-shrink: 0;
}
.oui-shrink {
  flex-shrink: 1;
}
.oui-shrink-0 {
  flex-shrink: 0;
}
.oui-grow {
  flex-grow: 1;
}
.oui-grow-0 {
  flex-grow: 0;
}
.oui-basis-1\/2 {
  flex-basis: 50%;
}
.oui-basis-5\/12 {
  flex-basis: 41.666667%;
}
.oui-basis-7\/12 {
  flex-basis: 58.333333%;
}
.oui-basis-\[100\%\] {
  flex-basis: 100%;
}
.oui-basis-auto {
  flex-basis: auto;
}
.oui-basis-full {
  flex-basis: 100%;
}
.oui-table-fixed {
  table-layout: fixed;
}
.oui-border-collapse {
  border-collapse: collapse;
}
.oui-origin-top-left {
  transform-origin: top left;
}
.-oui-translate-x-1\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-oui-translate-y-1\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-oui-translate-y-2\/4 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-oui-translate-y-\[0\.5px\] {
  --tw-translate-y: -0.5px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui--translate-x-1\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui--translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui--translate-y-1\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui-translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui-translate-x-3 {
  --tw-translate-x: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui-translate-x-\[-12px\] {
  --tw-translate-x: -12px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui-translate-x-\[-50\%\] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui-translate-y-1 {
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui-translate-y-3 {
  --tw-translate-y: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui-translate-y-\[-50\%\] {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui-translate-y-\[10px\] {
  --tw-translate-y: 10px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui-translate-y-\[120\%\] {
  --tw-translate-y: 120%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-oui-rotate-180 {
  --tw-rotate: -180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-oui-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui-rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui-rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui-rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui-scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui-scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui-transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui-transform-gpu {
  transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), 0) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes oui-pop {

  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.05);
  }
}
.oui-animate-pop {
  animation: oui-pop 0.2s ease-out;
}
@keyframes oui-rotate {

  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(240deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
.oui-animate-rotate-360 {
  animation: oui-rotate 1s linear infinite;
}
@keyframes oui-scan-qr-code {

  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(320px);
  }

  100% {
    transform: translateY(0);
  }
}
.oui-animate-scan-qr-code {
  animation: oui-scan-qr-code 6s infinite linear;
}
@keyframes oui-spin {

  to {
    transform: rotate(360deg);
  }
}
.oui-animate-spin {
  animation: oui-spin 1s linear infinite;
}
.oui-cursor-auto {
  cursor: auto;
}
.oui-cursor-default {
  cursor: default;
}
.oui-cursor-grab {
  cursor: grab;
}
.oui-cursor-grabbing {
  cursor: grabbing;
}
.oui-cursor-help {
  cursor: help;
}
.oui-cursor-move {
  cursor: move;
}
.oui-cursor-not-allowed {
  cursor: not-allowed;
}
.oui-cursor-pointer {
  cursor: pointer;
}
.oui-cursor-svg-edit {
  cursor: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2214%22%20height%3D%2214%22%20viewBox%3D%220%200%2014%2014%22%20fill%3D%22none%22%3E%3Cg%20clip-path%3D%22url%28%23clip0_22040_41827%29%22%3E%3Cpath%20d%3D%22M11.4548%200.693201C11.1139%200.352266%2010.5611%200.352266%2010.2202%200.693201L8.98558%201.92784L12.0722%205.01442L13.3068%203.77979C13.6477%203.43885%2013.6477%202.88609%2013.3068%202.54515L11.4548%200.693201Z%22%20fill%3D%22white%22%20fill-opacity%3D%220.98%22%2F%3E%3Cpath%20d%3D%22M11.1462%205.9404L8.0596%202.85381L0.960453%209.95296L0.443602%2013.0541C0.394363%2013.3495%200.650496%2013.6056%200.945935%2013.5564L4.04704%2013.0395L11.1462%205.9404Z%22%20fill%3D%22white%22%20fill-opacity%3D%220.98%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_22040_41827%22%3E%3Crect%20width%3D%2214%22%20height%3D%2214%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E") 2 12, auto;
}
.oui-touch-none {
  touch-action: none;
}
.oui-select-none {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.oui-resize-none {
  resize: none;
}
.oui-list-inside {
  list-style-position: inside;
}
.oui-list-outside {
  list-style-position: outside;
}
.oui-list-decimal {
  list-style-type: decimal;
}
.oui-list-disc {
  list-style-type: disc;
}
.oui-list-none {
  list-style-type: none;
}
.oui-grid-flow-row {
  grid-auto-flow: row;
}
.oui-grid-flow-col {
  grid-auto-flow: column;
}
.oui-grid-flow-row-dense {
  grid-auto-flow: row dense;
}
.oui-grid-flow-col-dense {
  grid-auto-flow: column dense;
}
.oui-auto-rows-fr {
  grid-auto-rows: minmax(0, 1fr);
}
.oui-grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.oui-grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.oui-grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.oui-grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.oui-grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.oui-grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.oui-grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.oui-grid-cols-8 {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}
.oui-grid-cols-9 {
  grid-template-columns: repeat(9, minmax(0, 1fr));
}
.oui-grid-cols-\[1fr\,1fr\,135px\] {
  grid-template-columns: 1fr 1fr 135px;
}
.oui-grid-cols-\[2fr_1fr_1fr_1fr_1fr_1fr_1\.5fr\] {
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr 1fr 1.5fr;
}
.oui-grid-cols-\[40px_1fr_40px\] {
  grid-template-columns: 40px 1fr 40px;
}
.oui-grid-cols-\[4fr\,6fr\] {
  grid-template-columns: 4fr 6fr;
}
.oui-grid-cols-\[6fr\,4fr\] {
  grid-template-columns: 6fr 4fr;
}
.oui-grid-cols-\[minmax\(0\,1fr\)_96px_72px\] {
  grid-template-columns: minmax(0,1fr) 96px 72px;
}
.oui-grid-cols-none {
  grid-template-columns: none;
}
.oui-grid-rows-1 {
  grid-template-rows: repeat(1, minmax(0, 1fr));
}
.oui-grid-rows-2 {
  grid-template-rows: repeat(2, minmax(0, 1fr));
}
.oui-grid-rows-3 {
  grid-template-rows: repeat(3, minmax(0, 1fr));
}
.oui-grid-rows-4 {
  grid-template-rows: repeat(4, minmax(0, 1fr));
}
.oui-grid-rows-5 {
  grid-template-rows: repeat(5, minmax(0, 1fr));
}
.oui-grid-rows-6 {
  grid-template-rows: repeat(6, minmax(0, 1fr));
}
.oui-grid-rows-7 {
  grid-template-rows: repeat(7, minmax(0, 1fr));
}
.oui-grid-rows-8 {
  grid-template-rows: repeat(8, minmax(0, 1fr));
}
.oui-grid-rows-9 {
  grid-template-rows: repeat(9, minmax(0, 1fr));
}
.oui-grid-rows-\[auto\,1fr\] {
  grid-template-rows: auto 1fr;
}
.oui-grid-rows-\[auto\,auto\,1fr\,auto\,1fr\,auto\] {
  grid-template-rows: auto auto 1fr auto 1fr auto;
}
.oui-grid-rows-\[auto\,auto\,1fr\,auto\,1fr\] {
  grid-template-rows: auto auto 1fr auto 1fr;
}
.oui-grid-rows-\[auto_minmax\(0\,1fr\)\] {
  grid-template-rows: auto minmax(0,1fr);
}
.oui-grid-rows-none {
  grid-template-rows: none;
}
.oui-flex-row {
  flex-direction: row;
}
.oui-flex-row-reverse {
  flex-direction: row-reverse;
}
.oui-flex-col {
  flex-direction: column;
}
.oui-flex-col-reverse {
  flex-direction: column-reverse;
}
.oui-flex-wrap {
  flex-wrap: wrap;
}
.oui-flex-wrap-reverse {
  flex-wrap: wrap-reverse;
}
.oui-flex-nowrap {
  flex-wrap: nowrap;
}
.oui-items-start {
  align-items: flex-start;
}
.oui-items-end {
  align-items: flex-end;
}
.oui-items-center {
  align-items: center;
}
.oui-items-baseline {
  align-items: baseline;
}
.oui-items-stretch {
  align-items: stretch;
}
.oui-justify-start {
  justify-content: flex-start;
}
.oui-justify-end {
  justify-content: flex-end;
}
.oui-justify-center {
  justify-content: center;
}
.oui-justify-between {
  justify-content: space-between;
}
.oui-justify-around {
  justify-content: space-around;
}
.oui-justify-evenly {
  justify-content: space-evenly;
}
.oui-justify-stretch {
  justify-content: stretch;
}
.\!oui-gap-\[2px\] {
  gap: 2px !important;
}
.oui-gap-0 {
  gap: 0px;
}
.oui-gap-0\.5 {
  gap: 0.125rem;
}
.oui-gap-1 {
  gap: 0.25rem;
}
.oui-gap-1\.5 {
  gap: 0.375rem;
}
.oui-gap-10 {
  gap: 2.5rem;
}
.oui-gap-12 {
  gap: 3rem;
}
.oui-gap-2 {
  gap: 0.5rem;
}
.oui-gap-2\.5 {
  gap: 0.625rem;
}
.oui-gap-3 {
  gap: 0.75rem;
}
.oui-gap-4 {
  gap: 1rem;
}
.oui-gap-5 {
  gap: 1.25rem;
}
.oui-gap-6 {
  gap: 1.5rem;
}
.oui-gap-8 {
  gap: 2rem;
}
.oui-gap-\[10px\] {
  gap: 10px;
}
.oui-gap-\[11px\] {
  gap: 11px;
}
.oui-gap-\[2px\] {
  gap: 2px;
}
.oui-gap-\[6px\] {
  gap: 6px;
}
.oui-gap-\[clamp\(0\.375rem\,2vw\,1rem\)\] {
  gap: clamp(0.375rem, 2vw, 1rem);
}
.oui-gap-px {
  gap: 1px;
}
.oui-gap-x-0 {
  -moz-column-gap: 0px;
       column-gap: 0px;
}
.oui-gap-x-0\.5 {
  -moz-column-gap: 0.125rem;
       column-gap: 0.125rem;
}
.oui-gap-x-1 {
  -moz-column-gap: 0.25rem;
       column-gap: 0.25rem;
}
.oui-gap-x-10 {
  -moz-column-gap: 2.5rem;
       column-gap: 2.5rem;
}
.oui-gap-x-2 {
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem;
}
.oui-gap-x-3 {
  -moz-column-gap: 0.75rem;
       column-gap: 0.75rem;
}
.oui-gap-x-4 {
  -moz-column-gap: 1rem;
       column-gap: 1rem;
}
.oui-gap-x-5 {
  -moz-column-gap: 1.25rem;
       column-gap: 1.25rem;
}
.oui-gap-x-6 {
  -moz-column-gap: 1.5rem;
       column-gap: 1.5rem;
}
.oui-gap-x-7 {
  -moz-column-gap: 1.75rem;
       column-gap: 1.75rem;
}
.oui-gap-x-8 {
  -moz-column-gap: 2rem;
       column-gap: 2rem;
}
.oui-gap-x-\[1px\] {
  -moz-column-gap: 1px;
       column-gap: 1px;
}
.oui-gap-x-\[30px\] {
  -moz-column-gap: 30px;
       column-gap: 30px;
}
.oui-gap-x-\[6px\] {
  -moz-column-gap: 6px;
       column-gap: 6px;
}
.oui-gap-x-px {
  -moz-column-gap: 1px;
       column-gap: 1px;
}
.oui-gap-y-0 {
  row-gap: 0px;
}
.oui-gap-y-1 {
  row-gap: 0.25rem;
}
.oui-gap-y-10 {
  row-gap: 2.5rem;
}
.oui-gap-y-2 {
  row-gap: 0.5rem;
}
.oui-gap-y-3 {
  row-gap: 0.75rem;
}
.oui-gap-y-4 {
  row-gap: 1rem;
}
.oui-gap-y-5 {
  row-gap: 1.25rem;
}
.oui-gap-y-6 {
  row-gap: 1.5rem;
}
.oui-gap-y-8 {
  row-gap: 2rem;
}
.oui-gap-y-\[2px\] {
  row-gap: 2px;
}
.\!oui-space-y-0 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(0px * var(--tw-space-y-reverse)) !important;
}
.\!oui-space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse)) !important;
}
.oui-space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.oui-space-x-\[6px\] > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(6px * var(--tw-space-x-reverse));
  margin-left: calc(6px * calc(1 - var(--tw-space-x-reverse)));
}
.oui-space-y-0 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.oui-space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.oui-space-y-1\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.oui-space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.oui-space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.oui-space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.oui-space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.oui-space-y-\[2px\] > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2px * var(--tw-space-y-reverse));
}
.oui-self-end {
  align-self: flex-end;
}
.oui-overflow-auto {
  overflow: auto;
}
.oui-overflow-hidden {
  overflow: hidden;
}
.oui-overflow-x-auto {
  overflow-x: auto;
}
.oui-overflow-y-auto {
  overflow-y: auto;
}
.oui-overflow-y-hidden {
  overflow-y: hidden;
}
.oui-overflow-y-visible {
  overflow-y: visible;
}
.oui-overflow-x-scroll {
  overflow-x: scroll;
}
.oui-overflow-y-scroll {
  overflow-y: scroll;
}
.oui-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.oui-overflow-ellipsis {
  text-overflow: ellipsis;
}
.oui-text-ellipsis {
  text-overflow: ellipsis;
}
.\!oui-whitespace-normal {
  white-space: normal !important;
}
.oui-whitespace-normal {
  white-space: normal;
}
.oui-whitespace-nowrap {
  white-space: nowrap;
}
.oui-whitespace-pre {
  white-space: pre;
}
.oui-text-nowrap {
  text-wrap: nowrap;
}
.oui-text-pretty {
  text-wrap: pretty;
}
.oui-break-normal {
  overflow-wrap: normal;
  word-break: normal;
}
.oui-break-words {
  overflow-wrap: break-word;
}
.oui-break-all {
  word-break: break-all;
}
.\!oui-rounded {
  border-radius: var(--oui-rounded, 0.25rem) !important;
}
.\!oui-rounded-md {
  border-radius: var(--oui-rounded-md, 0.375rem) !important;
}
.oui-rounded {
  border-radius: var(--oui-rounded, 0.25rem);
}
.oui-rounded-2xl {
  border-radius: var(--oui-rounded-2xl, 1rem);
}
.oui-rounded-\[100\%\] {
  border-radius: 100%;
}
.oui-rounded-\[100px\] {
  border-radius: 100px;
}
.oui-rounded-\[10px\] {
  border-radius: 10px;
}
.oui-rounded-\[12px\] {
  border-radius: 12px;
}
.oui-rounded-\[14px\] {
  border-radius: 14px;
}
.oui-rounded-\[16px\] {
  border-radius: 16px;
}
.oui-rounded-\[1px\] {
  border-radius: 1px;
}
.oui-rounded-\[24px\] {
  border-radius: 24px;
}
.oui-rounded-\[2px\] {
  border-radius: 2px;
}
.oui-rounded-\[3px\] {
  border-radius: 3px;
}
.oui-rounded-\[44px\] {
  border-radius: 44px;
}
.oui-rounded-\[4px\] {
  border-radius: 4px;
}
.oui-rounded-\[6px\] {
  border-radius: 6px;
}
.oui-rounded-\[8px\] {
  border-radius: 8px;
}
.oui-rounded-\[inherit\] {
  border-radius: inherit;
}
.oui-rounded-full {
  border-radius: var(--oui-rounded-full, 9999px);
}
.oui-rounded-lg {
  border-radius: var(--oui-rounded-lg, 0.5rem);
}
.oui-rounded-md {
  border-radius: var(--oui-rounded-md, 0.375rem);
}
.oui-rounded-none {
  border-radius: 0;
}
.oui-rounded-sm {
  border-radius: var(--oui-rounded-sm, 0.125rem);
}
.oui-rounded-xl {
  border-radius: var(--oui-rounded-xl, 0.75rem);
}
.\!oui-rounded-b-xl {
  border-bottom-right-radius: var(--oui-rounded-xl, 0.75rem) !important;
  border-bottom-left-radius: var(--oui-rounded-xl, 0.75rem) !important;
}
.\!oui-rounded-t-xl {
  border-top-left-radius: var(--oui-rounded-xl, 0.75rem) !important;
  border-top-right-radius: var(--oui-rounded-xl, 0.75rem) !important;
}
.oui-rounded-b-2xl {
  border-bottom-right-radius: var(--oui-rounded-2xl, 1rem);
  border-bottom-left-radius: var(--oui-rounded-2xl, 1rem);
}
.oui-rounded-b-sm {
  border-bottom-right-radius: var(--oui-rounded-sm, 0.125rem);
  border-bottom-left-radius: var(--oui-rounded-sm, 0.125rem);
}
.oui-rounded-b-xl {
  border-bottom-right-radius: var(--oui-rounded-xl, 0.75rem);
  border-bottom-left-radius: var(--oui-rounded-xl, 0.75rem);
}
.oui-rounded-e {
  border-start-end-radius: var(--oui-rounded, 0.25rem);
  border-end-end-radius: var(--oui-rounded, 0.25rem);
}
.oui-rounded-e-full {
  border-start-end-radius: var(--oui-rounded-full, 9999px);
  border-end-end-radius: var(--oui-rounded-full, 9999px);
}
.oui-rounded-e-lg {
  border-start-end-radius: var(--oui-rounded-lg, 0.5rem);
  border-end-end-radius: var(--oui-rounded-lg, 0.5rem);
}
.oui-rounded-l {
  border-top-left-radius: var(--oui-rounded, 0.25rem);
  border-bottom-left-radius: var(--oui-rounded, 0.25rem);
}
.oui-rounded-r {
  border-top-right-radius: var(--oui-rounded, 0.25rem);
  border-bottom-right-radius: var(--oui-rounded, 0.25rem);
}
.oui-rounded-s {
  border-start-start-radius: var(--oui-rounded, 0.25rem);
  border-end-start-radius: var(--oui-rounded, 0.25rem);
}
.oui-rounded-s-full {
  border-start-start-radius: var(--oui-rounded-full, 9999px);
  border-end-start-radius: var(--oui-rounded-full, 9999px);
}
.oui-rounded-s-lg {
  border-start-start-radius: var(--oui-rounded-lg, 0.5rem);
  border-end-start-radius: var(--oui-rounded-lg, 0.5rem);
}
.oui-rounded-t-2xl {
  border-top-left-radius: var(--oui-rounded-2xl, 1rem);
  border-top-right-radius: var(--oui-rounded-2xl, 1rem);
}
.oui-rounded-t-\[6px\] {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.oui-rounded-t-sm {
  border-top-left-radius: var(--oui-rounded-sm, 0.125rem);
  border-top-right-radius: var(--oui-rounded-sm, 0.125rem);
}
.oui-rounded-t-xl {
  border-top-left-radius: var(--oui-rounded-xl, 0.75rem);
  border-top-right-radius: var(--oui-rounded-xl, 0.75rem);
}
.oui-rounded-bl-\[10px\] {
  border-bottom-left-radius: 10px;
}
.oui-rounded-bl-\[6px\] {
  border-bottom-left-radius: 6px;
}
.oui-rounded-bl-md {
  border-bottom-left-radius: var(--oui-rounded-md, 0.375rem);
}
.oui-rounded-br-\[3px\] {
  border-bottom-right-radius: 3px;
}
.oui-rounded-br-lg {
  border-bottom-right-radius: var(--oui-rounded-lg, 0.5rem);
}
.oui-rounded-ee-none {
  border-end-end-radius: 0;
}
.oui-rounded-es {
  border-end-start-radius: var(--oui-rounded, 0.25rem);
}
.oui-rounded-ss {
  border-start-start-radius: var(--oui-rounded, 0.25rem);
}
.oui-rounded-ss-none {
  border-start-start-radius: 0;
}
.oui-rounded-tl-\[10px\] {
  border-top-left-radius: 10px;
}
.oui-rounded-tr-\[10px\] {
  border-top-right-radius: 10px;
}
.oui-rounded-tr-md {
  border-top-right-radius: var(--oui-rounded-md, 0.375rem);
}
.\!oui-border {
  border-width: 1px !important;
}
.oui-border {
  border-width: 1px;
}
.oui-border-0 {
  border-width: 0px;
}
.oui-border-4 {
  border-width: 4px;
}
.oui-border-8 {
  border-width: 8px;
}
.oui-border-\[0\.5px\] {
  border-width: 0.5px;
}
.oui-border-\[2\.5px\] {
  border-width: 2.5px;
}
.oui-border-\[2px\] {
  border-width: 2px;
}
.oui-border-\[4px\] {
  border-width: 4px;
}
.oui-border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.oui-border-y-2 {
  border-top-width: 2px;
  border-bottom-width: 2px;
}
.oui-border-b {
  border-bottom-width: 1px;
}
.oui-border-b-2 {
  border-bottom-width: 2px;
}
.oui-border-e {
  border-inline-end-width: 1px;
}
.oui-border-s {
  border-inline-start-width: 1px;
}
.oui-border-t {
  border-top-width: 1px;
}
.oui-border-t-2 {
  border-top-width: 2px;
}
.\!oui-border-solid {
  border-style: solid !important;
}
.oui-border-solid {
  border-style: solid;
}
.oui-border-dashed {
  border-style: dashed;
}
.oui-border-dotted {
  border-style: dotted;
}
.\!oui-border-none {
  border-style: none !important;
}
.oui-border-none {
  border-style: none;
}
.\!oui-border-line-12 {
  border-color: rgb(var(--oui-color-line, 255 255 255) / 0.12) !important;
}
.\!oui-border-primary-light {
  --tw-border-opacity: 1 !important;
  border-color: rgb(var(--oui-color-primary-light) / var(--tw-border-opacity, 1)) !important;
}
.oui-border-\[\#d9d9d9\] {
  --tw-border-opacity: 1;
  border-color: rgb(217 217 217 / var(--tw-border-opacity, 1));
}
.oui-border-\[rgb\(var\(--oui-gradient-brand-start\)\)\] {
  border-color: rgb(var(--oui-gradient-brand-start));
}
.oui-border-\[rgba\(var\(--oui-gradient-brand-start\)\)\] {
  border-color: rgba(var(--oui-gradient-brand-start));
}
.oui-border-\[rgba\(var\(--oui-gradient-primary-start\)\/0\.36\)\] {
  border-color: rgba(var(--oui-gradient-primary-start)/0.36);
}
.oui-border-\[rgba\(var\(--oui-gradient-secondary-start\)\/0\.36\)\] {
  border-color: rgba(var(--oui-gradient-secondary-start)/0.36);
}
.oui-border-\[rgba\(var\(--oui-gradient-success-start\)\/0\.36\)\] {
  border-color: rgba(var(--oui-gradient-success-start)/0.36);
}
.oui-border-base-2 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--oui-color-base-2) / var(--tw-border-opacity, 1));
}
.oui-border-base-4 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--oui-color-base-4) / var(--tw-border-opacity, 1));
}
.oui-border-base-5 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--oui-color-base-5) / var(--tw-border-opacity, 1));
}
.oui-border-base-6 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--oui-color-base-6) / var(--tw-border-opacity, 1));
}
.oui-border-base-contrast-12 {
  border-color: rgb(var(--oui-color-base-foreground) / 0.12);
}
.oui-border-base-contrast-20 {
  border-color: rgb(var(--oui-color-base-foreground) / 0.2);
}
.oui-border-base-contrast-36 {
  border-color: rgb(var(--oui-color-base-foreground) / 0.36);
}
.oui-border-base-contrast-54 {
  border-color: rgb(var(--oui-color-base-foreground) / 0.54);
}
.oui-border-base-contrast-80 {
  border-color: rgb(var(--oui-color-base-foreground) / 0.80);
}
.oui-border-base-contrast\/10 {
  border-color: rgb(var(--oui-color-base-foreground) / 0.1);
}
.oui-border-base-contrast\/\[0\.08\] {
  border-color: rgb(var(--oui-color-base-foreground) / 0.08);
}
.oui-border-base-contrast\/\[0\.12\] {
  border-color: rgb(var(--oui-color-base-foreground) / 0.12);
}
.oui-border-base-static-contrast-20 {
  border-color: rgb(var(--oui-color-base-static-contrast) / 0.2);
}
.oui-border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.oui-border-danger {
  --tw-border-opacity: 1;
  border-color: rgb(var(--oui-color-danger) / var(--tw-border-opacity, 1));
}
.oui-border-line {
  border-color: rgb(var(--oui-color-line, 255 255 255) / 0.08);
}
.oui-border-line-10 {
  border-color: rgb(var(--oui-color-line, 255 255 255) / 0.10);
}
.oui-border-line-12 {
  border-color: rgb(var(--oui-color-line, 255 255 255) / 0.12);
}
.oui-border-line-16 {
  border-color: rgb(var(--oui-color-line, 255 255 255) / 0.16);
}
.oui-border-line-4 {
  border-color: rgb(var(--oui-color-line, 255 255 255) / 0.04);
}
.oui-border-line-6 {
  border-color: rgb(var(--oui-color-line, 255 255 255) / 0.06);
}
.oui-border-link-light {
  --tw-border-opacity: 1;
  border-color: rgb(var(--oui-color-link-light) / var(--tw-border-opacity, 1));
}
.oui-border-primary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--oui-color-primary) / var(--tw-border-opacity, 1));
}
.oui-border-primary-darken {
  --tw-border-opacity: 1;
  border-color: rgb(var(--oui-color-primary-darken) / var(--tw-border-opacity, 1));
}
.oui-border-primary-light {
  --tw-border-opacity: 1;
  border-color: rgb(var(--oui-color-primary-light) / var(--tw-border-opacity, 1));
}
.oui-border-success {
  --tw-border-opacity: 1;
  border-color: rgb(var(--oui-color-success) / var(--tw-border-opacity, 1));
}
.oui-border-trade-loss {
  --tw-border-opacity: 1;
  border-color: rgb(var(--oui-color-trading-loss) / var(--tw-border-opacity, 1));
}
.oui-border-trade-profit {
  --tw-border-opacity: 1;
  border-color: rgb(var(--oui-color-trading-profit) / var(--tw-border-opacity, 1));
}
.oui-border-transparent {
  border-color: transparent;
}
.oui-border-warning-darken {
  --tw-border-opacity: 1;
  border-color: rgb(var(--oui-color-warning-darken) / var(--tw-border-opacity, 1));
}
.oui-border-b-line-4 {
  border-bottom-color: rgb(var(--oui-color-line, 255 255 255) / 0.04);
}
.oui-border-b-line-6 {
  border-bottom-color: rgb(var(--oui-color-line, 255 255 255) / 0.06);
}
.oui-border-b-transparent {
  border-bottom-color: transparent;
}
.oui-border-b-white\/10 {
  border-bottom-color: rgb(255 255 255 / 0.1);
}
.oui-border-e-line-16 {
  border-inline-end-color: rgb(var(--oui-color-line, 255 255 255) / 0.16);
}
.oui-border-s-transparent {
  border-inline-start-color: transparent;
}
.oui-border-t-transparent {
  border-top-color: transparent;
}
.\!oui-bg-base-10\/60 {
  background-color: rgb(var(--oui-color-base-10) / 0.6) !important;
}
.\!oui-bg-base-8 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(var(--oui-color-base-8) / var(--tw-bg-opacity, 1)) !important;
}
.\!oui-bg-base-9 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(var(--oui-color-base-9) / var(--tw-bg-opacity, 1)) !important;
}
.\!oui-bg-black\/10 {
  background-color: rgb(0 0 0 / 0.1) !important;
}
.\!oui-bg-primary-darken {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(var(--oui-color-primary-darken) / var(--tw-bg-opacity, 1)) !important;
}
.\!oui-bg-transparent {
  background-color: transparent !important;
}
.oui-bg-\[\#00A858\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 168 88 / var(--tw-bg-opacity, 1));
}
.oui-bg-\[\#07080A\] {
  --tw-bg-opacity: 1;
  background-color: rgb(7 8 10 / var(--tw-bg-opacity, 1));
}
.oui-bg-\[\#283BEE\] {
  --tw-bg-opacity: 1;
  background-color: rgb(40 59 238 / var(--tw-bg-opacity, 1));
}
.oui-bg-\[\#333948\] {
  --tw-bg-opacity: 1;
  background-color: rgb(51 57 72 / var(--tw-bg-opacity, 1));
}
.oui-bg-\[\#335FFC\] {
  --tw-bg-opacity: 1;
  background-color: rgb(51 95 252 / var(--tw-bg-opacity, 1));
}
.oui-bg-\[\#3D79A9\] {
  --tw-bg-opacity: 1;
  background-color: rgb(61 121 169 / var(--tw-bg-opacity, 1));
}
.oui-bg-\[\#630EAD\] {
  --tw-bg-opacity: 1;
  background-color: rgb(99 14 173 / var(--tw-bg-opacity, 1));
}
.oui-bg-\[\#d9d9d9\] {
  --tw-bg-opacity: 1;
  background-color: rgb(217 217 217 / var(--tw-bg-opacity, 1));
}
.oui-bg-\[\#e9e9eb\] {
  --tw-bg-opacity: 1;
  background-color: rgb(233 233 235 / var(--tw-bg-opacity, 1));
}
.oui-bg-\[lightgray\] {
  --tw-bg-opacity: 1;
  background-color: rgb(211 211 211 / var(--tw-bg-opacity, 1));
}
.oui-bg-\[rgb\(var\(--oui-color-primary-light\)\/0\.06\)\] {
  background-color: rgb(var(--oui-color-primary-light)/0.06);
}
.oui-bg-\[rgb\(var\(--oui-color-warning-darken\)_\/_0\.1\)\] {
  background-color: rgb(var(--oui-color-warning-darken) / 0.1);
}
.oui-bg-\[rgb\(var\(--oui-gradient-brand-start\)\)\] {
  background-color: rgb(var(--oui-gradient-brand-start));
}
.oui-bg-\[rgba\(0\,0\,0\,0\.48\)\] {
  background-color: rgba(0,0,0,0.48);
}
.oui-bg-\[rgba\(var\(--oui-color-warning-darken\)\/0\.15\)\] {
  background-color: rgba(var(--oui-color-warning-darken)/0.15);
}
.oui-bg-\[rgba\(var\(--oui-gradient-brand-start\)\)\] {
  background-color: rgba(var(--oui-gradient-brand-start));
}
.oui-bg-\[var\(--oui-table-background-color\)\] {
  background-color: var(--oui-table-background-color);
}
.oui-bg-base-1 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-1) / var(--tw-bg-opacity, 1));
}
.oui-bg-base-10 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-10) / var(--tw-bg-opacity, 1));
}
.oui-bg-base-2 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-2) / var(--tw-bg-opacity, 1));
}
.oui-bg-base-3 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-3) / var(--tw-bg-opacity, 1));
}
.oui-bg-base-4 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-4) / var(--tw-bg-opacity, 1));
}
.oui-bg-base-5 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-5) / var(--tw-bg-opacity, 1));
}
.oui-bg-base-6 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-6) / var(--tw-bg-opacity, 1));
}
.oui-bg-base-7 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-7) / var(--tw-bg-opacity, 1));
}
.oui-bg-base-8 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-8) / var(--tw-bg-opacity, 1));
}
.oui-bg-base-8\/70 {
  background-color: rgb(var(--oui-color-base-8) / 0.7);
}
.oui-bg-base-9 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-9) / var(--tw-bg-opacity, 1));
}
.oui-bg-base-contrast {
  background-color: rgb(var(--oui-color-base-foreground) / 0.98);
}
.oui-bg-base-contrast-12 {
  background-color: rgb(var(--oui-color-base-foreground) / 0.12);
}
.oui-bg-base-contrast-16 {
  background-color: rgb(var(--oui-color-base-foreground) / 0.16);
}
.oui-bg-base-contrast-20 {
  background-color: rgb(var(--oui-color-base-foreground) / 0.2);
}
.oui-bg-base-contrast-30 {
  background-color: rgb(var(--oui-color-base-foreground) / 0.30);
}
.oui-bg-base-contrast-4 {
  background-color: rgb(var(--oui-color-base-foreground) / 0.04);
}
.oui-bg-base-contrast-54 {
  background-color: rgb(var(--oui-color-base-foreground) / 0.54);
}
.oui-bg-base-contrast-6 {
  background-color: rgb(var(--oui-color-base-foreground) / 0.06);
}
.oui-bg-base-contrast-8 {
  background-color: rgb(var(--oui-color-base-foreground) / 0.08);
}
.oui-bg-base-contrast-80 {
  background-color: rgb(var(--oui-color-base-foreground) / 0.80);
}
.oui-bg-base-static {
  background-color: rgb(var(--oui-color-base-static) / 0.98);
}
.oui-bg-base-static-contrast\/10 {
  background-color: rgb(var(--oui-color-base-static-contrast) / 0.1);
}
.oui-bg-black\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.oui-bg-danger {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-danger) / var(--tw-bg-opacity, 1));
}
.oui-bg-danger-darken {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-danger-darken) / var(--tw-bg-opacity, 1));
}
.oui-bg-danger-light {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-danger-light) / var(--tw-bg-opacity, 1));
}
.oui-bg-danger\/15 {
  background-color: rgb(var(--oui-color-danger) / 0.15);
}
.oui-bg-line {
  background-color: rgb(var(--oui-color-line, 255 255 255) / 0.08);
}
.oui-bg-line-12 {
  background-color: rgb(var(--oui-color-line, 255 255 255) / 0.12);
}
.oui-bg-line-4 {
  background-color: rgb(var(--oui-color-line, 255 255 255) / 0.04);
}
.oui-bg-line-6 {
  background-color: rgb(var(--oui-color-line, 255 255 255) / 0.06);
}
.oui-bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-primary) / var(--tw-bg-opacity, 1));
}
.oui-bg-primary-contrast {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-primary-contrast) / var(--tw-bg-opacity, 1));
}
.oui-bg-primary-darken {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-primary-darken) / var(--tw-bg-opacity, 1));
}
.oui-bg-primary-light {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-primary-light) / var(--tw-bg-opacity, 1));
}
.oui-bg-primary-light\/15 {
  background-color: rgb(var(--oui-color-primary-light) / 0.15);
}
.oui-bg-primary\/15 {
  background-color: rgb(var(--oui-color-primary) / 0.15);
}
.oui-bg-primary\/\[0\.08\] {
  background-color: rgb(var(--oui-color-primary) / 0.08);
}
.oui-bg-primary\/\[0\.12\] {
  background-color: rgb(var(--oui-color-primary) / 0.12);
}
.oui-bg-red-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
.oui-bg-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-secondary) / var(--tw-bg-opacity, 1));
}
.oui-bg-success {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-success) / var(--tw-bg-opacity, 1));
}
.oui-bg-success-darken {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-success-darken) / var(--tw-bg-opacity, 1));
}
.oui-bg-success\/15 {
  background-color: rgb(var(--oui-color-success) / 0.15);
}
.oui-bg-success\/20 {
  background-color: rgb(var(--oui-color-success) / 0.2);
}
.oui-bg-success\/\[0\.15\] {
  background-color: rgb(var(--oui-color-success) / 0.15);
}
.oui-bg-trade-loss {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-trading-loss) / var(--tw-bg-opacity, 1));
}
.oui-bg-trade-loss\/10 {
  background-color: rgb(var(--oui-color-trading-loss) / 0.1);
}
.oui-bg-trade-loss\/20 {
  background-color: rgb(var(--oui-color-trading-loss) / 0.2);
}
.oui-bg-trade-profit {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-trading-profit) / var(--tw-bg-opacity, 1));
}
.oui-bg-trade-profit\/10 {
  background-color: rgb(var(--oui-color-trading-profit) / 0.1);
}
.oui-bg-trade-profit\/20 {
  background-color: rgb(var(--oui-color-trading-profit) / 0.2);
}
.oui-bg-transparent {
  background-color: transparent;
}
.oui-bg-warning-darken {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-warning-darken) / var(--tw-bg-opacity, 1));
}
.oui-bg-warning-darken\/10 {
  background-color: rgb(var(--oui-color-warning-darken) / 0.1);
}
.oui-bg-warning-darken\/15 {
  background-color: rgb(var(--oui-color-warning-darken) / 0.15);
}
.oui-bg-warning-light {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-warning-light) / var(--tw-bg-opacity, 1));
}
.oui-bg-warning\/10 {
  background-color: rgb(var(--oui-color-warning) / 0.1);
}
.oui-bg-warning\/70 {
  background-color: rgb(var(--oui-color-warning) / 0.7);
}
.oui-bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.oui-bg-\[linear-gradient\(15deg\,rgb\(var\(--oui-color-link\)\)_-11\%\,transparent_30\%\,transparent_77\%\,rgb\(var\(--oui-color-success\)\)_100\%\)\] {
  background-image: linear-gradient(15deg,rgb(var(--oui-color-link)) -11%,transparent 30%,transparent 77%,rgb(var(--oui-color-success)) 100%);
}
.oui-bg-\[linear-gradient\(15deg\,rgb\(var\(--oui-color-primary\)\)_-11\%\,transparent_30\%\,transparent_77\%\,rgb\(var\(--oui-color-danger-darken\)\)_100\%\)\] {
  background-image: linear-gradient(15deg,rgb(var(--oui-color-primary)) -11%,transparent 30%,transparent 77%,rgb(var(--oui-color-danger-darken)) 100%);
}
.oui-bg-\[linear-gradient\(15deg\,rgb\(var\(--oui-color-primary-darken\)\)_0\%\,transparent_30\%\)\] {
  background-image: linear-gradient(15deg,rgb(var(--oui-color-primary-darken)) 0%,transparent 30%);
}
.oui-bg-\[linear-gradient\(15deg\,rgb\(var\(--oui-color-warning-darken\)\)_0\%\,transparent_30\%\)\] {
  background-image: linear-gradient(15deg,rgb(var(--oui-color-warning-darken)) 0%,transparent 30%);
}
.oui-bg-\[linear-gradient\(270deg\,rgb\(var\(--oui-gradient-brand-end\)\)_0\%\,rgb\(var\(--oui-gradient-brand-start\)\)_100\%\)\] {
  background-image: linear-gradient(270deg,rgb(var(--oui-gradient-brand-end)) 0%,rgb(var(--oui-gradient-brand-start)) 100%);
}
.oui-bg-\[linear-gradient\(270deg\,rgb\(var\(--oui-gradient-brand-end\)_\/_0\.10\)_0\%\,rgb\(var\(--oui-gradient-brand-start\)_\/_0\.10\)_100\%\)\] {
  background-image: linear-gradient(270deg,rgb(var(--oui-gradient-brand-end) / 0.10) 0%,rgb(var(--oui-gradient-brand-start) / 0.10) 100%);
}
.oui-bg-\[linear-gradient\(270deg\,rgb\(var\(--oui-gradient-brand-start\)\)_0\%\,rgb\(var\(--oui-gradient-brand-end\)\)_100\%\)\] {
  background-image: linear-gradient(270deg,rgb(var(--oui-gradient-brand-start)) 0%,rgb(var(--oui-gradient-brand-end)) 100%);
}
.oui-bg-\[linear-gradient\(270deg\,rgba\(241\,215\,121\,0\.0225\)_-2\.05\%\,rgba\(255\,203\,70\,0\.45\)_100\%\)\] {
  background-image: linear-gradient(270deg,rgba(241,215,121,0.0225) -2.05%,rgba(255,203,70,0.45) 100%);
}
.oui-bg-\[linear-gradient\(270deg\,rgba\(255\,233\,157\,0\.0225\)_-1\.3\%\,rgba\(160\,101\,46\,0\.45\)_100\%\)\] {
  background-image: linear-gradient(270deg,rgba(255,233,157,0.0225) -1.3%,rgba(160,101,46,0.45) 100%);
}
.oui-bg-\[linear-gradient\(270deg\,rgba\(255\,255\,255\,0\.0225\)_-2\.05\%\,rgba\(199\,199\,199\,0\.45\)_100\%\)\] {
  background-image: linear-gradient(270deg,rgba(255,255,255,0.0225) -2.05%,rgba(199,199,199,0.45) 100%);
}
.oui-bg-\[linear-gradient\(90deg\,rgba\(var\(--oui-color-base-9\)_\/_0\)_0\%\,rgba\(var\(--oui-color-base-9\)_\/_1\)_100\%\)\] {
  background-image: linear-gradient(90deg,rgba(var(--oui-color-base-9) / 0) 0%,rgba(var(--oui-color-base-9) / 1) 100%);
}
.oui-bg-\[repeating-linear-gradient\(45deg\,rgba\(255\,255\,255\,0\.08\)_0\,rgba\(255\,255\,255\,0\.08\)_4px\,transparent_4px\,transparent_8px\)\] {
  background-image: repeating-linear-gradient(45deg,rgba(255,255,255,0.08) 0,rgba(255,255,255,0.08) 4px,transparent 4px,transparent 8px);
}
.oui-bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.oui-bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.oui-bg-gradient-to-tr {
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
}
.oui-from-\[rgb\(var\(--oui-gradient-brand-end\)\)\] {
  --tw-gradient-from: rgb(var(--oui-gradient-brand-end)) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--oui-gradient-brand-end) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.oui-from-\[rgb\(var\(--oui-gradient-brand-start\)\)\] {
  --tw-gradient-from: rgb(var(--oui-gradient-brand-start)) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--oui-gradient-brand-start) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.oui-from-\[rgb\(var\(--oui-gradient-brand-start\)_\/_0\.12\)\] {
  --tw-gradient-from: rgb(var(--oui-gradient-brand-start) / 0.12) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--oui-gradient-brand-start) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.oui-from-\[rgb\(var\(--oui-gradient-danger-end\)\)\] {
  --tw-gradient-from: rgb(var(--oui-gradient-danger-end)) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--oui-gradient-danger-end) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.oui-from-\[rgb\(var\(--oui-gradient-secondary-end\)\)\] {
  --tw-gradient-from: rgb(var(--oui-gradient-secondary-end)) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--oui-gradient-secondary-end) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.oui-from-\[rgb\(var\(--oui-gradient-warning-end\)\)\] {
  --tw-gradient-from: rgb(var(--oui-gradient-warning-end)) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--oui-gradient-warning-end) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.oui-from-\[rgba\(var\(--oui-gradient-brand-end\)\/0\)\] {
  --tw-gradient-from: rgba(var(--oui-gradient-brand-end)/0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(var(--oui-gradient-brand-end), 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.oui-from-\[rgba\(var\(--oui-gradient-brand-start\)\)\] {
  --tw-gradient-from: rgba(var(--oui-gradient-brand-start)) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(var(--oui-gradient-brand-start), 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.oui-from-\[rgba\(var\(--oui-gradient-primary-end\)\/0\.12\)\] {
  --tw-gradient-from: rgba(var(--oui-gradient-primary-end)/0.12) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(var(--oui-gradient-primary-end), 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.oui-from-\[rgba\(var\(--oui-gradient-secondary-end\)\/0\.12\)\] {
  --tw-gradient-from: rgba(var(--oui-gradient-secondary-end)/0.12) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(var(--oui-gradient-secondary-end), 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.oui-from-\[rgba\(var\(--oui-gradient-success-end\)\/0\.12\)\] {
  --tw-gradient-from: rgba(var(--oui-gradient-success-end)/0.12) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(var(--oui-gradient-success-end), 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.oui-via-\[rgb\(var\(--oui-color-warning-darken\)\)\] {
  --tw-gradient-to: rgb(var(--oui-color-warning-darken) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(var(--oui-color-warning-darken)) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.oui-to-\[rgb\(var\(--oui-color-danger-darken\)\)\] {
  --tw-gradient-to: rgb(var(--oui-color-danger-darken)) var(--tw-gradient-to-position);
}
.oui-to-\[rgb\(var\(--oui-gradient-brand-end\)\)\] {
  --tw-gradient-to: rgb(var(--oui-gradient-brand-end)) var(--tw-gradient-to-position);
}
.oui-to-\[rgb\(var\(--oui-gradient-brand-end\)_\/_0\.12\)\] {
  --tw-gradient-to: rgb(var(--oui-gradient-brand-end) / 0.12) var(--tw-gradient-to-position);
}
.oui-to-\[rgb\(var\(--oui-gradient-brand-start\)\)\] {
  --tw-gradient-to: rgb(var(--oui-gradient-brand-start)) var(--tw-gradient-to-position);
}
.oui-to-\[rgb\(var\(--oui-gradient-danger-start\)\)\] {
  --tw-gradient-to: rgb(var(--oui-gradient-danger-start)) var(--tw-gradient-to-position);
}
.oui-to-\[rgb\(var\(--oui-gradient-secondary-start\)\)\] {
  --tw-gradient-to: rgb(var(--oui-gradient-secondary-start)) var(--tw-gradient-to-position);
}
.oui-to-\[rgb\(var\(--oui-gradient-warning-start\)\)\] {
  --tw-gradient-to: rgb(var(--oui-gradient-warning-start)) var(--tw-gradient-to-position);
}
.oui-to-\[rgba\(var\(--oui-gradient-brand-end\)\)\] {
  --tw-gradient-to: rgba(var(--oui-gradient-brand-end)) var(--tw-gradient-to-position);
}
.oui-to-\[rgba\(var\(--oui-gradient-brand-end\)\/0\)\] {
  --tw-gradient-to: rgba(var(--oui-gradient-brand-end)/0) var(--tw-gradient-to-position);
}
.oui-to-\[rgba\(var\(--oui-gradient-brand-start\)\)\] {
  --tw-gradient-to: rgba(var(--oui-gradient-brand-start)) var(--tw-gradient-to-position);
}
.oui-to-\[rgba\(var\(--oui-gradient-primary-start\)\/0\.12\)\] {
  --tw-gradient-to: rgba(var(--oui-gradient-primary-start)/0.12) var(--tw-gradient-to-position);
}
.oui-to-\[rgba\(var\(--oui-gradient-secondary-start\)\/0\.12\)\] {
  --tw-gradient-to: rgba(var(--oui-gradient-secondary-start)/0.12) var(--tw-gradient-to-position);
}
.oui-to-\[rgba\(var\(--oui-gradient-success-start\)\/0\.12\)\] {
  --tw-gradient-to: rgba(var(--oui-gradient-success-start)/0.12) var(--tw-gradient-to-position);
}
.oui-bg-contain {
  background-size: contain;
}
.oui-bg-cover {
  background-size: cover;
}
.oui-bg-clip-padding {
  background-clip: padding-box;
}
.oui-bg-clip-text {
  -webkit-background-clip: text;
          background-clip: text;
}
.oui-bg-center {
  background-position: center;
}
.oui-bg-no-repeat {
  background-repeat: no-repeat;
}
.\!oui-fill-base-6 {
  fill: rgb(var(--oui-color-base-6) / 1) !important;
}
.oui-fill-base-4 {
  fill: rgb(var(--oui-color-base-4) / 1);
}
.oui-fill-base-5 {
  fill: rgb(var(--oui-color-base-5) / 1);
}
.oui-fill-base-6 {
  fill: rgb(var(--oui-color-base-6) / 1);
}
.oui-fill-base-7 {
  fill: rgb(var(--oui-color-base-7) / 1);
}
.oui-fill-base-8 {
  fill: rgb(var(--oui-color-base-8) / 1);
}
.oui-fill-base-contrast {
  fill: rgb(var(--oui-color-base-foreground) / 0.98);
}
.oui-fill-base-contrast-12 {
  fill: rgb(var(--oui-color-base-foreground) / 0.12);
}
.oui-fill-base-contrast-16 {
  fill: rgb(var(--oui-color-base-foreground) / 0.16);
}
.oui-fill-base-contrast-20 {
  fill: rgb(var(--oui-color-base-foreground) / 0.2);
}
.oui-fill-base-contrast-36 {
  fill: rgb(var(--oui-color-base-foreground) / 0.36);
}
.oui-fill-base-contrast-54 {
  fill: rgb(var(--oui-color-base-foreground) / 0.54);
}
.oui-fill-base-contrast-6 {
  fill: rgb(var(--oui-color-base-foreground) / 0.06);
}
.oui-fill-base-contrast-80 {
  fill: rgb(var(--oui-color-base-foreground) / 0.80);
}
.oui-fill-base-static {
  fill: rgb(var(--oui-color-base-static) / 0.98);
}
.oui-fill-current {
  fill: currentColor;
}
.oui-fill-danger {
  fill: rgb(var(--oui-color-danger) / 1);
}
.oui-fill-danger-light {
  fill: rgb(var(--oui-color-danger-light) / 1);
}
.oui-fill-primary {
  fill: rgb(var(--oui-color-primary) / 1);
}
.oui-fill-primary-contrast {
  fill: rgb(var(--oui-color-primary-contrast) / 1);
}
.oui-fill-primary-contrast\/50 {
  fill: rgb(var(--oui-color-primary-contrast) / 0.5);
}
.oui-fill-primary-darken {
  fill: rgb(var(--oui-color-primary-darken) / 1);
}
.oui-fill-primary-light {
  fill: rgb(var(--oui-color-primary-light) / 1);
}
.oui-fill-success {
  fill: rgb(var(--oui-color-success) / 1);
}
.oui-fill-success-darken {
  fill: rgb(var(--oui-color-success-darken) / 1);
}
.oui-fill-success-light {
  fill: rgb(var(--oui-color-success-light) / 1);
}
.oui-fill-transparent {
  fill: transparent;
}
.oui-fill-warning {
  fill: rgb(var(--oui-color-warning) / 1);
}
.oui-fill-warning-darken {
  fill: rgb(var(--oui-color-warning-darken) / 1);
}
.oui-fill-warning-light {
  fill: rgb(var(--oui-color-warning-light) / 1);
}
.oui-object-contain {
  -o-object-fit: contain;
     object-fit: contain;
}
.oui-object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}
.\!oui-p-0 {
  padding: 0px !important;
}
.\!oui-p-1 {
  padding: 0.25rem !important;
}
.\!oui-p-3 {
  padding: 0.75rem !important;
}
.\!oui-p-4 {
  padding: 1rem !important;
}
.oui-p-0 {
  padding: 0px;
}
.oui-p-0\.5 {
  padding: 0.125rem;
}
.oui-p-1 {
  padding: 0.25rem;
}
.oui-p-1\.5 {
  padding: 0.375rem;
}
.oui-p-10 {
  padding: 2.5rem;
}
.oui-p-2 {
  padding: 0.5rem;
}
.oui-p-3 {
  padding: 0.75rem;
}
.oui-p-4 {
  padding: 1rem;
}
.oui-p-5 {
  padding: 1.25rem;
}
.oui-p-6 {
  padding: 1.5rem;
}
.oui-p-7 {
  padding: 1.75rem;
}
.oui-p-8 {
  padding: 2rem;
}
.oui-p-9 {
  padding: 2.25rem;
}
.oui-p-\[1px\] {
  padding: 1px;
}
.oui-p-\[2px\] {
  padding: 2px;
}
.oui-p-\[7px\] {
  padding: 7px;
}
.oui-p-\[clamp\(0\.75rem\,2\.5vw\,1\.5rem\)\] {
  padding: clamp(0.75rem, 2.5vw, 1.5rem);
}
.oui-p-\[clamp\(1rem\,1\.75vw\,1\.75rem\)\] {
  padding: clamp(1rem, 1.75vw, 1.75rem);
}
.\!oui-px-0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.\!oui-px-1 {
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}
.\!oui-px-5 {
  padding-left: 1.25rem !important;
  padding-right: 1.25rem !important;
}
.\!oui-py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.\!oui-py-12 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}
.\!oui-py-\[2px\] {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}
.oui-px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.oui-px-0\.5 {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.oui-px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.oui-px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.oui-px-16 {
  padding-left: 4rem;
  padding-right: 4rem;
}
.oui-px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.oui-px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.oui-px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.oui-px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.oui-px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.oui-px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.oui-px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.oui-px-9 {
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}
.oui-px-\[10\%\] {
  padding-left: 10%;
  padding-right: 10%;
}
.oui-px-\[14px\] {
  padding-left: 14px;
  padding-right: 14px;
}
.oui-px-\[1px\] {
  padding-left: 1px;
  padding-right: 1px;
}
.oui-px-\[20px\] {
  padding-left: 20px;
  padding-right: 20px;
}
.oui-px-\[2px\] {
  padding-left: 2px;
  padding-right: 2px;
}
.oui-px-\[40px\] {
  padding-left: 40px;
  padding-right: 40px;
}
.oui-px-\[5px\] {
  padding-left: 5px;
  padding-right: 5px;
}
.oui-px-\[6px\] {
  padding-left: 6px;
  padding-right: 6px;
}
.oui-px-\[7px\] {
  padding-left: 7px;
  padding-right: 7px;
}
.oui-px-px {
  padding-left: 1px;
  padding-right: 1px;
}
.oui-py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.oui-py-0\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.oui-py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.oui-py-1\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.oui-py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.oui-py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.oui-py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.oui-py-2\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.oui-py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.oui-py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.oui-py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.oui-py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.oui-py-7 {
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.oui-py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.oui-py-9 {
  padding-top: 2.25rem;
  padding-bottom: 2.25rem;
}
.oui-py-\[10px\] {
  padding-top: 10px;
  padding-bottom: 10px;
}
.oui-py-\[11px\] {
  padding-top: 11px;
  padding-bottom: 11px;
}
.oui-py-\[13px\] {
  padding-top: 13px;
  padding-bottom: 13px;
}
.oui-py-\[2px\] {
  padding-top: 2px;
  padding-bottom: 2px;
}
.oui-py-\[3px\] {
  padding-top: 3px;
  padding-bottom: 3px;
}
.oui-py-\[5px\] {
  padding-top: 5px;
  padding-bottom: 5px;
}
.oui-py-\[6px\] {
  padding-top: 6px;
  padding-bottom: 6px;
}
.\!oui-pb-0 {
  padding-bottom: 0px !important;
}
.\!oui-pe-0 {
  padding-inline-end: 0px !important;
}
.\!oui-pe-5 {
  padding-inline-end: 1.25rem !important;
}
.\!oui-ps-5 {
  padding-inline-start: 1.25rem !important;
}
.\!oui-pt-0 {
  padding-top: 0px !important;
}
.\!oui-pt-3 {
  padding-top: 0.75rem !important;
}
.\!oui-pt-8 {
  padding-top: 2rem !important;
}
.oui-pb-0 {
  padding-bottom: 0px;
}
.oui-pb-1 {
  padding-bottom: 0.25rem;
}
.oui-pb-10 {
  padding-bottom: 2.5rem;
}
.oui-pb-2 {
  padding-bottom: 0.5rem;
}
.oui-pb-24 {
  padding-bottom: 6rem;
}
.oui-pb-3 {
  padding-bottom: 0.75rem;
}
.oui-pb-4 {
  padding-bottom: 1rem;
}
.oui-pb-5 {
  padding-bottom: 1.25rem;
}
.oui-pb-6 {
  padding-bottom: 1.5rem;
}
.oui-pb-7 {
  padding-bottom: 1.75rem;
}
.oui-pb-8 {
  padding-bottom: 2rem;
}
.oui-pb-9 {
  padding-bottom: 2.25rem;
}
.oui-pb-\[5px\] {
  padding-bottom: 5px;
}
.oui-pb-\[9px\] {
  padding-bottom: 9px;
}
.oui-pb-\[calc\(20px\+env\(safe-area-inset-bottom\)\)\] {
  padding-bottom: calc(20px + env(safe-area-inset-bottom));
}
.oui-pb-\[calc\(env\(safe-area-inset-bottom\)\)\] {
  padding-bottom: calc(env(safe-area-inset-bottom));
}
.oui-pb-\[env\(safe-area-inset-bottom\)\] {
  padding-bottom: env(safe-area-inset-bottom);
}
.oui-pb-\[env\(safe-area-inset-bottom\,_20px\)\] {
  padding-bottom: env(safe-area-inset-bottom, 20px);
}
.oui-pe-0 {
  padding-inline-end: 0px;
}
.oui-pe-1 {
  padding-inline-end: 0.25rem;
}
.oui-pe-12 {
  padding-inline-end: 3rem;
}
.oui-pe-2 {
  padding-inline-end: 0.5rem;
}
.oui-pe-2\.5 {
  padding-inline-end: 0.625rem;
}
.oui-pe-3 {
  padding-inline-end: 0.75rem;
}
.oui-pe-5 {
  padding-inline-end: 1.25rem;
}
.oui-pe-8 {
  padding-inline-end: 2rem;
}
.oui-pe-9 {
  padding-inline-end: 2.25rem;
}
.oui-pe-\[5px\] {
  padding-inline-end: 5px;
}
.oui-pe-\[6px\] {
  padding-inline-end: 6px;
}
.oui-pl-0 {
  padding-left: 0px;
}
.oui-pl-1 {
  padding-left: 0.25rem;
}
.oui-pl-10 {
  padding-left: 2.5rem;
}
.oui-pl-2 {
  padding-left: 0.5rem;
}
.oui-pl-3 {
  padding-left: 0.75rem;
}
.oui-pl-4 {
  padding-left: 1rem;
}
.oui-pl-5 {
  padding-left: 1.25rem;
}
.oui-pl-6 {
  padding-left: 1.5rem;
}
.oui-pl-7 {
  padding-left: 1.75rem;
}
.oui-pl-8 {
  padding-left: 2rem;
}
.oui-pl-9 {
  padding-left: 2.25rem;
}
.oui-pr-0 {
  padding-right: 0px;
}
.oui-pr-1 {
  padding-right: 0.25rem;
}
.oui-pr-10 {
  padding-right: 2.5rem;
}
.oui-pr-2 {
  padding-right: 0.5rem;
}
.oui-pr-3 {
  padding-right: 0.75rem;
}
.oui-pr-4 {
  padding-right: 1rem;
}
.oui-pr-5 {
  padding-right: 1.25rem;
}
.oui-pr-6 {
  padding-right: 1.5rem;
}
.oui-pr-7 {
  padding-right: 1.75rem;
}
.oui-pr-8 {
  padding-right: 2rem;
}
.oui-pr-9 {
  padding-right: 2.25rem;
}
.oui-ps-0 {
  padding-inline-start: 0px;
}
.oui-ps-0\.5 {
  padding-inline-start: 0.125rem;
}
.oui-ps-1 {
  padding-inline-start: 0.25rem;
}
.oui-ps-2 {
  padding-inline-start: 0.5rem;
}
.oui-ps-2\.5 {
  padding-inline-start: 0.625rem;
}
.oui-ps-3 {
  padding-inline-start: 0.75rem;
}
.oui-ps-4 {
  padding-inline-start: 1rem;
}
.oui-ps-5 {
  padding-inline-start: 1.25rem;
}
.oui-ps-6 {
  padding-inline-start: 1.5rem;
}
.oui-ps-8 {
  padding-inline-start: 2rem;
}
.oui-pt-0 {
  padding-top: 0px;
}
.oui-pt-1 {
  padding-top: 0.25rem;
}
.oui-pt-10 {
  padding-top: 2.5rem;
}
.oui-pt-16 {
  padding-top: 4rem;
}
.oui-pt-2 {
  padding-top: 0.5rem;
}
.oui-pt-3 {
  padding-top: 0.75rem;
}
.oui-pt-4 {
  padding-top: 1rem;
}
.oui-pt-5 {
  padding-top: 1.25rem;
}
.oui-pt-6 {
  padding-top: 1.5rem;
}
.oui-pt-7 {
  padding-top: 1.75rem;
}
.oui-pt-8 {
  padding-top: 2rem;
}
.oui-pt-9 {
  padding-top: 2.25rem;
}
.oui-pt-\[2px\] {
  padding-top: 2px;
}
.oui-pt-\[6px\] {
  padding-top: 6px;
}
.oui-pt-\[9px\] {
  padding-top: 9px;
}
.oui-pt-px {
  padding-top: 1px;
}
.oui-text-left {
  text-align: left;
}
.oui-text-center {
  text-align: center;
}
.oui-text-right {
  text-align: right;
}
.\!oui-text-start {
  text-align: start !important;
}
.oui-text-start {
  text-align: start;
}
.oui-text-end {
  text-align: end;
}
.\!oui-text-\[10px\] {
  font-size: 10px !important;
}
.oui-text-2xl {
  font-size: var(--oui-font-size-2xl, 1.5rem);
  line-height: 2rem;
}
.oui-text-2xs {
  font-size: var(--oui-font-size-2xs, 0.75rem);
  line-height: 1.125rem;
}
.oui-text-3xl {
  font-size: var(--oui-font-size-3xl, 1.75rem);
  line-height: 2.25rem;
}
.oui-text-3xs {
  font-size: var(--oui-font-size-3xs, 0.625rem);
  line-height: 0.625rem;
}
.oui-text-4xl {
  font-size: var(--oui-font-size-4xl, 1.875rem);
  line-height: 2.375rem;
}
.oui-text-5xl {
  font-size: var(--oui-font-size-5xl, 2.25rem);
  line-height: 2.75rem;
}
.oui-text-6xl {
  font-size: var(--oui-font-size-6xl, 3rem);
  line-height: 3rem;
}
.oui-text-\[0\.8rem\] {
  font-size: 0.8rem;
}
.oui-text-\[10px\] {
  font-size: 10px;
}
.oui-text-\[11px\] {
  font-size: 11px;
}
.oui-text-\[14px\] {
  font-size: 14px;
}
.oui-text-\[16px\] {
  font-size: 16px;
}
.oui-text-\[18px\] {
  font-size: 18px;
}
.oui-text-\[20px\] {
  font-size: 20px;
}
.oui-text-\[24px\] {
  font-size: 24px;
}
.oui-text-\[28px\] {
  font-size: 28px;
}
.oui-text-\[32px\] {
  font-size: 32px;
}
.oui-text-\[36px\] {
  font-size: 36px;
}
.oui-text-\[48px\] {
  font-size: 48px;
}
.oui-text-\[56px\] {
  font-size: 56px;
}
.oui-text-\[8px\] {
  font-size: 8px;
}
.oui-text-\[length\:clamp\(0\.625rem\,1\.5vw\,0\.875rem\)\] {
  font-size: clamp(0.625rem, 1.5vw, 0.875rem);
}
.oui-text-\[length\:clamp\(0\.75rem\,0\.9vw\,0\.875rem\)\] {
  font-size: clamp(0.75rem, 0.9vw, 0.875rem);
}
.oui-text-\[length\:clamp\(1\.25rem\,3\.5vw\,2\.25rem\)\] {
  font-size: clamp(1.25rem, 3.5vw, 2.25rem);
}
.oui-text-\[length\:clamp\(1\.5rem\,2\.25vw\,2\.75rem\)\] {
  font-size: clamp(1.5rem, 2.25vw, 2.75rem);
}
.oui-text-\[length\:clamp\(28px\,2\.2vw\,38px\)\] {
  font-size: clamp(28px, 2.2vw, 38px);
}
.oui-text-base {
  font-size: var(--oui-font-size-base, 1rem);
  line-height: 1.5rem;
}
.oui-text-lg {
  font-size: var(--oui-font-size-lg, 1.125rem);
  line-height: 1.625rem;
}
.oui-text-sm {
  font-size: var(--oui-font-size-sm,0.875rem);
  line-height: 1.25rem;
}
.oui-text-xl {
  font-size: var(--oui-font-size-xl, 1.25rem);
  line-height: 1.75rem;
}
.oui-text-xs {
  font-size: var(--oui-font-size-xs, calc(0.875rem - 1px));
  line-height: 1.25rem;
}
.oui-font-bold {
  font-weight: 700;
}
.oui-font-medium {
  font-weight: 500;
}
.oui-font-normal {
  font-weight: 400;
}
.oui-font-semibold {
  font-weight: 600;
}
.oui-tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.oui-leading-10 {
  line-height: 2.5rem;
}
.oui-leading-3 {
  line-height: .75rem;
}
.oui-leading-4 {
  line-height: 1rem;
}
.oui-leading-5 {
  line-height: 1.25rem;
}
.oui-leading-6 {
  line-height: 1.5rem;
}
.oui-leading-8 {
  line-height: 2rem;
}
.oui-leading-9 {
  line-height: 2.25rem;
}
.oui-leading-\[0px\] {
  line-height: 0px;
}
.oui-leading-\[1\.15\] {
  line-height: 1.15;
}
.oui-leading-\[1\.2\] {
  line-height: 1.2;
}
.oui-leading-\[1\.45\] {
  line-height: 1.45;
}
.oui-leading-\[1\.5\] {
  line-height: 1.5;
}
.oui-leading-\[10px\] {
  line-height: 10px;
}
.oui-leading-\[14px\] {
  line-height: 14px;
}
.oui-leading-\[15px\] {
  line-height: 15px;
}
.oui-leading-\[16px\] {
  line-height: 16px;
}
.oui-leading-\[18px\] {
  line-height: 18px;
}
.oui-leading-\[20px\] {
  line-height: 20px;
}
.oui-leading-\[24px\] {
  line-height: 24px;
}
.oui-leading-\[26px\] {
  line-height: 26px;
}
.oui-leading-\[28px\] {
  line-height: 28px;
}
.oui-leading-\[32px\] {
  line-height: 32px;
}
.oui-leading-\[36px\] {
  line-height: 36px;
}
.oui-leading-\[40px\] {
  line-height: 40px;
}
.oui-leading-\[44px\] {
  line-height: 44px;
}
.oui-leading-\[56px\] {
  line-height: 56px;
}
.oui-leading-none {
  line-height: 1;
}
.oui-leading-normal {
  line-height: 1.5;
}
.oui-leading-relaxed {
  line-height: 1.625;
}
.oui-leading-tight {
  line-height: 1.25;
}
.oui-tracking-\[-0\.025em\] {
  letter-spacing: -0.025em;
}
.oui-tracking-\[-0\.02em\] {
  letter-spacing: -0.02em;
}
.oui-tracking-\[0\.01em\] {
  letter-spacing: 0.01em;
}
.oui-tracking-\[0\.03em\] {
  letter-spacing: 0.03em;
}
.oui-tracking-\[0\.48px\] {
  letter-spacing: 0.48px;
}
.oui-tracking-tight {
  letter-spacing: -0.025em;
}
.oui-tracking-wide {
  letter-spacing: 0.025em;
}
.oui-tracking-widest {
  letter-spacing: 0.1em;
}
.oui-text-\[\#63666D\] {
  --tw-text-opacity: 1;
  color: rgb(99 102 109 / var(--tw-text-opacity, 1));
}
.oui-text-\[rgb\(var\(--oui-gradient-brand-start\)\)\] {
  color: rgb(var(--oui-gradient-brand-start));
}
.oui-text-\[rgba\(255\,154\,46\,1\)\] {
  color: rgba(255,154,46,1);
}
.oui-text-base-10 {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-base-10) / var(--tw-text-opacity, 1));
}
.oui-text-base-5 {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-base-5) / var(--tw-text-opacity, 1));
}
.oui-text-base-6 {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-base-6) / var(--tw-text-opacity, 1));
}
.oui-text-base-8 {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-base-8) / var(--tw-text-opacity, 1));
}
.oui-text-base-contrast {
  color: rgb(var(--oui-color-base-foreground) / 0.98);
}
.oui-text-base-contrast-12 {
  color: rgb(var(--oui-color-base-foreground) / 0.12);
}
.oui-text-base-contrast-20 {
  color: rgb(var(--oui-color-base-foreground) / 0.2);
}
.oui-text-base-contrast-36 {
  color: rgb(var(--oui-color-base-foreground) / 0.36);
}
.oui-text-base-contrast-54 {
  color: rgb(var(--oui-color-base-foreground) / 0.54);
}
.oui-text-base-contrast-8 {
  color: rgb(var(--oui-color-base-foreground) / 0.08);
}
.oui-text-base-contrast-80 {
  color: rgb(var(--oui-color-base-foreground) / 0.80);
}
.oui-text-base-contrast\/30 {
  color: rgb(var(--oui-color-base-foreground) / 0.3);
}
.oui-text-base-contrast\/40 {
  color: rgb(var(--oui-color-base-foreground) / 0.4);
}
.oui-text-base-contrast\/60 {
  color: rgb(var(--oui-color-base-foreground) / 0.6);
}
.oui-text-base-static {
  color: rgb(var(--oui-color-base-static) / 0.98);
}
.oui-text-base-static-contrast {
  color: rgb(var(--oui-color-base-static-contrast) / 0.98);
}
.oui-text-base-static-contrast-20 {
  color: rgb(var(--oui-color-base-static-contrast) / 0.2);
}
.oui-text-base-static-contrast-80 {
  color: rgb(var(--oui-color-base-static-contrast) / 0.80);
}
.oui-text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.oui-text-current {
  color: currentColor;
}
.oui-text-danger {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-danger) / var(--tw-text-opacity, 1));
}
.oui-text-danger-contrast {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-danger-contrast) / var(--tw-text-opacity, 1));
}
.oui-text-danger-darken {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-danger-darken) / var(--tw-text-opacity, 1));
}
.oui-text-danger-light {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-danger-light) / var(--tw-text-opacity, 1));
}
.oui-text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.oui-text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.oui-text-inherit {
  color: inherit;
}
.oui-text-primary {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-primary) / var(--tw-text-opacity, 1));
}
.oui-text-primary-contrast {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-primary-contrast) / var(--tw-text-opacity, 1));
}
.oui-text-primary-contrast\/80 {
  color: rgb(var(--oui-color-primary-contrast) / 0.8);
}
.oui-text-primary-contrast\/\[0\.54\] {
  color: rgb(var(--oui-color-primary-contrast) / 0.54);
}
.oui-text-primary-darken {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-primary-darken) / var(--tw-text-opacity, 1));
}
.oui-text-primary-light {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-primary-light) / var(--tw-text-opacity, 1));
}
.oui-text-primary-light\/60 {
  color: rgb(var(--oui-color-primary-light) / 0.6);
}
.oui-text-secondary {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-secondary) / var(--tw-text-opacity, 1));
}
.oui-text-secondary\/80 {
  color: rgb(var(--oui-color-secondary) / 0.8);
}
.oui-text-secondary\/\[0\.36\] {
  color: rgb(var(--oui-color-secondary) / 0.36);
}
.oui-text-success {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-success) / var(--tw-text-opacity, 1));
}
.oui-text-success-contrast {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-success-contrast) / var(--tw-text-opacity, 1));
}
.oui-text-success-darken {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-success-darken) / var(--tw-text-opacity, 1));
}
.oui-text-success-light {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-success-light) / var(--tw-text-opacity, 1));
}
.oui-text-tertiary {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-tertiary) / var(--tw-text-opacity, 1));
}
.oui-text-trade-loss {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-trading-loss) / var(--tw-text-opacity, 1));
}
.oui-text-trade-profit {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-trading-profit) / var(--tw-text-opacity, 1));
}
.oui-text-transparent {
  color: transparent;
}
.oui-text-warning {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-warning) / var(--tw-text-opacity, 1));
}
.oui-text-warning-contrast {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-warning-contrast) / var(--tw-text-opacity, 1));
}
.oui-text-warning-darken {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-warning-darken) / var(--tw-text-opacity, 1));
}
.oui-text-warning-light {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-warning-light) / var(--tw-text-opacity, 1));
}
.oui-text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.oui-underline {
  text-decoration-line: underline;
}
.oui-no-underline {
  text-decoration-line: none;
}
.oui-decoration-base-contrast {
  text-decoration-color: rgb(var(--oui-color-base-foreground) / 0.98);
}
.oui-decoration-base-contrast-36 {
  text-decoration-color: rgb(var(--oui-color-base-foreground) / 0.36);
}
.oui-decoration-line-16 {
  text-decoration-color: rgb(var(--oui-color-line, 255 255 255) / 0.16);
}
.oui-decoration-warning-darken {
  text-decoration-color: rgb(var(--oui-color-warning-darken) / 1);
}
.oui-decoration-white\/20 {
  text-decoration-color: rgb(255 255 255 / 0.2);
}
.oui-decoration-dotted {
  text-decoration-style: dotted;
}
.oui-decoration-dashed {
  text-decoration-style: dashed;
}
.oui-decoration-1 {
  text-decoration-thickness: 1px;
}
.oui-underline-offset-2 {
  text-underline-offset: 2px;
}
.oui-underline-offset-4 {
  text-underline-offset: 4px;
}
.oui-underline-offset-\[6px\] {
  text-underline-offset: 6px;
}
.oui-placeholder-base-contrast-20::-moz-placeholder {
  color: rgb(var(--oui-color-base-foreground) / 0.2);
}
.oui-placeholder-base-contrast-20::placeholder {
  color: rgb(var(--oui-color-base-foreground) / 0.2);
}
.oui-caret-\[rgb\(var\(--oui-color-tertiary\)\)\] {
  caret-color: rgb(var(--oui-color-tertiary));
}
.oui-opacity-0 {
  opacity: 0;
}
.oui-opacity-100 {
  opacity: 1;
}
.oui-opacity-20 {
  opacity: 0.2;
}
.oui-opacity-30 {
  opacity: 0.3;
}
.oui-opacity-40 {
  opacity: 0.4;
}
.oui-opacity-50 {
  opacity: 0.5;
}
.oui-opacity-60 {
  opacity: 0.6;
}
.oui-opacity-70 {
  opacity: 0.7;
}
.oui-opacity-80 {
  opacity: 0.8;
}
.oui-opacity-90 {
  opacity: 0.9;
}
.oui-opacity-\[\.12\] {
  opacity: .12;
}
.oui-bg-blend-luminosity {
  background-blend-mode: luminosity;
}
.oui-mix-blend-screen {
  mix-blend-mode: screen;
}
.oui-mix-blend-luminosity {
  mix-blend-mode: luminosity;
}
.\!oui-shadow-none {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.oui-shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.oui-shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.oui-shadow-\[0_0_8px_4px_rgba\(var\(--oui-gradient-brand-start\)\/0\.12\)\] {
  --tw-shadow: 0 0 8px 4px rgba(var(--oui-gradient-brand-start)/0.12);
  --tw-shadow-colored: 0 0 8px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.oui-shadow-\[0px_12px_20px_0px_rgba\(0\,0\,0\,0\.25\)\] {
  --tw-shadow: 0px 12px 20px 0px rgba(0,0,0,0.25);
  --tw-shadow-colored: 0px 12px 20px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.oui-shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.oui-shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.oui-shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.oui-shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.oui-shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.oui-shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.oui-shadow-base-9 {
  --tw-shadow-color: rgb(var(--oui-color-base-9) / 1);
  --tw-shadow: var(--tw-shadow-colored);
}
.oui-outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.oui-outline {
  outline-style: solid;
}
.oui-outline-1 {
  outline-width: 1px;
}
.oui-outline-2 {
  outline-width: 2px;
}
.oui-outline-offset-0 {
  outline-offset: 0px;
}
.oui-outline-base-1 {
  outline-color: rgb(var(--oui-color-base-1) / 1);
}
.oui-outline-base-8 {
  outline-color: rgb(var(--oui-color-base-8) / 1);
}
.oui-outline-base-contrast-12 {
  outline-color: rgb(var(--oui-color-base-foreground) / 0.12);
}
.oui-outline-danger {
  outline-color: rgb(var(--oui-color-danger) / 1);
}
.oui-outline-danger-light {
  outline-color: rgb(var(--oui-color-danger-light) / 1);
}
.oui-outline-line {
  outline-color: rgb(var(--oui-color-line, 255 255 255) / 0.08);
}
.oui-outline-line-12 {
  outline-color: rgb(var(--oui-color-line, 255 255 255) / 0.12);
}
.oui-outline-primary-darken {
  outline-color: rgb(var(--oui-color-primary-darken) / 1);
}
.oui-outline-primary-light {
  outline-color: rgb(var(--oui-color-primary-light) / 1);
}
.oui-outline-success {
  outline-color: rgb(var(--oui-color-success) / 1);
}
.oui-outline-transparent {
  outline-color: transparent;
}
.oui-outline-warning-darken {
  outline-color: rgb(var(--oui-color-warning-darken) / 1);
}
.oui-outline-warning-light {
  outline-color: rgb(var(--oui-color-warning-light) / 1);
}
.oui-ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.oui-ring-offset-base-7 {
  --tw-ring-offset-color: rgb(var(--oui-color-base-7) / 1);
}
.oui-drop-shadow {
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.oui-backdrop-blur-\[10px\] {
  --tw-backdrop-blur: blur(10px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.oui-backdrop-blur-\[200px\] {
  --tw-backdrop-blur: blur(200px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.oui-backdrop-blur-\[2px\] {
  --tw-backdrop-blur: blur(2px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.oui-backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.\!oui-transition-none {
  transition-property: none !important;
}
.oui-transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.oui-transition-\[height\] {
  transition-property: height;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.oui-transition-\[max-height\] {
  transition-property: max-height;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.oui-transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.oui-transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.oui-transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.oui-transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.oui-duration-150 {
  transition-duration: 150ms;
}
.oui-duration-200 {
  transition-duration: 200ms;
}
.oui-duration-300 {
  transition-duration: 300ms;
}
.oui-ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.oui-gradient-primary {
  background-image: linear-gradient(var(--oui-gradient-primary-angle, 28.29deg), rgb(var(--oui-gradient-primary-start)) var(--oui-gradient-primary-stop-start,0%), rgb(var(--oui-gradient-primary-end)) var(--oui-gradient-primary-stop-end,100%));
}
.oui-gradient-secondary {
  background-image: linear-gradient(var(--oui-gradient-secondary-angle, 0deg), rgb(var(--oui-gradient-secondary-start)) var(--oui-gradient-secondary-stop-start,0%), rgb(var(--oui-gradient-secondary-end)) var(--oui-gradient-secondary-stop-end,100%));
}
.oui-gradient-success {
  background-image: linear-gradient(var(--oui-gradient-success-angle, 28.29deg), rgb(var(--oui-gradient-success-start)) var(--oui-gradient-success-stop-start,0%), rgba(var(--oui-gradient-success-end)) var(--oui-gradient-success-stop-end,100%));
}
.oui-gradient-warning {
  background-image: linear-gradient(var(--oui-gradient-warning-angle, 28.29deg),rgb(var(--oui-gradient-warning-start)) var(--oui-gradient-warning-stop-start,0%), rgb(var(--oui-gradient-warning-end)) var(--oui-gradient-warning-stop-end,100%));
}
.oui-gradient-danger {
  background-image: linear-gradient(var(--oui-gradient-danger-angle, 28.29deg), rgb(var(--oui-gradient-danger-start)) var(--oui-gradient-danger-stop-start,0%), rgb(var(--oui-gradient-danger-end)) var(--oui-gradient-danger-stop-end,100%));
}
.oui-gradient-neutral {
  background-image: linear-gradient(var(--oui-gradient-neutral-angle, 28.29deg), rgb(var(--oui-gradient-neutral-start)) var(--oui-gradient-neutral-stop-start,0%), rgb(var(--oui-gradient-neutral-end)) var(--oui-gradient-neutral-stop-end,100%));
}
.oui-gradient-brand {
  background-image: linear-gradient(var(--oui-gradient-brand-angle, 17.44deg), rgb(var(--oui-gradient-brand-start)) var(--oui-gradient-brand-stop-start,0%), rgb(var(--oui-gradient-brand-end)) var(--oui-gradient-brand-stop-end,100%));
}
@keyframes enter {

  from {
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit {

  to {
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.oui-animate-in {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.oui-fade-in {
  --tw-enter-opacity: 0;
}
.oui-fade-in-0 {
  --tw-enter-opacity: 0;
}
.oui-fade-out {
  --tw-exit-opacity: 0;
}
.oui-zoom-in-95 {
  --tw-enter-scale: .95;
}
.oui-slide-in-from-bottom-2 {
  --tw-enter-translate-y: 0.5rem;
}
.oui-slide-in-from-top-2 {
  --tw-enter-translate-y: -0.5rem;
}
.oui-duration-150 {
  animation-duration: 150ms;
}
.oui-duration-200 {
  animation-duration: 200ms;
}
.oui-duration-300 {
  animation-duration: 300ms;
}
.oui-ease-in-out {
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
:where(.placeholder\:oui-text-2xs, .oui-text-xs, .oui-text-sm)::-moz-placeholder {
  font-weight: 500;
}
:where(.placeholder\:oui-text-2xs, .oui-text-xs, .oui-text-sm)::placeholder {
  font-weight: 500;
}
:where(.oui-text-2xs,.placeholder\:oui-text-xs, .oui-text-sm)::-moz-placeholder {
  font-weight: 500;
}
:where(.oui-text-2xs,.placeholder\:oui-text-xs, .oui-text-sm)::placeholder {
  font-weight: 500;
}
:where(.oui-text-2xs, .oui-text-xs,.placeholder\:oui-text-sm)::-moz-placeholder {
  font-weight: 500;
}
:where(.oui-text-2xs, .oui-text-xs,.placeholder\:oui-text-sm)::placeholder {
  font-weight: 500;
}
@media (min-width: 480px) {

  :where(.md\:oui-text-2xl, .oui-text-3xl, .oui-text-4xl, .oui-text-5xl) {
    font-weight: 600;
  }

  :where(.oui-text-2xl,.md\:oui-text-3xl, .oui-text-4xl, .oui-text-5xl) {
    font-weight: 600;
  }

  :where(.md\:oui-text-2xs, .oui-text-xs, .oui-text-sm) {
    font-weight: 500;
  }

  :where(.oui-text-2xs,.md\:oui-text-xs, .oui-text-sm) {
    font-weight: 500;
  }

  :where(.oui-text-2xs, .oui-text-xs,.md\:oui-text-sm) {
    font-weight: 500;
  }

  :where(.md\:placeholder\:oui-text-2xs, .oui-text-xs, .oui-text-sm)::-moz-placeholder {
    font-weight: 500;
  }

  :where(.md\:placeholder\:oui-text-2xs, .oui-text-xs, .oui-text-sm)::placeholder {
    font-weight: 500;
  }

  :where(.oui-text-2xs, .oui-text-xs,.md\:placeholder\:oui-text-sm)::-moz-placeholder {
    font-weight: 500;
  }

  :where(.oui-text-2xs, .oui-text-xs,.md\:placeholder\:oui-text-sm)::placeholder {
    font-weight: 500;
  }
}
@media (min-width: 768px) {

  :where(.lg\:oui-text-2xl, .oui-text-3xl, .oui-text-4xl, .oui-text-5xl) {
    font-weight: 600;
  }

  :where(.oui-text-2xl, .oui-text-3xl,.lg\:oui-text-4xl, .oui-text-5xl) {
    font-weight: 600;
  }

  :where(.lg\:oui-text-2xs, .oui-text-xs, .oui-text-sm) {
    font-weight: 500;
  }

  :where(.oui-text-2xs,.lg\:oui-text-xs, .oui-text-sm) {
    font-weight: 500;
  }

  :where(.oui-text-2xs, .oui-text-xs,.lg\:oui-text-sm) {
    font-weight: 500;
  }

  :where(.lg\:placeholder\:oui-text-2xs, .oui-text-xs, .oui-text-sm)::-moz-placeholder {
    font-weight: 500;
  }

  :where(.lg\:placeholder\:oui-text-2xs, .oui-text-xs, .oui-text-sm)::placeholder {
    font-weight: 500;
  }

  :where(.oui-text-2xs, .oui-text-xs,.lg\:placeholder\:oui-text-sm)::-moz-placeholder {
    font-weight: 500;
  }

  :where(.oui-text-2xs, .oui-text-xs,.lg\:placeholder\:oui-text-sm)::placeholder {
    font-weight: 500;
  }
}
@media (min-width: 1024px) {

  :where(.xl\:oui-text-2xl, .oui-text-3xl, .oui-text-4xl, .oui-text-5xl) {
    font-weight: 600;
  }

  :where(.oui-text-2xl,.xl\:oui-text-3xl, .oui-text-4xl, .oui-text-5xl) {
    font-weight: 600;
  }

  :where(.oui-text-2xl, .oui-text-3xl, .oui-text-4xl,.xl\:oui-text-5xl) {
    font-weight: 600;
  }

  :where(.oui-text-2xs,.xl\:oui-text-xs, .oui-text-sm) {
    font-weight: 500;
  }

  :where(.oui-text-2xs, .oui-text-xs,.xl\:oui-text-sm) {
    font-weight: 500;
  }
}
@media (min-width: 1280px) {

  :where(.\32xl\:oui-text-2xl, .oui-text-3xl, .oui-text-4xl, .oui-text-5xl) {
    font-weight: 600;
  }

  :where(.oui-text-2xs, .oui-text-xs,.\32xl\:oui-text-sm) {
    font-weight: 500;
  }
}
:where(.\[\&\>div\]\:oui-text-2xs>div, .oui-text-xs, .oui-text-sm) {
  font-weight: 500;
}
.marker\:oui-text-3xs *::marker {
  font-size: var(--oui-font-size-3xs, 0.625rem);
  line-height: 0.625rem;
}
.marker\:oui-text-3xs::marker {
  font-size: var(--oui-font-size-3xs, 0.625rem);
  line-height: 0.625rem;
}
.placeholder\:oui-text-2xs::-moz-placeholder {
  font-size: var(--oui-font-size-2xs, 0.75rem);
  line-height: 1.125rem;
}
.placeholder\:oui-text-2xs::placeholder {
  font-size: var(--oui-font-size-2xs, 0.75rem);
  line-height: 1.125rem;
}
.placeholder\:oui-text-base::-moz-placeholder {
  font-size: var(--oui-font-size-base, 1rem);
  line-height: 1.5rem;
}
.placeholder\:oui-text-base::placeholder {
  font-size: var(--oui-font-size-base, 1rem);
  line-height: 1.5rem;
}
.placeholder\:oui-text-sm::-moz-placeholder {
  font-size: var(--oui-font-size-sm,0.875rem);
  line-height: 1.25rem;
}
.placeholder\:oui-text-sm::placeholder {
  font-size: var(--oui-font-size-sm,0.875rem);
  line-height: 1.25rem;
}
.placeholder\:oui-text-xs::-moz-placeholder {
  font-size: var(--oui-font-size-xs, calc(0.875rem - 1px));
  line-height: 1.25rem;
}
.placeholder\:oui-text-xs::placeholder {
  font-size: var(--oui-font-size-xs, calc(0.875rem - 1px));
  line-height: 1.25rem;
}
.placeholder\:oui-text-base-contrast-20::-moz-placeholder {
  color: rgb(var(--oui-color-base-foreground) / 0.2);
}
.placeholder\:oui-text-base-contrast-20::placeholder {
  color: rgb(var(--oui-color-base-foreground) / 0.2);
}
.placeholder\:oui-text-base-contrast-54::-moz-placeholder {
  color: rgb(var(--oui-color-base-foreground) / 0.54);
}
.placeholder\:oui-text-base-contrast-54::placeholder {
  color: rgb(var(--oui-color-base-foreground) / 0.54);
}
.before\:oui-absolute::before {
  content: var(--tw-content);
  position: absolute;
}
.before\:oui-end-\[-32px\]::before {
  content: var(--tw-content);
  inset-inline-end: -32px;
}
.before\:oui-start-\[-32px\]::before {
  content: var(--tw-content);
  inset-inline-start: -32px;
}
.before\:oui-top-0::before {
  content: var(--tw-content);
  top: 0px;
}
.before\:oui-z-\[-1\]::before {
  content: var(--tw-content);
  z-index: -1;
}
.before\:oui-block::before {
  content: var(--tw-content);
  display: block;
}
.before\:oui-h-full::before {
  content: var(--tw-content);
  height: 100%;
}
.before\:oui-w-\[32px\]::before {
  content: var(--tw-content);
  width: 32px;
}
.before\:oui-rotate-180::before {
  content: var(--tw-content);
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.before\:oui-bg-\[linear-gradient\(90deg\2c rgba\(var\(--oui-color-base-10\)_\/_0\.80\)_0\%\2c rgba\(var\(--oui-color-base-10\)_\/_0\.36\)_65\%\2c rgba\(var\(--oui-color-base-10\)_\/_0\.00\)_100\%\)\]::before {
  content: var(--tw-content);
  background-image: linear-gradient(90deg,rgba(var(--oui-color-base-10) / 0.80) 0%,rgba(var(--oui-color-base-10) / 0.36) 65%,rgba(var(--oui-color-base-10) / 0.00) 100%);
}
.after\:oui-absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\:oui-bottom-\[-8px\]::after {
  content: var(--tw-content);
  bottom: -8px;
}
.after\:oui-end-0::after {
  content: var(--tw-content);
  inset-inline-end: 0px;
}
.after\:oui-left-1\/2::after {
  content: var(--tw-content);
  left: 50%;
}
.after\:oui-start-0::after {
  content: var(--tw-content);
  inset-inline-start: 0px;
}
.after\:oui-top-0::after {
  content: var(--tw-content);
  top: 0px;
}
.after\:oui-top-\[2px\]::after {
  content: var(--tw-content);
  top: 2px;
}
.after\:oui-z-\[-1\]::after {
  content: var(--tw-content);
  z-index: -1;
}
.after\:oui-block::after {
  content: var(--tw-content);
  display: block;
}
.after\:oui-size-full::after {
  content: var(--tw-content);
  width: 100%;
  height: 100%;
}
.after\:\!oui-h-\[2px\]::after {
  content: var(--tw-content);
  height: 2px !important;
}
.after\:oui-h-0::after {
  content: var(--tw-content);
  height: 0px;
}
.after\:oui-h-\[2px\]::after {
  content: var(--tw-content);
  height: 2px;
}
.after\:oui-h-\[40px\]::after {
  content: var(--tw-content);
  height: 40px;
}
.after\:\!oui-w-\[2px\]::after {
  content: var(--tw-content);
  width: 2px !important;
}
.after\:oui-w-0::after {
  content: var(--tw-content);
  width: 0px;
}
.after\:oui-w-\[10px\]::after {
  content: var(--tw-content);
  width: 10px;
}
.after\:oui-w-full::after {
  content: var(--tw-content);
  width: 100%;
}
.after\:oui-translate-x-\[-50\%\]::after {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\:oui-rounded-e-lg::after {
  content: var(--tw-content);
  border-start-end-radius: var(--oui-rounded-lg, 0.5rem);
  border-end-end-radius: var(--oui-rounded-lg, 0.5rem);
}
.after\:oui-rounded-s-lg::after {
  content: var(--tw-content);
  border-start-start-radius: var(--oui-rounded-lg, 0.5rem);
  border-end-start-radius: var(--oui-rounded-lg, 0.5rem);
}
.after\:oui-border-4::after {
  content: var(--tw-content);
  border-width: 4px;
}
.after\:oui-border-y::after {
  content: var(--tw-content);
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.after\:oui-border-b::after {
  content: var(--tw-content);
  border-bottom-width: 1px;
}
.after\:oui-border-e::after {
  content: var(--tw-content);
  border-inline-end-width: 1px;
}
.after\:oui-border-s::after {
  content: var(--tw-content);
  border-inline-start-width: 1px;
}
.after\:oui-border-solid::after {
  content: var(--tw-content);
  border-style: solid;
}
.after\:oui-border-\[rgb\(var\(--oui-gradient-brand-start\)\)\]::after {
  content: var(--tw-content);
  border-color: rgb(var(--oui-gradient-brand-start));
}
.after\:oui-border-line::after {
  content: var(--tw-content);
  border-color: rgb(var(--oui-color-line, 255 255 255) / 0.08);
}
.after\:oui-border-transparent::after {
  content: var(--tw-content);
  border-color: transparent;
}
.after\:oui-border-t-danger::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-top-color: rgb(var(--oui-color-danger) / var(--tw-border-opacity, 1));
}
.after\:oui-border-t-inherit::after {
  content: var(--tw-content);
  border-top-color: inherit;
}
.after\:oui-border-t-primary::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-top-color: rgb(var(--oui-color-primary) / var(--tw-border-opacity, 1));
}
.after\:oui-border-t-primary-light::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-top-color: rgb(var(--oui-color-primary-light) / var(--tw-border-opacity, 1));
}
.after\:oui-border-t-success::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-top-color: rgb(var(--oui-color-success) / var(--tw-border-opacity, 1));
}
.after\:\!oui-bg-transparent::after {
  content: var(--tw-content);
  background-color: transparent !important;
}
.after\:\!oui-shadow-transparent::after {
  content: var(--tw-content);
  --tw-shadow-color: transparent !important;
  --tw-shadow: var(--tw-shadow-colored) !important;
}
.after\:oui-content-\[\'\'\]::after {
  --tw-content: '';
  content: var(--tw-content);
}
.autofill\:oui-bg-transparent:-webkit-autofill {
  background-color: transparent;
}
.autofill\:oui-bg-transparent:autofill {
  background-color: transparent;
}
.focus-within\:oui-relative:focus-within {
  position: relative;
}
.focus-within\:oui-z-20:focus-within {
  z-index: 20;
}
.focus-within\:oui-outline-0:focus-within {
  outline-width: 0px;
}
.focus-within\:oui-outline-danger:focus-within {
  outline-color: rgb(var(--oui-color-danger) / 1);
}
.focus-within\:oui-outline-danger-light:focus-within {
  outline-color: rgb(var(--oui-color-danger-light) / 1);
}
.focus-within\:oui-outline-line-12:focus-within {
  outline-color: rgb(var(--oui-color-line, 255 255 255) / 0.12);
}
.focus-within\:oui-outline-primary-darken:focus-within {
  outline-color: rgb(var(--oui-color-primary-darken) / 1);
}
.focus-within\:oui-outline-primary-light:focus-within {
  outline-color: rgb(var(--oui-color-primary-light) / 1);
}
.focus-within\:oui-outline-success:focus-within {
  outline-color: rgb(var(--oui-color-success) / 1);
}
.focus-within\:oui-outline-transparent:focus-within {
  outline-color: transparent;
}
.focus-within\:oui-outline-warning-darken:focus-within {
  outline-color: rgb(var(--oui-color-warning-darken) / 1);
}
.focus-within\:oui-outline-warning-light:focus-within {
  outline-color: rgb(var(--oui-color-warning-light) / 1);
}
.hover\:oui-cursor-pointer:hover {
  cursor: pointer;
}
.hover\:oui-rounded:hover {
  border-radius: var(--oui-rounded, 0.25rem);
}
.hover\:oui-rounded-md:hover {
  border-radius: var(--oui-rounded-md, 0.375rem);
}
.hover\:oui-border-base-contrast:hover {
  border-color: rgb(var(--oui-color-base-foreground) / 0.98);
}
.hover\:oui-border-base-contrast-16:hover {
  border-color: rgb(var(--oui-color-base-foreground) / 0.16);
}
.hover\:oui-border-line-12:hover {
  border-color: rgb(var(--oui-color-line, 255 255 255) / 0.12);
}
.hover\:oui-border-primary-light:hover {
  --tw-border-opacity: 1;
  border-color: rgb(var(--oui-color-primary-light) / var(--tw-border-opacity, 1));
}
.hover\:\!oui-bg-primary-light:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(var(--oui-color-primary-light) / var(--tw-bg-opacity, 1)) !important;
}
.hover\:oui-bg-\[rgb\(var\(--oui-gradient-brand-start\)\)\]\/\[0\.08\]:hover {
  background-color: rgb(var(--oui-gradient-brand-start) / 0.08);
}
.hover\:oui-bg-base-2\/10:hover {
  background-color: rgb(var(--oui-color-base-2) / 0.1);
}
.hover\:oui-bg-base-2\/50:hover {
  background-color: rgb(var(--oui-color-base-2) / 0.5);
}
.hover\:oui-bg-base-2\/80:hover {
  background-color: rgb(var(--oui-color-base-2) / 0.8);
}
.hover\:oui-bg-base-3:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-3) / var(--tw-bg-opacity, 1));
}
.hover\:oui-bg-base-3\/80:hover {
  background-color: rgb(var(--oui-color-base-3) / 0.8);
}
.hover\:oui-bg-base-4:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-4) / var(--tw-bg-opacity, 1));
}
.hover\:oui-bg-base-4\/20:hover {
  background-color: rgb(var(--oui-color-base-4) / 0.2);
}
.hover\:oui-bg-base-4\/80:hover {
  background-color: rgb(var(--oui-color-base-4) / 0.8);
}
.hover\:oui-bg-base-5:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-5) / var(--tw-bg-opacity, 1));
}
.hover\:oui-bg-base-6:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-6) / var(--tw-bg-opacity, 1));
}
.hover\:oui-bg-base-7:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-7) / var(--tw-bg-opacity, 1));
}
.hover\:oui-bg-base-8:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-8) / var(--tw-bg-opacity, 1));
}
.hover\:oui-bg-base-static-80:hover {
  background-color: rgb(var(--oui-color-base-static) / 0.80);
}
.hover\:oui-bg-danger-darken\/80:hover {
  background-color: rgb(var(--oui-color-danger-darken) / 0.8);
}
.hover\:oui-bg-danger\/10:hover {
  background-color: rgb(var(--oui-color-danger) / 0.1);
}
.hover\:oui-bg-danger\/20:hover {
  background-color: rgb(var(--oui-color-danger) / 0.2);
}
.hover\:oui-bg-danger\/80:hover {
  background-color: rgb(var(--oui-color-danger) / 0.8);
}
.hover\:oui-bg-primary-darken:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-primary-darken) / var(--tw-bg-opacity, 1));
}
.hover\:oui-bg-primary-darken\/10:hover {
  background-color: rgb(var(--oui-color-primary-darken) / 0.1);
}
.hover\:oui-bg-primary-darken\/20:hover {
  background-color: rgb(var(--oui-color-primary-darken) / 0.2);
}
.hover\:oui-bg-primary-darken\/80:hover {
  background-color: rgb(var(--oui-color-primary-darken) / 0.8);
}
.hover\:oui-bg-primary-light\/20:hover {
  background-color: rgb(var(--oui-color-primary-light) / 0.2);
}
.hover\:oui-bg-success-darken\/80:hover {
  background-color: rgb(var(--oui-color-success-darken) / 0.8);
}
.hover\:oui-bg-success\/10:hover {
  background-color: rgb(var(--oui-color-success) / 0.1);
}
.hover\:oui-bg-success\/20:hover {
  background-color: rgb(var(--oui-color-success) / 0.2);
}
.hover\:oui-bg-success\/80:hover {
  background-color: rgb(var(--oui-color-success) / 0.8);
}
.hover\:oui-bg-transparent:hover {
  background-color: transparent;
}
.hover\:oui-bg-warning-darken\/10:hover {
  background-color: rgb(var(--oui-color-warning-darken) / 0.1);
}
.hover\:oui-bg-warning-darken\/20:hover {
  background-color: rgb(var(--oui-color-warning-darken) / 0.2);
}
.hover\:oui-bg-warning-darken\/80:hover {
  background-color: rgb(var(--oui-color-warning-darken) / 0.8);
}
.hover\:oui-fill-base-contrast:hover {
  fill: rgb(var(--oui-color-base-foreground) / 0.98);
}
.hover\:oui-fill-base-contrast-80:hover {
  fill: rgb(var(--oui-color-base-foreground) / 0.80);
}
.hover\:oui-fill-primary-darken:hover {
  fill: rgb(var(--oui-color-primary-darken) / 1);
}
.hover\:oui-fill-primary-light:hover {
  fill: rgb(var(--oui-color-primary-light) / 1);
}
.hover\:oui-text-\[rgba\(255\2c 154\2c 46\2c 1\)\]:hover {
  color: rgba(255,154,46,1);
}
.hover\:oui-text-base-contrast:hover {
  color: rgb(var(--oui-color-base-foreground) / 0.98);
}
.hover\:oui-text-base-contrast-54:hover {
  color: rgb(var(--oui-color-base-foreground) / 0.54);
}
.hover\:oui-text-base-contrast-80:hover {
  color: rgb(var(--oui-color-base-foreground) / 0.80);
}
.hover\:oui-text-danger\/80:hover {
  color: rgb(var(--oui-color-danger) / 0.8);
}
.hover\:oui-text-primary-darken:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-primary-darken) / var(--tw-text-opacity, 1));
}
.hover\:oui-text-primary-darken\/80:hover {
  color: rgb(var(--oui-color-primary-darken) / 0.8);
}
.hover\:oui-text-secondary:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-secondary) / var(--tw-text-opacity, 1));
}
.hover\:oui-text-secondary\/80:hover {
  color: rgb(var(--oui-color-secondary) / 0.8);
}
.hover\:oui-text-success\/80:hover {
  color: rgb(var(--oui-color-success) / 0.8);
}
.hover\:oui-text-warning-darken:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-warning-darken) / var(--tw-text-opacity, 1));
}
.hover\:oui-text-warning-darken\/80:hover {
  color: rgb(var(--oui-color-warning-darken) / 0.8);
}
.hover\:oui-text-warning\/90:hover {
  color: rgb(var(--oui-color-warning) / 0.9);
}
.hover\:oui-text-white\/80:hover {
  color: rgb(255 255 255 / 0.8);
}
.hover\:oui-opacity-100:hover {
  opacity: 1;
}
.hover\:oui-opacity-80:hover {
  opacity: 0.8;
}
.hover\:\!oui-shadow-\[0px_0px_4px_0px\]:hover {
  --tw-shadow: 0px 0px 4px 0px !important;
  --tw-shadow-colored: 0px 0px 4px 0px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.hover\:\!oui-shadow-primary-light\/80:hover {
  --tw-shadow-color: rgb(var(--oui-color-primary-light) / 0.8) !important;
  --tw-shadow: var(--tw-shadow-colored) !important;
}
.focus\:oui-h-4:focus {
  height: 1rem;
}
.focus\:oui-h-\[14px\]:focus {
  height: 14px;
}
.focus\:oui-w-4:focus {
  width: 1rem;
}
.focus\:oui-w-\[14px\]:focus {
  width: 14px;
}
.focus\:oui-border-2:focus {
  border-width: 2px;
}
.focus\:oui-border-\[3px\]:focus {
  border-width: 3px;
}
.focus\:oui-border-primary-darken:focus {
  --tw-border-opacity: 1;
  border-color: rgb(var(--oui-color-primary-darken) / var(--tw-border-opacity, 1));
}
.focus\:\!oui-bg-primary-light:focus {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(var(--oui-color-primary-light) / var(--tw-bg-opacity, 1)) !important;
}
.focus\:\!oui-shadow-\[0px_0px_4px_0px\]:focus {
  --tw-shadow: 0px 0px 4px 0px !important;
  --tw-shadow-colored: 0px 0px 4px 0px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.focus\:oui-shadow-\[0_0_0_8px\]:focus {
  --tw-shadow: 0 0 0 8px;
  --tw-shadow-colored: 0 0 0 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\:\!oui-shadow-primary-light\/80:focus {
  --tw-shadow-color: rgb(var(--oui-color-primary-light) / 0.8) !important;
  --tw-shadow: var(--tw-shadow-colored) !important;
}
.focus\:oui-shadow-base-contrast\/20:focus {
  --tw-shadow-color: rgb(var(--oui-color-base-foreground) / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.focus\:oui-outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\:oui-ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\:oui-ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\:oui-ring-danger:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--oui-color-danger) / var(--tw-ring-opacity, 1));
}
.focus\:oui-ring-transparent:focus {
  --tw-ring-color: transparent;
}
.focus\:oui-ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}
.focus-visible\:oui-outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\:oui-outline-danger:focus-visible {
  outline-color: rgb(var(--oui-color-danger) / 1);
}
.focus-visible\:oui-ring-1:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\:oui-ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\:oui-ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}
.active\:\!oui-bg-primary-light:active {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(var(--oui-color-primary-light) / var(--tw-bg-opacity, 1)) !important;
}
.active\:oui-bg-\[rgb\(var\(--oui-gradient-brand-start\)\)\]\/\[0\.08\]:active {
  background-color: rgb(var(--oui-gradient-brand-start) / 0.08);
}
.active\:oui-bg-base-2\/70:active {
  background-color: rgb(var(--oui-color-base-2) / 0.7);
}
.active\:oui-bg-base-3\/70:active {
  background-color: rgb(var(--oui-color-base-3) / 0.7);
}
.active\:oui-bg-base-4\/70:active {
  background-color: rgb(var(--oui-color-base-4) / 0.7);
}
.active\:oui-bg-base-6:active {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-6) / var(--tw-bg-opacity, 1));
}
.active\:oui-bg-base-static-54:active {
  background-color: rgb(var(--oui-color-base-static) / 0.54);
}
.active\:oui-bg-danger-darken\/80:active {
  background-color: rgb(var(--oui-color-danger-darken) / 0.8);
}
.active\:oui-bg-danger\/70:active {
  background-color: rgb(var(--oui-color-danger) / 0.7);
}
.active\:oui-bg-primary-darken\/70:active {
  background-color: rgb(var(--oui-color-primary-darken) / 0.7);
}
.active\:oui-bg-success-darken\/80:active {
  background-color: rgb(var(--oui-color-success-darken) / 0.8);
}
.active\:oui-bg-success\/70:active {
  background-color: rgb(var(--oui-color-success) / 0.7);
}
.active\:oui-bg-warning-darken\/70:active {
  background-color: rgb(var(--oui-color-warning-darken) / 0.7);
}
.active\:oui-text-danger\/70:active {
  color: rgb(var(--oui-color-danger) / 0.7);
}
.active\:oui-text-primary-darken\/70:active {
  color: rgb(var(--oui-color-primary-darken) / 0.7);
}
.active\:oui-text-success\/70:active {
  color: rgb(var(--oui-color-success) / 0.7);
}
.active\:oui-text-warning-darken\/70:active {
  color: rgb(var(--oui-color-warning-darken) / 0.7);
}
.active\:oui-text-white\/70:active {
  color: rgb(255 255 255 / 0.7);
}
.active\:\!oui-shadow-\[0px_0px_4px_0px\]:active {
  --tw-shadow: 0px 0px 4px 0px !important;
  --tw-shadow-colored: 0px 0px 4px 0px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.active\:\!oui-shadow-primary-light\/80:active {
  --tw-shadow-color: rgb(var(--oui-color-primary-light) / 0.8) !important;
  --tw-shadow: var(--tw-shadow-colored) !important;
}
.active\:oui-outline-none:active {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.disabled\:oui-pointer-events-none:disabled {
  pointer-events: none;
}
.disabled\:oui-cursor-default:disabled {
  cursor: default;
}
.disabled\:oui-cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\:oui-border-base-contrast-16:disabled {
  border-color: rgb(var(--oui-color-base-foreground) / 0.16);
}
.disabled\:oui-bg-base-3:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-3) / var(--tw-bg-opacity, 1));
}
.disabled\:oui-bg-base-static-36:disabled {
  background-color: rgb(var(--oui-color-base-static) / 0.36);
}
.disabled\:oui-bg-transparent:disabled {
  background-color: transparent;
}
.disabled\:oui-text-base-contrast-20:disabled {
  color: rgb(var(--oui-color-base-foreground) / 0.2);
}
.disabled\:oui-text-base-contrast-36:disabled {
  color: rgb(var(--oui-color-base-foreground) / 0.36);
}
.disabled\:oui-text-base-static-contrast-36:disabled {
  color: rgb(var(--oui-color-base-static-contrast) / 0.36);
}
.disabled\:oui-opacity-30:disabled {
  opacity: 0.3;
}
.disabled\:oui-opacity-50:disabled {
  opacity: 0.5;
}
.disabled\:hover\:oui-bg-base-3:hover:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-3) / var(--tw-bg-opacity, 1));
}
.disabled\:hover\:oui-bg-transparent:hover:disabled {
  background-color: transparent;
}
.hover\:disabled\:oui-bg-base-static-36:disabled:hover {
  background-color: rgb(var(--oui-color-base-static) / 0.36);
}
.oui-group:first-child .group-first\:oui-rounded-t-xl {
  border-top-left-radius: var(--oui-rounded-xl, 0.75rem);
  border-top-right-radius: var(--oui-rounded-xl, 0.75rem);
}
.oui-group:last-child .group-last\:oui-rounded-b-xl {
  border-bottom-right-radius: var(--oui-rounded-xl, 0.75rem);
  border-bottom-left-radius: var(--oui-rounded-xl, 0.75rem);
}
.oui-group:hover .group-hover\:oui-visible {
  visibility: visible;
}
.oui-group:hover .group-hover\:oui-invisible {
  visibility: hidden;
}
.oui-group:hover .group-hover\:oui-block {
  display: block;
}
.oui-group:hover .group-hover\:oui-inline-flex {
  display: inline-flex;
}
.oui-group:hover .group-hover\:-oui-translate-x-5 {
  --tw-translate-x: -1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui-group:hover .group-hover\:oui-translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui-group:hover .group-hover\:oui-border-base-4 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--oui-color-base-4) / var(--tw-border-opacity, 1));
}
.oui-group:hover .group-hover\:oui-border-primary-light {
  --tw-border-opacity: 1;
  border-color: rgb(var(--oui-color-primary-light) / var(--tw-border-opacity, 1));
}
.oui-group:hover .group-hover\:oui-bg-base-4 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-4) / var(--tw-bg-opacity, 1));
}
.oui-group:hover .group-hover\:oui-bg-base-6 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-6) / var(--tw-bg-opacity, 1));
}
.oui-group:hover .group-hover\:oui-bg-line-4 {
  background-color: rgb(var(--oui-color-line, 255 255 255) / 0.04);
}
.oui-group:hover .group-hover\:oui-bg-line-6 {
  background-color: rgb(var(--oui-color-line, 255 255 255) / 0.06);
}
.oui-group:hover .group-hover\:oui-bg-transparent {
  background-color: transparent;
}
.oui-group\/icon:hover .group-hover\/icon\:oui-fill-primary-contrast {
  fill: rgb(var(--oui-color-primary-contrast) / 1);
}
.oui-group:hover .group-hover\:oui-fill-base-contrast-80 {
  fill: rgb(var(--oui-color-base-foreground) / 0.80);
}
.oui-group:hover .group-hover\:oui-text-base-contrast {
  color: rgb(var(--oui-color-base-foreground) / 0.98);
}
.oui-group:hover .group-hover\:oui-text-base-contrast-54 {
  color: rgb(var(--oui-color-base-foreground) / 0.54);
}
.oui-group:hover .group-hover\:oui-text-base-contrast-80 {
  color: rgb(var(--oui-color-base-foreground) / 0.80);
}
.oui-group:hover .group-hover\:oui-text-transparent {
  color: transparent;
}
.oui-group:hover .group-hover\:oui-opacity-100 {
  opacity: 1;
}
.oui-group:hover .group-hover\:oui-will-change-\[max-height\] {
  will-change: max-height;
}
.oui-group:focus .group-focus\:oui-inline-block {
  display: inline-block;
}
.oui-peer:focus ~ .peer-focus\:oui-visible {
  visibility: visible;
}
.has-\[\&\>\*\:nth-child\(1\)\]\:oui-bg-red-400:has(.has-\[\&\>\*\:nth-child\(1\)\]\:oui-bg-red-400>*:nth-child(1)) {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
.has-\[button\]\:oui-bg-red-50:has(button) {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.has-\[\&_\+_div\]\:oui-pb-3:has(.has-\[\&_\+_div\]\:oui-pb-3 + div) {
  padding-bottom: 0.75rem;
}
.aria-selected\:oui-opacity-100[aria-selected="true"] {
  opacity: 1;
}
.aria-selected\:oui-opacity-30[aria-selected="true"] {
  opacity: 0.3;
}
.data-\[disabled\]\:oui-pointer-events-none[data-disabled] {
  pointer-events: none;
}
.data-\[disabled\]\:oui-hidden[data-disabled] {
  display: none;
}
.data-\[side\=bottom\]\:oui-translate-y-1[data-side="bottom"] {
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\[side\=left\]\:-oui-translate-x-1[data-side="left"] {
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\[side\=right\]\:oui-translate-x-1[data-side="right"] {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\[side\=top\]\:-oui-translate-y-1[data-side="top"] {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\[state\=checked\]\:oui-translate-x-\[15px\][data-state="checked"] {
  --tw-translate-x: 15px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\[state\=unchecked\]\:oui-translate-x-\[3px\][data-state="unchecked"] {
  --tw-translate-x: 3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes oui-collapsible-up {

  from {
    height: var(--radix-collapsible-content-height);
  }

  to {
    height: 0;
  }
}
.data-\[state\=closed\]\:oui-animate-collapsible-up[data-state="closed"] {
  animation: oui-collapsible-up 0.2s ease-out;
}
@keyframes oui-collapsible-down {

  from {
    height: 0;
  }

  to {
    height: var(--radix-collapsible-content-height);
  }
}
.data-\[state\=open\]\:oui-animate-collapsible-down[data-state="open"] {
  animation: oui-collapsible-down 0.2s ease-out;
}
.data-\[state\=checked\]\:oui-border-none[data-state="checked"] {
  border-style: none;
}
.data-\[disabled\]\:oui-border-base-2[data-disabled] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--oui-color-base-2) / var(--tw-border-opacity, 1));
}
.data-\[state\=checked\]\:oui-border-base-contrast-20[data-state="checked"] {
  border-color: rgb(var(--oui-color-base-foreground) / 0.2);
}
.data-\[active\=true\]\:oui-bg-base-5[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-5) / var(--tw-bg-opacity, 1));
}
.data-\[disabled\]\:oui-bg-base-2[data-disabled] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-2) / var(--tw-bg-opacity, 1));
}
.data-\[state\=active\]\:oui-bg-base-5[data-state="active"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-5) / var(--tw-bg-opacity, 1));
}
.data-\[state\=checked\]\:oui-bg-base-5[data-state="checked"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-5) / var(--tw-bg-opacity, 1));
}
.data-\[state\=checked\]\:oui-bg-danger[data-state="checked"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-danger) / var(--tw-bg-opacity, 1));
}
.data-\[state\=checked\]\:oui-bg-primary-darken[data-state="checked"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-primary-darken) / var(--tw-bg-opacity, 1));
}
.data-\[state\=checked\]\:oui-bg-success[data-state="checked"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-success) / var(--tw-bg-opacity, 1));
}
.data-\[state\=checked\]\:oui-bg-transparent[data-state="checked"] {
  background-color: transparent;
}
.data-\[state\=checked\]\:oui-bg-warning-darken[data-state="checked"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-warning-darken) / var(--tw-bg-opacity, 1));
}
.data-\[state\=checked\]\:oui-bg-white\/80[data-state="checked"] {
  background-color: rgb(255 255 255 / 0.8);
}
.data-\[state\=open\]\:oui-bg-secondary[data-state="open"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-secondary) / var(--tw-bg-opacity, 1));
}
.data-\[state\=unchecked\]\:oui-bg-base-1[data-state="unchecked"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-1) / var(--tw-bg-opacity, 1));
}
.data-\[state\=unchecked\]\:oui-bg-danger[data-state="unchecked"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-danger) / var(--tw-bg-opacity, 1));
}
.data-\[state\=unchecked\]\:oui-bg-success[data-state="unchecked"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-success) / var(--tw-bg-opacity, 1));
}
.data-\[state\=unchecked\]\:oui-bg-warning-darken[data-state="unchecked"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-warning-darken) / var(--tw-bg-opacity, 1));
}
.data-\[state\=active\]\:oui-text-base-contrast[data-state="active"] {
  color: rgb(var(--oui-color-base-foreground) / 0.98);
}
.data-\[state\=checked\]\:oui-text-\[rgba\(0\2c 0\2c 0\2c 0\.88\)\][data-state="checked"] {
  color: rgba(0,0,0,0.88);
}
.data-\[state\=checked\]\:oui-text-base-contrast[data-state="checked"] {
  color: rgb(var(--oui-color-base-foreground) / 0.98);
}
.data-\[state\=checked\]\:oui-text-base-contrast-80[data-state="checked"] {
  color: rgb(var(--oui-color-base-foreground) / 0.80);
}
.data-\[state\=open\]\:oui-text-base-contrast-80[data-state="open"] {
  color: rgb(var(--oui-color-base-foreground) / 0.80);
}
.data-\[disabled\]\:oui-opacity-50[data-disabled] {
  opacity: 0.5;
}
.data-\[state\=open\]\:oui-duration-300[data-state="open"] {
  transition-duration: 300ms;
}
.data-\[state\=open\]\:oui-animate-in[data-state="open"] {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\[state\=closed\]\:oui-animate-out[data-state="closed"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\[state\=closed\]\:oui-fade-out-0[data-state="closed"] {
  --tw-exit-opacity: 0;
}
.data-\[state\=open\]\:oui-fade-in-0[data-state="open"] {
  --tw-enter-opacity: 0;
}
.data-\[state\=closed\]\:oui-zoom-out-95[data-state="closed"] {
  --tw-exit-scale: .95;
}
.data-\[state\=open\]\:oui-zoom-in-95[data-state="open"] {
  --tw-enter-scale: .95;
}
.data-\[side\=bottom\]\:oui-slide-in-from-top-2[data-side="bottom"] {
  --tw-enter-translate-y: -0.5rem;
}
.data-\[side\=left\]\:oui-slide-in-from-right-2[data-side="left"] {
  --tw-enter-translate-x: 0.5rem;
}
.data-\[side\=right\]\:oui-slide-in-from-left-2[data-side="right"] {
  --tw-enter-translate-x: -0.5rem;
}
.data-\[side\=top\]\:oui-slide-in-from-bottom-2[data-side="top"] {
  --tw-enter-translate-y: 0.5rem;
}
.data-\[state\=closed\]\:oui-slide-out-to-bottom[data-state="closed"] {
  --tw-exit-translate-y: 100%;
}
.data-\[state\=closed\]\:oui-slide-out-to-left[data-state="closed"] {
  --tw-exit-translate-x: -100%;
}
.data-\[state\=closed\]\:oui-slide-out-to-left-1\/2[data-state="closed"] {
  --tw-exit-translate-x: -50%;
}
.data-\[state\=closed\]\:oui-slide-out-to-right[data-state="closed"] {
  --tw-exit-translate-x: 100%;
}
.data-\[state\=closed\]\:oui-slide-out-to-top[data-state="closed"] {
  --tw-exit-translate-y: -100%;
}
.data-\[state\=closed\]\:oui-slide-out-to-top-\[48\%\][data-state="closed"] {
  --tw-exit-translate-y: -48%;
}
.data-\[state\=open\]\:oui-slide-in-from-bottom[data-state="open"] {
  --tw-enter-translate-y: 100%;
}
.data-\[state\=open\]\:oui-slide-in-from-left[data-state="open"] {
  --tw-enter-translate-x: -100%;
}
.data-\[state\=open\]\:oui-slide-in-from-left-1\/2[data-state="open"] {
  --tw-enter-translate-x: -50%;
}
.data-\[state\=open\]\:oui-slide-in-from-right[data-state="open"] {
  --tw-enter-translate-x: 100%;
}
.data-\[state\=open\]\:oui-slide-in-from-top[data-state="open"] {
  --tw-enter-translate-y: -100%;
}
.data-\[state\=open\]\:oui-slide-in-from-top-\[48\%\][data-state="open"] {
  --tw-enter-translate-y: -48%;
}
.data-\[state\=open\]\:oui-duration-300[data-state="open"] {
  animation-duration: 300ms;
}
.data-\[state\=active\]\:after\:oui-absolute[data-state="active"]::after {
  content: var(--tw-content);
  position: absolute;
}
.data-\[state\=active\]\:after\:-oui-bottom-0[data-state="active"]::after {
  content: var(--tw-content);
  bottom: -0px;
}
.data-\[state\=active\]\:after\:oui-end-0[data-state="active"]::after {
  content: var(--tw-content);
  inset-inline-end: 0px;
}
.data-\[state\=active\]\:after\:oui-start-0[data-state="active"]::after {
  content: var(--tw-content);
  inset-inline-start: 0px;
}
.data-\[state\=active\]\:after\:oui-block[data-state="active"]::after {
  content: var(--tw-content);
  display: block;
}
.data-\[state\=active\]\:after\:oui-h-\[3px\][data-state="active"]::after {
  content: var(--tw-content);
  height: 3px;
}
.data-\[state\=active\]\:after\:oui-rounded-full[data-state="active"]::after {
  content: var(--tw-content);
  border-radius: var(--oui-rounded-full, 9999px);
}
.data-\[state\=active\]\:after\:oui-bg-base-contrast[data-state="active"]::after {
  content: var(--tw-content);
  background-color: rgb(var(--oui-color-base-foreground) / 0.98);
}
.data-\[state\=active\]\:after\:oui-content-\[\'\'\][data-state="active"]::after {
  --tw-content: '';
  content: var(--tw-content);
}
.data-\[active\=false\]\:hover\:oui-bg-base-6:hover[data-active="false"] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-6) / var(--tw-bg-opacity, 1));
}
.oui-group[data-active="true"] .group-data-\[active\=true\]\:oui-visible {
  visibility: visible;
}
.oui-group[data-active="true"] .group-data-\[active\=true\]\:oui-invisible {
  visibility: hidden;
}
.oui-group[data-state="active"] .group-data-\[state\=active\]\:oui-block {
  display: block;
}
.oui-group\/bar[data-state="closed"] .group-data-\[state\=closed\]\/bar\:oui-w-\[42px\] {
  width: 42px;
}
.oui-group[data-open="true"] .group-data-\[open\=true\]\:oui-rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui-group[data-state="closed"] .group-data-\[state\=closed\]\:oui-rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui-group[data-state="open"] .group-data-\[state\=open\]\:oui-rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui-group[data-actived="true"] .group-data-\[actived\=true\]\:oui-fill-\[url\(\#side-menu-gradient\)\] {
  fill: url(#side-menu-gradient);
}
.oui-group[data-state="open"] .group-data-\[state\=open\]\:oui-fill-primary-light {
  fill: rgb(var(--oui-color-primary-light) / 1);
}
.oui-group[data-state="open"] .group-data-\[state\=open\]\:oui-font-semibold {
  font-weight: 600;
}
.oui-group[data-state="active"] .group-data-\[state\=active\]\:oui-text-base-contrast {
  color: rgb(var(--oui-color-base-foreground) / 0.98);
}
.oui-group[data-state="inactive"] .group-data-\[state\=inactive\]\:oui-text-base-contrast-36 {
  color: rgb(var(--oui-color-base-foreground) / 0.36);
}
.oui-peer[data-state="closed"] ~ .peer-data-\[state\=closed\]\:oui-rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui-peer[data-state="open"] ~ .peer-data-\[state\=open\]\:oui-rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.oui-peer[data-disabled] ~ .peer-data-\[disabled\]\:oui-text-base-contrast-20 {
  color: rgb(var(--oui-color-base-foreground) / 0.2);
}
.dark\:oui-text-gray-600:is(.oui-dark *) {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
@media (max-width: 400px) {

  .max-\[400px\]\:oui-text-\[15px\] {
    font-size: 15px;
  }
}
@media (min-width: 375px) {

  .sm\:oui-flex {
    display: flex;
  }

  .sm\:oui-inline-flex {
    display: inline-flex;
  }

  .sm\:oui-max-w-sm {
    max-width: var(--oui-spacing-sm, 22.5rem);
  }

  .sm\:oui-flex-row {
    flex-direction: row;
  }

  .sm\:oui-flex-row-reverse {
    flex-direction: row-reverse;
  }

  .sm\:oui-flex-col {
    flex-direction: column;
  }

  .sm\:oui-flex-col-reverse {
    flex-direction: column-reverse;
  }

  .sm\:oui-flex-wrap {
    flex-wrap: wrap;
  }

  .sm\:oui-flex-wrap-reverse {
    flex-wrap: wrap-reverse;
  }

  .sm\:oui-flex-nowrap {
    flex-wrap: nowrap;
  }

  .sm\:oui-items-start {
    align-items: flex-start;
  }

  .sm\:oui-items-end {
    align-items: flex-end;
  }

  .sm\:oui-items-center {
    align-items: center;
  }

  .sm\:oui-items-baseline {
    align-items: baseline;
  }

  .sm\:oui-items-stretch {
    align-items: stretch;
  }

  .sm\:oui-justify-start {
    justify-content: flex-start;
  }

  .sm\:oui-justify-end {
    justify-content: flex-end;
  }

  .sm\:oui-justify-center {
    justify-content: center;
  }

  .sm\:oui-justify-between {
    justify-content: space-between;
  }

  .sm\:oui-justify-around {
    justify-content: space-around;
  }

  .sm\:oui-justify-evenly {
    justify-content: space-evenly;
  }

  .sm\:oui-justify-stretch {
    justify-content: stretch;
  }

  .sm\:oui-gap-x-2 {
    -moz-column-gap: 0.5rem;
         column-gap: 0.5rem;
  }

  .sm\:oui-gap-x-4 {
    -moz-column-gap: 1rem;
         column-gap: 1rem;
  }

  .sm\:oui-space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\:oui-rounded-xl {
    border-radius: var(--oui-rounded-xl, 0.75rem);
  }
}
@media (min-width: 480px) {

  .md\:oui-bottom-10 {
    bottom: 2.5rem;
  }

  .md\:oui-end-3 {
    inset-inline-end: 0.75rem;
  }

  .md\:oui-end-4 {
    inset-inline-end: 1rem;
  }

  .md\:oui-start-auto {
    inset-inline-start: auto;
  }

  .md\:oui-top-1\/2 {
    top: 50%;
  }

  .md\:oui-order-1 {
    order: 1;
  }

  .md\:oui-order-2 {
    order: 2;
  }

  .md\:oui-m-3 {
    margin: 0.75rem;
  }

  .md\:oui-mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .md\:oui-mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .md\:oui-mt-10 {
    margin-top: 2.5rem;
  }

  .md\:oui-mt-3 {
    margin-top: 0.75rem;
  }

  .md\:oui-mt-5 {
    margin-top: 1.25rem;
  }

  .md\:oui-block {
    display: block;
  }

  .md\:oui-flex {
    display: flex;
  }

  .md\:oui-inline-flex {
    display: inline-flex;
  }

  .md\:oui-hidden {
    display: none;
  }

  .md\:oui-size-\[18px\] {
    width: 18px;
    height: 18px;
  }

  .md\:oui-size-\[480px\] {
    width: 480px;
    height: 480px;
  }

  .md\:oui-h-10 {
    height: 2.5rem;
  }

  .md\:oui-h-12 {
    height: 3rem;
  }

  .md\:oui-h-13 {
    height: 3.25rem;
  }

  .md\:oui-h-3 {
    height: 0.75rem;
  }

  .md\:oui-h-4 {
    height: 1rem;
  }

  .md\:oui-h-5 {
    height: 1.25rem;
  }

  .md\:oui-h-6 {
    height: 1.5rem;
  }

  .md\:oui-h-7 {
    height: 1.75rem;
  }

  .md\:oui-h-8 {
    height: 2rem;
  }

  .md\:oui-h-\[14px\] {
    height: 14px;
  }

  .md\:oui-h-\[240px\] {
    height: 240px;
  }

  .md\:oui-h-\[24px\] {
    height: 24px;
  }

  .md\:oui-h-\[46px\] {
    height: 46px;
  }

  .md\:oui-h-\[48px\] {
    height: 48px;
  }

  .md\:oui-h-\[52px\] {
    height: 52px;
  }

  .md\:oui-h-\[var\(--radix-select-trigger-height\)\] {
    height: var(--radix-select-trigger-height);
  }

  .md\:oui-h-full {
    height: 100%;
  }

  .md\:oui-min-h-\[180px\] {
    min-height: 180px;
  }

  .md\:oui-w-1\/2 {
    width: 50%;
  }

  .md\:oui-w-3 {
    width: 0.75rem;
  }

  .md\:oui-w-4 {
    width: 1rem;
  }

  .md\:oui-w-5 {
    width: 1.25rem;
  }

  .md\:oui-w-6 {
    width: 1.5rem;
  }

  .md\:oui-w-\[1040px\] {
    width: 1040px;
  }

  .md\:oui-w-\[14px\] {
    width: 14px;
  }

  .md\:oui-w-\[24px\] {
    width: 24px;
  }

  .md\:oui-w-\[300px\] {
    width: 300px;
  }

  .md\:oui-w-\[420px\] {
    width: 420px;
  }

  .md\:oui-w-auto {
    width: auto;
  }

  .md\:oui-w-fit {
    width: -moz-fit-content;
    width: fit-content;
  }

  .md\:oui-w-full {
    width: 100%;
  }

  .md\:oui-min-w-\[var\(--radix-select-trigger-width\)\] {
    min-width: var(--radix-select-trigger-width);
  }

  .md\:oui-max-w-\[1040px\] {
    max-width: 1040px;
  }

  .md\:oui-flex-shrink {
    flex-shrink: 1;
  }

  .md\:oui-translate-y-\[-50\%\] {
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .md\:oui-cursor-not-allowed {
    cursor: not-allowed;
  }

  .md\:oui-grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\:oui-grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\:oui-flex-row {
    flex-direction: row;
  }

  .md\:oui-flex-row-reverse {
    flex-direction: row-reverse;
  }

  .md\:oui-flex-col {
    flex-direction: column;
  }

  .md\:oui-flex-col-reverse {
    flex-direction: column-reverse;
  }

  .md\:oui-flex-wrap {
    flex-wrap: wrap;
  }

  .md\:oui-flex-wrap-reverse {
    flex-wrap: wrap-reverse;
  }

  .md\:oui-flex-nowrap {
    flex-wrap: nowrap;
  }

  .md\:oui-items-start {
    align-items: flex-start;
  }

  .md\:oui-items-end {
    align-items: flex-end;
  }

  .md\:oui-items-center {
    align-items: center;
  }

  .md\:oui-items-baseline {
    align-items: baseline;
  }

  .md\:oui-items-stretch {
    align-items: stretch;
  }

  .md\:oui-justify-start {
    justify-content: flex-start;
  }

  .md\:oui-justify-end {
    justify-content: flex-end;
  }

  .md\:oui-justify-center {
    justify-content: center;
  }

  .md\:oui-justify-between {
    justify-content: space-between;
  }

  .md\:oui-justify-around {
    justify-content: space-around;
  }

  .md\:oui-justify-evenly {
    justify-content: space-evenly;
  }

  .md\:oui-justify-stretch {
    justify-content: stretch;
  }

  .md\:oui-gap-10 {
    gap: 2.5rem;
  }

  .md\:oui-gap-5 {
    gap: 1.25rem;
  }

  .md\:oui-gap-6 {
    gap: 1.5rem;
  }

  .md\:oui-gap-x-3 {
    -moz-column-gap: 0.75rem;
         column-gap: 0.75rem;
  }

  .md\:oui-rounded {
    border-radius: var(--oui-rounded, 0.25rem);
  }

  .md\:oui-rounded-2xl {
    border-radius: var(--oui-rounded-2xl, 1rem);
  }

  .md\:oui-rounded-lg {
    border-radius: var(--oui-rounded-lg, 0.5rem);
  }

  .md\:oui-rounded-md {
    border-radius: var(--oui-rounded-md, 0.375rem);
  }

  .md\:oui-rounded-none {
    border-radius: 0;
  }

  .md\:oui-border {
    border-width: 1px;
  }

  .md\:oui-border-danger {
    --tw-border-opacity: 1;
    border-color: rgb(var(--oui-color-danger) / var(--tw-border-opacity, 1));
  }

  .md\:oui-border-line-6 {
    border-color: rgb(var(--oui-color-line, 255 255 255) / 0.06);
  }

  .md\:oui-bg-base-4 {
    --tw-bg-opacity: 1;
    background-color: rgb(var(--oui-color-base-4) / var(--tw-bg-opacity, 1));
  }

  .md\:oui-bg-base-5 {
    --tw-bg-opacity: 1;
    background-color: rgb(var(--oui-color-base-5) / var(--tw-bg-opacity, 1));
  }

  .md\:oui-bg-line-4 {
    background-color: rgb(var(--oui-color-line, 255 255 255) / 0.04);
  }

  .md\:oui-bg-transparent {
    background-color: transparent;
  }

  .md\:oui-p-10 {
    padding: 2.5rem;
  }

  .md\:oui-p-6 {
    padding: 1.5rem;
  }

  .md\:oui-px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .md\:oui-px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .md\:oui-px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\:oui-py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .md\:oui-py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .md\:oui-py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .md\:oui-py-\[38px\] {
    padding-top: 38px;
    padding-bottom: 38px;
  }

  .md\:oui-pb-\[14px\] {
    padding-bottom: 14px;
  }

  .md\:oui-pe-2 {
    padding-inline-end: 0.5rem;
  }

  .md\:oui-pe-3 {
    padding-inline-end: 0.75rem;
  }

  .md\:oui-pe-\[60px\] {
    padding-inline-end: 60px;
  }

  .md\:oui-pl-0 {
    padding-left: 0px;
  }

  .md\:oui-pl-3 {
    padding-left: 0.75rem;
  }

  .md\:oui-pr-0 {
    padding-right: 0px;
  }

  .md\:oui-pr-3 {
    padding-right: 0.75rem;
  }

  .md\:oui-ps-2 {
    padding-inline-start: 0.5rem;
  }

  .md\:oui-ps-4 {
    padding-inline-start: 1rem;
  }

  .md\:oui-pt-3 {
    padding-top: 0.75rem;
  }

  .md\:oui-text-center {
    text-align: center;
  }

  .md\:oui-text-start {
    text-align: start;
  }

  .md\:oui-text-end {
    text-align: end;
  }

  .md\:oui-text-2xl {
    font-size: var(--oui-font-size-2xl, 1.5rem);
    line-height: 2rem;
  }

  .md\:oui-text-2xs {
    font-size: var(--oui-font-size-2xs, 0.75rem);
    line-height: 1.125rem;
  }

  .md\:oui-text-3xl {
    font-size: var(--oui-font-size-3xl, 1.75rem);
    line-height: 2.25rem;
  }

  .md\:oui-text-6xl {
    font-size: var(--oui-font-size-6xl, 3rem);
    line-height: 3rem;
  }

  .md\:oui-text-\[20px\] {
    font-size: 20px;
  }

  .md\:oui-text-\[48px\] {
    font-size: 48px;
  }

  .md\:oui-text-base {
    font-size: var(--oui-font-size-base, 1rem);
    line-height: 1.5rem;
  }

  .md\:oui-text-lg {
    font-size: var(--oui-font-size-lg, 1.125rem);
    line-height: 1.625rem;
  }

  .md\:oui-text-sm {
    font-size: var(--oui-font-size-sm,0.875rem);
    line-height: 1.25rem;
  }

  .md\:oui-text-xl {
    font-size: var(--oui-font-size-xl, 1.25rem);
    line-height: 1.75rem;
  }

  .md\:oui-text-xs {
    font-size: var(--oui-font-size-xs, calc(0.875rem - 1px));
    line-height: 1.25rem;
  }

  .md\:oui-leading-\[28px\] {
    line-height: 28px;
  }

  .md\:oui-leading-\[56px\] {
    line-height: 56px;
  }

  .md\:oui-leading-\[72px\] {
    line-height: 72px;
  }

  .md\:oui-text-base-10 {
    --tw-text-opacity: 1;
    color: rgb(var(--oui-color-base-10) / var(--tw-text-opacity, 1));
  }

  .md\:oui-text-base-contrast {
    color: rgb(var(--oui-color-base-foreground) / 0.98);
  }

  .md\:oui-text-base-contrast-20 {
    color: rgb(var(--oui-color-base-foreground) / 0.2);
  }

  .md\:oui-text-base-contrast-80 {
    color: rgb(var(--oui-color-base-foreground) / 0.80);
  }

  .md\:oui-text-danger {
    --tw-text-opacity: 1;
    color: rgb(var(--oui-color-danger) / var(--tw-text-opacity, 1));
  }

  .md\:oui-text-success {
    --tw-text-opacity: 1;
    color: rgb(var(--oui-color-success) / var(--tw-text-opacity, 1));
  }

  .md\:oui-text-warning-darken {
    --tw-text-opacity: 1;
    color: rgb(var(--oui-color-warning-darken) / var(--tw-text-opacity, 1));
  }

  .md\:oui-outline-danger {
    outline-color: rgb(var(--oui-color-danger) / 1);
  }

  .md\:oui-outline-success {
    outline-color: rgb(var(--oui-color-success) / 1);
  }

  .md\:oui-outline-transparent {
    outline-color: transparent;
  }

  .md\:oui-outline-warning-darken {
    outline-color: rgb(var(--oui-color-warning-darken) / 1);
  }

  .md\:oui-gradient-brand {
    background-image: linear-gradient(var(--oui-gradient-brand-angle, 17.44deg), rgb(var(--oui-gradient-brand-start)) var(--oui-gradient-brand-stop-start,0%), rgb(var(--oui-gradient-brand-end)) var(--oui-gradient-brand-stop-end,100%));
  }

  .md\:placeholder\:oui-text-2xs::-moz-placeholder {
    font-size: var(--oui-font-size-2xs, 0.75rem);
    line-height: 1.125rem;
  }

  .md\:placeholder\:oui-text-2xs::placeholder {
    font-size: var(--oui-font-size-2xs, 0.75rem);
    line-height: 1.125rem;
  }

  .md\:placeholder\:oui-text-base::-moz-placeholder {
    font-size: var(--oui-font-size-base, 1rem);
    line-height: 1.5rem;
  }

  .md\:placeholder\:oui-text-base::placeholder {
    font-size: var(--oui-font-size-base, 1rem);
    line-height: 1.5rem;
  }

  .md\:placeholder\:oui-text-sm::-moz-placeholder {
    font-size: var(--oui-font-size-sm,0.875rem);
    line-height: 1.25rem;
  }

  .md\:placeholder\:oui-text-sm::placeholder {
    font-size: var(--oui-font-size-sm,0.875rem);
    line-height: 1.25rem;
  }

  .md\:after\:oui-h-\[48px\]::after {
    content: var(--tw-content);
    height: 48px;
  }

  .md\:focus-within\:oui-outline-danger:focus-within {
    outline-color: rgb(var(--oui-color-danger) / 1);
  }

  .md\:focus-within\:oui-outline-success:focus-within {
    outline-color: rgb(var(--oui-color-success) / 1);
  }

  .md\:focus-within\:oui-outline-warning-darken:focus-within {
    outline-color: rgb(var(--oui-color-warning-darken) / 1);
  }

  .md\:hover\:oui-bg-base-2\/80:hover {
    background-color: rgb(var(--oui-color-base-2) / 0.8);
  }

  .md\:hover\:oui-bg-base-4\/80:hover {
    background-color: rgb(var(--oui-color-base-4) / 0.8);
  }

  .md\:hover\:oui-bg-base-static-80:hover {
    background-color: rgb(var(--oui-color-base-static) / 0.80);
  }

  .md\:hover\:oui-bg-danger\/80:hover {
    background-color: rgb(var(--oui-color-danger) / 0.8);
  }

  .md\:hover\:oui-bg-primary-darken\/80:hover {
    background-color: rgb(var(--oui-color-primary-darken) / 0.8);
  }

  .md\:hover\:oui-bg-success\/80:hover {
    background-color: rgb(var(--oui-color-success) / 0.8);
  }

  .md\:hover\:oui-bg-warning-darken\/80:hover {
    background-color: rgb(var(--oui-color-warning-darken) / 0.8);
  }

  .md\:focus\:oui-ring-danger:focus {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(var(--oui-color-danger) / var(--tw-ring-opacity, 1));
  }

  .md\:active\:oui-bg-base-2\/70:active {
    background-color: rgb(var(--oui-color-base-2) / 0.7);
  }

  .md\:active\:oui-bg-base-4\/70:active {
    background-color: rgb(var(--oui-color-base-4) / 0.7);
  }

  .md\:active\:oui-bg-base-static-54:active {
    background-color: rgb(var(--oui-color-base-static) / 0.54);
  }

  .md\:active\:oui-bg-danger\/70:active {
    background-color: rgb(var(--oui-color-danger) / 0.7);
  }

  .md\:active\:oui-bg-primary-darken\/70:active {
    background-color: rgb(var(--oui-color-primary-darken) / 0.7);
  }

  .md\:active\:oui-bg-success\/70:active {
    background-color: rgb(var(--oui-color-success) / 0.7);
  }

  .md\:active\:oui-bg-warning-darken\/70:active {
    background-color: rgb(var(--oui-color-warning-darken) / 0.7);
  }

  .md\:data-\[side\=bottom\]\:oui-translate-y-1[data-side="bottom"] {
    --tw-translate-y: 0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .md\:data-\[side\=left\]\:-oui-translate-x-1[data-side="left"] {
    --tw-translate-x: -0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .md\:data-\[side\=right\]\:oui-translate-x-1[data-side="right"] {
    --tw-translate-x: 0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .md\:data-\[side\=top\]\:-oui-translate-y-1[data-side="top"] {
    --tw-translate-y: -0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
}
@media (min-width: 768px) {

  .lg\:oui-bottom-\[-24px\] {
    bottom: -24px;
  }

  .lg\:oui-top-\[-24px\] {
    top: -24px;
  }

  .lg\:oui-mb-8 {
    margin-bottom: 2rem;
  }

  .lg\:oui-flex {
    display: flex;
  }

  .lg\:oui-inline-flex {
    display: inline-flex;
  }

  .lg\:oui-size-5 {
    width: 1.25rem;
    height: 1.25rem;
  }

  .lg\:oui-size-\[20px\] {
    width: 20px;
    height: 20px;
  }

  .lg\:\!oui-h-\[700px\] {
    height: 700px !important;
  }

  .lg\:oui-h-10 {
    height: 2.5rem;
  }

  .lg\:oui-h-12 {
    height: 3rem;
  }

  .lg\:oui-h-13 {
    height: 3.25rem;
  }

  .lg\:oui-h-3 {
    height: 0.75rem;
  }

  .lg\:oui-h-4 {
    height: 1rem;
  }

  .lg\:oui-h-5 {
    height: 1.25rem;
  }

  .lg\:oui-h-6 {
    height: 1.5rem;
  }

  .lg\:oui-h-7 {
    height: 1.75rem;
  }

  .lg\:oui-h-8 {
    height: 2rem;
  }

  .lg\:oui-h-\[28px\] {
    height: 28px;
  }

  .lg\:oui-h-\[var\(--radix-select-trigger-height\)\] {
    height: var(--radix-select-trigger-height);
  }

  .lg\:oui-min-h-\[320px\] {
    min-height: 320px;
  }

  .lg\:oui-min-h-\[46px\] {
    min-height: 46px;
  }

  .lg\:oui-w-3 {
    width: 0.75rem;
  }

  .lg\:oui-w-4 {
    width: 1rem;
  }

  .lg\:oui-w-5 {
    width: 1.25rem;
  }

  .lg\:oui-w-6 {
    width: 1.5rem;
  }

  .lg\:oui-w-7 {
    width: 1.75rem;
  }

  .lg\:oui-w-\[154px\] {
    width: 154px;
  }

  .lg\:oui-w-\[184px\] {
    width: 184px;
  }

  .lg\:oui-w-\[28px\] {
    width: 28px;
  }

  .lg\:oui-w-\[360px\] {
    width: 360px;
  }

  .lg\:oui-w-\[calc\(\(100\%_-_8px\)\/3\)\] {
    width: calc((100% - 8px) / 3);
  }

  .lg\:oui-w-auto {
    width: auto;
  }

  .lg\:oui-w-full {
    width: 100%;
  }

  .lg\:oui-min-w-\[184px\] {
    min-width: 184px;
  }

  .lg\:oui-min-w-\[var\(--radix-select-trigger-width\)\] {
    min-width: var(--radix-select-trigger-width);
  }

  .lg\:oui-max-w-\[640px\] {
    max-width: 640px;
  }

  .lg\:oui-cursor-not-allowed {
    cursor: not-allowed;
  }

  .lg\:oui-flex-row {
    flex-direction: row;
  }

  .lg\:oui-flex-row-reverse {
    flex-direction: row-reverse;
  }

  .lg\:oui-flex-col {
    flex-direction: column;
  }

  .lg\:oui-flex-col-reverse {
    flex-direction: column-reverse;
  }

  .lg\:oui-flex-wrap {
    flex-wrap: wrap;
  }

  .lg\:oui-flex-wrap-reverse {
    flex-wrap: wrap-reverse;
  }

  .lg\:oui-flex-nowrap {
    flex-wrap: nowrap;
  }

  .lg\:oui-items-start {
    align-items: flex-start;
  }

  .lg\:oui-items-end {
    align-items: flex-end;
  }

  .lg\:oui-items-center {
    align-items: center;
  }

  .lg\:oui-items-baseline {
    align-items: baseline;
  }

  .lg\:oui-items-stretch {
    align-items: stretch;
  }

  .lg\:oui-justify-start {
    justify-content: flex-start;
  }

  .lg\:oui-justify-end {
    justify-content: flex-end;
  }

  .lg\:oui-justify-center {
    justify-content: center;
  }

  .lg\:oui-justify-between {
    justify-content: space-between;
  }

  .lg\:oui-justify-around {
    justify-content: space-around;
  }

  .lg\:oui-justify-evenly {
    justify-content: space-evenly;
  }

  .lg\:oui-justify-stretch {
    justify-content: stretch;
  }

  .lg\:oui-gap-3 {
    gap: 0.75rem;
  }

  .lg\:oui-gap-4 {
    gap: 1rem;
  }

  .lg\:oui-gap-x-2 {
    -moz-column-gap: 0.5rem;
         column-gap: 0.5rem;
  }

  .lg\:oui-gap-y-2 {
    row-gap: 0.5rem;
  }

  .lg\:oui-rounded {
    border-radius: var(--oui-rounded, 0.25rem);
  }

  .lg\:oui-rounded-2xl {
    border-radius: var(--oui-rounded-2xl, 1rem);
  }

  .lg\:oui-rounded-lg {
    border-radius: var(--oui-rounded-lg, 0.5rem);
  }

  .lg\:oui-rounded-md {
    border-radius: var(--oui-rounded-md, 0.375rem);
  }

  .lg\:oui-border {
    border-width: 1px;
  }

  .lg\:oui-border-b {
    border-bottom-width: 1px;
  }

  .lg\:oui-border-danger {
    --tw-border-opacity: 1;
    border-color: rgb(var(--oui-color-danger) / var(--tw-border-opacity, 1));
  }

  .lg\:oui-border-line-6 {
    border-color: rgb(var(--oui-color-line, 255 255 255) / 0.06);
  }

  .lg\:oui-border-b-white\/\[0\.12\] {
    border-bottom-color: rgb(255 255 255 / 0.12);
  }

  .lg\:oui-bg-base-4 {
    --tw-bg-opacity: 1;
    background-color: rgb(var(--oui-color-base-4) / var(--tw-bg-opacity, 1));
  }

  .lg\:oui-bg-base-5 {
    --tw-bg-opacity: 1;
    background-color: rgb(var(--oui-color-base-5) / var(--tw-bg-opacity, 1));
  }

  .lg\:oui-bg-line-4 {
    background-color: rgb(var(--oui-color-line, 255 255 255) / 0.04);
  }

  .lg\:oui-bg-transparent {
    background-color: transparent;
  }

  .lg\:oui-p-5 {
    padding: 1.25rem;
  }

  .lg\:oui-p-6 {
    padding: 1.5rem;
  }

  .lg\:oui-px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .lg\:oui-px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .lg\:oui-px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .lg\:oui-px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .lg\:oui-px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .lg\:oui-px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\:oui-py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .lg\:oui-py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .lg\:oui-py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .lg\:oui-pb-2 {
    padding-bottom: 0.5rem;
  }

  .lg\:oui-pl-0 {
    padding-left: 0px;
  }

  .lg\:oui-pl-3 {
    padding-left: 0.75rem;
  }

  .lg\:oui-pr-0 {
    padding-right: 0px;
  }

  .lg\:oui-pr-3 {
    padding-right: 0.75rem;
  }

  .lg\:oui-pt-0 {
    padding-top: 0px;
  }

  .lg\:oui-pt-3 {
    padding-top: 0.75rem;
  }

  .lg\:oui-pt-4 {
    padding-top: 1rem;
  }

  .lg\:oui-text-center {
    text-align: center;
  }

  .lg\:oui-text-start {
    text-align: start;
  }

  .lg\:oui-text-end {
    text-align: end;
  }

  .lg\:oui-text-2xl {
    font-size: var(--oui-font-size-2xl, 1.5rem);
    line-height: 2rem;
  }

  .lg\:oui-text-2xs {
    font-size: var(--oui-font-size-2xs, 0.75rem);
    line-height: 1.125rem;
  }

  .lg\:oui-text-4xl {
    font-size: var(--oui-font-size-4xl, 1.875rem);
    line-height: 2.375rem;
  }

  .lg\:oui-text-\[16px\] {
    font-size: 16px;
  }

  .lg\:oui-text-\[24px\] {
    font-size: 24px;
  }

  .lg\:oui-text-\[48px\] {
    font-size: 48px;
  }

  .lg\:oui-text-\[56px\] {
    font-size: 56px;
  }

  .lg\:oui-text-base {
    font-size: var(--oui-font-size-base, 1rem);
    line-height: 1.5rem;
  }

  .lg\:oui-text-lg {
    font-size: var(--oui-font-size-lg, 1.125rem);
    line-height: 1.625rem;
  }

  .lg\:oui-text-sm {
    font-size: var(--oui-font-size-sm,0.875rem);
    line-height: 1.25rem;
  }

  .lg\:oui-text-xl {
    font-size: var(--oui-font-size-xl, 1.25rem);
    line-height: 1.75rem;
  }

  .lg\:oui-text-xs {
    font-size: var(--oui-font-size-xs, calc(0.875rem - 1px));
    line-height: 1.25rem;
  }

  .lg\:oui-leading-\[24px\] {
    line-height: 24px;
  }

  .lg\:oui-leading-\[32px\] {
    line-height: 32px;
  }

  .lg\:oui-leading-\[56px\] {
    line-height: 56px;
  }

  .lg\:oui-text-base-10 {
    --tw-text-opacity: 1;
    color: rgb(var(--oui-color-base-10) / var(--tw-text-opacity, 1));
  }

  .lg\:oui-text-base-contrast {
    color: rgb(var(--oui-color-base-foreground) / 0.98);
  }

  .lg\:oui-text-base-contrast-20 {
    color: rgb(var(--oui-color-base-foreground) / 0.2);
  }

  .lg\:oui-text-danger {
    --tw-text-opacity: 1;
    color: rgb(var(--oui-color-danger) / var(--tw-text-opacity, 1));
  }

  .lg\:oui-text-success {
    --tw-text-opacity: 1;
    color: rgb(var(--oui-color-success) / var(--tw-text-opacity, 1));
  }

  .lg\:oui-text-warning-darken {
    --tw-text-opacity: 1;
    color: rgb(var(--oui-color-warning-darken) / var(--tw-text-opacity, 1));
  }

  .lg\:oui-outline-danger {
    outline-color: rgb(var(--oui-color-danger) / 1);
  }

  .lg\:oui-outline-success {
    outline-color: rgb(var(--oui-color-success) / 1);
  }

  .lg\:oui-outline-transparent {
    outline-color: transparent;
  }

  .lg\:oui-outline-warning-darken {
    outline-color: rgb(var(--oui-color-warning-darken) / 1);
  }

  .lg\:oui-gradient-brand {
    background-image: linear-gradient(var(--oui-gradient-brand-angle, 17.44deg), rgb(var(--oui-gradient-brand-start)) var(--oui-gradient-brand-stop-start,0%), rgb(var(--oui-gradient-brand-end)) var(--oui-gradient-brand-stop-end,100%));
  }

  .lg\:placeholder\:oui-text-2xs::-moz-placeholder {
    font-size: var(--oui-font-size-2xs, 0.75rem);
    line-height: 1.125rem;
  }

  .lg\:placeholder\:oui-text-2xs::placeholder {
    font-size: var(--oui-font-size-2xs, 0.75rem);
    line-height: 1.125rem;
  }

  .lg\:placeholder\:oui-text-base::-moz-placeholder {
    font-size: var(--oui-font-size-base, 1rem);
    line-height: 1.5rem;
  }

  .lg\:placeholder\:oui-text-base::placeholder {
    font-size: var(--oui-font-size-base, 1rem);
    line-height: 1.5rem;
  }

  .lg\:placeholder\:oui-text-sm::-moz-placeholder {
    font-size: var(--oui-font-size-sm,0.875rem);
    line-height: 1.25rem;
  }

  .lg\:placeholder\:oui-text-sm::placeholder {
    font-size: var(--oui-font-size-sm,0.875rem);
    line-height: 1.25rem;
  }

  .lg\:focus-within\:oui-outline-danger:focus-within {
    outline-color: rgb(var(--oui-color-danger) / 1);
  }

  .lg\:focus-within\:oui-outline-success:focus-within {
    outline-color: rgb(var(--oui-color-success) / 1);
  }

  .lg\:focus-within\:oui-outline-warning-darken:focus-within {
    outline-color: rgb(var(--oui-color-warning-darken) / 1);
  }

  .lg\:hover\:oui-bg-base-2\/80:hover {
    background-color: rgb(var(--oui-color-base-2) / 0.8);
  }

  .lg\:hover\:oui-bg-base-4\/80:hover {
    background-color: rgb(var(--oui-color-base-4) / 0.8);
  }

  .lg\:hover\:oui-bg-base-static-80:hover {
    background-color: rgb(var(--oui-color-base-static) / 0.80);
  }

  .lg\:hover\:oui-bg-danger\/80:hover {
    background-color: rgb(var(--oui-color-danger) / 0.8);
  }

  .lg\:hover\:oui-bg-primary-darken\/80:hover {
    background-color: rgb(var(--oui-color-primary-darken) / 0.8);
  }

  .lg\:hover\:oui-bg-success\/80:hover {
    background-color: rgb(var(--oui-color-success) / 0.8);
  }

  .lg\:hover\:oui-bg-warning-darken\/80:hover {
    background-color: rgb(var(--oui-color-warning-darken) / 0.8);
  }

  .lg\:focus\:oui-ring-danger:focus {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(var(--oui-color-danger) / var(--tw-ring-opacity, 1));
  }

  .lg\:active\:oui-bg-base-2\/70:active {
    background-color: rgb(var(--oui-color-base-2) / 0.7);
  }

  .lg\:active\:oui-bg-base-4\/70:active {
    background-color: rgb(var(--oui-color-base-4) / 0.7);
  }

  .lg\:active\:oui-bg-base-static-54:active {
    background-color: rgb(var(--oui-color-base-static) / 0.54);
  }

  .lg\:active\:oui-bg-danger\/70:active {
    background-color: rgb(var(--oui-color-danger) / 0.7);
  }

  .lg\:active\:oui-bg-primary-darken\/70:active {
    background-color: rgb(var(--oui-color-primary-darken) / 0.7);
  }

  .lg\:active\:oui-bg-success\/70:active {
    background-color: rgb(var(--oui-color-success) / 0.7);
  }

  .lg\:active\:oui-bg-warning-darken\/70:active {
    background-color: rgb(var(--oui-color-warning-darken) / 0.7);
  }

  .lg\:data-\[side\=bottom\]\:oui-translate-y-1[data-side="bottom"] {
    --tw-translate-y: 0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\:data-\[side\=left\]\:-oui-translate-x-1[data-side="left"] {
    --tw-translate-x: -0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\:data-\[side\=right\]\:oui-translate-x-1[data-side="right"] {
    --tw-translate-x: 0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\:data-\[side\=top\]\:-oui-translate-y-1[data-side="top"] {
    --tw-translate-y: -0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
}
@media (min-width: 1024px) {

  .xl\:oui-flex {
    display: flex;
  }

  .xl\:oui-inline-flex {
    display: inline-flex;
  }

  .xl\:oui-grid {
    display: grid;
  }

  .xl\:oui-size-\[24px\] {
    width: 24px;
    height: 24px;
  }

  .xl\:oui-size-\[90px\] {
    width: 90px;
    height: 90px;
  }

  .xl\:oui-h-4 {
    height: 1rem;
  }

  .xl\:oui-h-8 {
    height: 2rem;
  }

  .xl\:oui-h-\[64px\] {
    height: 64px;
  }

  .xl\:oui-w-4 {
    width: 1rem;
  }

  .xl\:oui-w-8 {
    width: 2rem;
  }

  .xl\:oui-w-\[64px\] {
    width: 64px;
  }

  .xl\:oui-w-full {
    width: 100%;
  }

  .xl\:oui-flex-1 {
    flex: 1 1 0%;
  }

  .xl\:-oui-rotate-90 {
    --tw-rotate: -90deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .xl\:oui-grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\:oui-grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\:oui-flex-row {
    flex-direction: row;
  }

  .xl\:oui-flex-row-reverse {
    flex-direction: row-reverse;
  }

  .xl\:oui-flex-col {
    flex-direction: column;
  }

  .xl\:oui-flex-col-reverse {
    flex-direction: column-reverse;
  }

  .xl\:oui-flex-wrap {
    flex-wrap: wrap;
  }

  .xl\:oui-flex-wrap-reverse {
    flex-wrap: wrap-reverse;
  }

  .xl\:oui-flex-nowrap {
    flex-wrap: nowrap;
  }

  .xl\:oui-items-start {
    align-items: flex-start;
  }

  .xl\:oui-items-end {
    align-items: flex-end;
  }

  .xl\:oui-items-center {
    align-items: center;
  }

  .xl\:oui-items-baseline {
    align-items: baseline;
  }

  .xl\:oui-items-stretch {
    align-items: stretch;
  }

  .xl\:oui-justify-start {
    justify-content: flex-start;
  }

  .xl\:oui-justify-end {
    justify-content: flex-end;
  }

  .xl\:oui-justify-center {
    justify-content: center;
  }

  .xl\:oui-justify-between {
    justify-content: space-between;
  }

  .xl\:oui-justify-around {
    justify-content: space-around;
  }

  .xl\:oui-justify-evenly {
    justify-content: space-evenly;
  }

  .xl\:oui-justify-stretch {
    justify-content: stretch;
  }

  .xl\:oui-gap-\[36px\] {
    gap: 36px;
  }

  .xl\:oui-gap-\[6px\] {
    gap: 6px;
  }

  .xl\:oui-gap-x-\[6px\] {
    -moz-column-gap: 6px;
         column-gap: 6px;
  }

  .xl\:oui-space-y-1 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
  }

  .xl\:oui-space-y-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
  }

  .xl\:oui-p-3 {
    padding: 0.75rem;
  }

  .xl\:oui-px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .xl\:oui-pt-2 {
    padding-top: 0.5rem;
  }

  .xl\:oui-text-center {
    text-align: center;
  }

  .xl\:oui-text-2xl {
    font-size: var(--oui-font-size-2xl, 1.5rem);
    line-height: 2rem;
  }

  .xl\:oui-text-3xl {
    font-size: var(--oui-font-size-3xl, 1.75rem);
    line-height: 2.25rem;
  }

  .xl\:oui-text-5xl {
    font-size: var(--oui-font-size-5xl, 2.25rem);
    line-height: 2.75rem;
  }

  .xl\:oui-text-\[32px\] {
    font-size: 32px;
  }

  .xl\:oui-text-\[36px\] {
    font-size: 36px;
  }

  .xl\:oui-text-base {
    font-size: var(--oui-font-size-base, 1rem);
    line-height: 1.5rem;
  }

  .xl\:oui-text-lg {
    font-size: var(--oui-font-size-lg, 1.125rem);
    line-height: 1.625rem;
  }

  .xl\:oui-text-sm {
    font-size: var(--oui-font-size-sm,0.875rem);
    line-height: 1.25rem;
  }

  .xl\:oui-text-xs {
    font-size: var(--oui-font-size-xs, calc(0.875rem - 1px));
    line-height: 1.25rem;
  }

  .xl\:oui-leading-\[24px\] {
    line-height: 24px;
  }

  .xl\:oui-leading-\[44px\] {
    line-height: 44px;
  }

  .min-\[1024px\]\:oui-grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (min-width: 1280px) {

  .\32xl\:oui-flex {
    display: flex;
  }

  .\32xl\:oui-inline-flex {
    display: inline-flex;
  }

  .\32xl\:oui-size-auto {
    width: auto;
    height: auto;
  }

  .\32xl\:oui-h-\[196px\] {
    height: 196px;
  }

  .\32xl\:oui-h-\[80px\] {
    height: 80px;
  }

  .\32xl\:oui-h-full {
    height: 100%;
  }

  .\32xl\:oui-max-h-\[230px\] {
    max-height: 230px;
  }

  .\32xl\:oui-w-\[80px\] {
    width: 80px;
  }

  .\32xl\:oui-flex-1 {
    flex: 1 1 0%;
  }

  .\32xl\:oui-flex-row {
    flex-direction: row;
  }

  .\32xl\:oui-flex-row-reverse {
    flex-direction: row-reverse;
  }

  .\32xl\:oui-flex-col {
    flex-direction: column;
  }

  .\32xl\:oui-flex-col-reverse {
    flex-direction: column-reverse;
  }

  .\32xl\:oui-flex-wrap {
    flex-wrap: wrap;
  }

  .\32xl\:oui-flex-wrap-reverse {
    flex-wrap: wrap-reverse;
  }

  .\32xl\:oui-flex-nowrap {
    flex-wrap: nowrap;
  }

  .\32xl\:oui-items-start {
    align-items: flex-start;
  }

  .\32xl\:oui-items-end {
    align-items: flex-end;
  }

  .\32xl\:oui-items-center {
    align-items: center;
  }

  .\32xl\:oui-items-baseline {
    align-items: baseline;
  }

  .\32xl\:oui-items-stretch {
    align-items: stretch;
  }

  .\32xl\:oui-justify-start {
    justify-content: flex-start;
  }

  .\32xl\:oui-justify-end {
    justify-content: flex-end;
  }

  .\32xl\:oui-justify-center {
    justify-content: center;
  }

  .\32xl\:oui-justify-between {
    justify-content: space-between;
  }

  .\32xl\:oui-justify-around {
    justify-content: space-around;
  }

  .\32xl\:oui-justify-evenly {
    justify-content: space-evenly;
  }

  .\32xl\:oui-justify-stretch {
    justify-content: stretch;
  }

  .\32xl\:oui-text-2xl {
    font-size: var(--oui-font-size-2xl, 1.5rem);
    line-height: 2rem;
  }

  .\32xl\:oui-text-base {
    font-size: var(--oui-font-size-base, 1rem);
    line-height: 1.5rem;
  }

  .\32xl\:oui-text-lg {
    font-size: var(--oui-font-size-lg, 1.125rem);
    line-height: 1.625rem;
  }

  .\32xl\:oui-text-sm {
    font-size: var(--oui-font-size-sm,0.875rem);
    line-height: 1.25rem;
  }
}
@media (min-width: 1440px) {

  .\33xl\:oui-flex {
    display: flex;
  }

  .\33xl\:oui-inline-flex {
    display: inline-flex;
  }

  .\33xl\:oui-max-h-\[300px\] {
    max-height: 300px;
  }

  .\33xl\:oui-w-1\/3 {
    width: 33.333333%;
  }

  .\33xl\:oui-w-2\/3 {
    width: 66.666667%;
  }

  .\33xl\:oui-flex-row {
    flex-direction: row;
  }

  .\33xl\:oui-flex-row-reverse {
    flex-direction: row-reverse;
  }

  .\33xl\:oui-flex-col {
    flex-direction: column;
  }

  .\33xl\:oui-flex-col-reverse {
    flex-direction: column-reverse;
  }

  .\33xl\:oui-flex-wrap {
    flex-wrap: wrap;
  }

  .\33xl\:oui-flex-wrap-reverse {
    flex-wrap: wrap-reverse;
  }

  .\33xl\:oui-flex-nowrap {
    flex-wrap: nowrap;
  }

  .\33xl\:oui-items-start {
    align-items: flex-start;
  }

  .\33xl\:oui-items-end {
    align-items: flex-end;
  }

  .\33xl\:oui-items-center {
    align-items: center;
  }

  .\33xl\:oui-items-baseline {
    align-items: baseline;
  }

  .\33xl\:oui-items-stretch {
    align-items: stretch;
  }

  .\33xl\:oui-justify-start {
    justify-content: flex-start;
  }

  .\33xl\:oui-justify-end {
    justify-content: flex-end;
  }

  .\33xl\:oui-justify-center {
    justify-content: center;
  }

  .\33xl\:oui-justify-between {
    justify-content: space-between;
  }

  .\33xl\:oui-justify-around {
    justify-content: space-around;
  }

  .\33xl\:oui-justify-evenly {
    justify-content: space-evenly;
  }

  .\33xl\:oui-justify-stretch {
    justify-content: stretch;
  }

  .\33xl\:oui-gap-2 {
    gap: 0.5rem;
  }
}
@media (min-width: 1680px) {

  .\34xl\:oui-flex {
    display: flex;
  }

  .\34xl\:oui-inline-flex {
    display: inline-flex;
  }

  .\34xl\:oui-flex-row {
    flex-direction: row;
  }

  .\34xl\:oui-flex-row-reverse {
    flex-direction: row-reverse;
  }

  .\34xl\:oui-flex-col {
    flex-direction: column;
  }

  .\34xl\:oui-flex-col-reverse {
    flex-direction: column-reverse;
  }

  .\34xl\:oui-flex-wrap {
    flex-wrap: wrap;
  }

  .\34xl\:oui-flex-wrap-reverse {
    flex-wrap: wrap-reverse;
  }

  .\34xl\:oui-flex-nowrap {
    flex-wrap: nowrap;
  }

  .\34xl\:oui-items-start {
    align-items: flex-start;
  }

  .\34xl\:oui-items-end {
    align-items: flex-end;
  }

  .\34xl\:oui-items-center {
    align-items: center;
  }

  .\34xl\:oui-items-baseline {
    align-items: baseline;
  }

  .\34xl\:oui-items-stretch {
    align-items: stretch;
  }

  .\34xl\:oui-justify-start {
    justify-content: flex-start;
  }

  .\34xl\:oui-justify-end {
    justify-content: flex-end;
  }

  .\34xl\:oui-justify-center {
    justify-content: center;
  }

  .\34xl\:oui-justify-between {
    justify-content: space-between;
  }

  .\34xl\:oui-justify-around {
    justify-content: space-around;
  }

  .\34xl\:oui-justify-evenly {
    justify-content: space-evenly;
  }

  .\34xl\:oui-justify-stretch {
    justify-content: stretch;
  }
}
@media (min-width: 1920px) {

  .\35xl\:oui-flex {
    display: flex;
  }

  .\35xl\:oui-inline-flex {
    display: inline-flex;
  }

  .\35xl\:oui-flex-row {
    flex-direction: row;
  }

  .\35xl\:oui-flex-row-reverse {
    flex-direction: row-reverse;
  }

  .\35xl\:oui-flex-col {
    flex-direction: column;
  }

  .\35xl\:oui-flex-col-reverse {
    flex-direction: column-reverse;
  }

  .\35xl\:oui-flex-wrap {
    flex-wrap: wrap;
  }

  .\35xl\:oui-flex-wrap-reverse {
    flex-wrap: wrap-reverse;
  }

  .\35xl\:oui-flex-nowrap {
    flex-wrap: nowrap;
  }

  .\35xl\:oui-items-start {
    align-items: flex-start;
  }

  .\35xl\:oui-items-end {
    align-items: flex-end;
  }

  .\35xl\:oui-items-center {
    align-items: center;
  }

  .\35xl\:oui-items-baseline {
    align-items: baseline;
  }

  .\35xl\:oui-items-stretch {
    align-items: stretch;
  }

  .\35xl\:oui-justify-start {
    justify-content: flex-start;
  }

  .\35xl\:oui-justify-end {
    justify-content: flex-end;
  }

  .\35xl\:oui-justify-center {
    justify-content: center;
  }

  .\35xl\:oui-justify-between {
    justify-content: space-between;
  }

  .\35xl\:oui-justify-around {
    justify-content: space-around;
  }

  .\35xl\:oui-justify-evenly {
    justify-content: space-evenly;
  }

  .\35xl\:oui-justify-stretch {
    justify-content: stretch;
  }
}
.\[\&\:has\(\>\.oui-day-range-end\)\]\:oui-rounded-e-md:has(>.oui-day-range-end) {
  border-start-end-radius: var(--oui-rounded-md, 0.375rem);
  border-end-end-radius: var(--oui-rounded-md, 0.375rem);
}
.\[\&\:has\(\>\.oui-day-range-start\)\]\:oui-rounded-s-md:has(>.oui-day-range-start) {
  border-start-start-radius: var(--oui-rounded-md, 0.375rem);
  border-end-start-radius: var(--oui-rounded-md, 0.375rem);
}
.\[\&\:has\(\[aria-selected\]\)\]\:oui-rounded-md:has([aria-selected]) {
  border-radius: var(--oui-rounded-md, 0.375rem);
}
.\[\&\:has\(\[aria-selected\]\)\]\:oui-bg-base-4:has([aria-selected]) {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--oui-color-base-4) / var(--tw-bg-opacity, 1));
}
.first\:\[\&\:has\(\[aria-selected\]\)\]\:oui-rounded-s-md:has([aria-selected]):first-child {
  border-start-start-radius: var(--oui-rounded-md, 0.375rem);
  border-end-start-radius: var(--oui-rounded-md, 0.375rem);
}
.last\:\[\&\:has\(\[aria-selected\]\)\]\:oui-rounded-e-md:has([aria-selected]):last-child {
  border-start-end-radius: var(--oui-rounded-md, 0.375rem);
  border-end-end-radius: var(--oui-rounded-md, 0.375rem);
}
.\[\&\:has\(\[aria-selected\]\.day-outside\)\]\:oui-bg-base-4\/50:has([aria-selected].day-outside) {
  background-color: rgb(var(--oui-color-base-4) / 0.5);
}
.\[\&\:has\(\[aria-selected\]\.day-range-end\)\]\:oui-rounded-e-md:has([aria-selected].day-range-end) {
  border-start-end-radius: var(--oui-rounded-md, 0.375rem);
  border-end-end-radius: var(--oui-rounded-md, 0.375rem);
}
.\[\&\>\*\:not\(\:first-child\)\]\:oui-border-t>*:not(:first-child) {
  border-top-width: 1px;
}
.\[\&\>\*\:not\(\:first-child\)\]\:oui-border-line-12>*:not(:first-child) {
  border-color: rgb(var(--oui-color-line, 255 255 255) / 0.12);
}
.\[\&\>\*\:not\(\:first-child\)\]\:oui-pt-1>*:not(:first-child) {
  padding-top: 0.25rem;
}
.\[\&\>div\]\:oui-flex-1>div {
  flex: 1 1 0%;
}
.\[\&\>div\]\:oui-text-2xs>div {
  font-size: var(--oui-font-size-2xs, 0.75rem);
  line-height: 1.125rem;
}
.\[\&\>div\]\:oui-text-base-contrast-36>div {
  color: rgb(var(--oui-color-base-foreground) / 0.36);
}
.\[\&\>span\]\:oui-line-clamp-1>span {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.\[\&\>td\:first-child\]\:oui-ps-0>td:first-child {
  padding-inline-start: 0px;
}
.\[\&\>td\:first-child\]\:oui-ps-3>td:first-child {
  padding-inline-start: 0.75rem;
}
.\[\&\>td\:last-child\]\:oui-pe-0>td:last-child {
  padding-inline-end: 0px;
}
.\[\&\>td\:last-child\]\:oui-pe-3>td:last-child {
  padding-inline-end: 0.75rem;
}
.\[\&\>th\:first-child\]\:oui-ps-3>th:first-child {
  padding-inline-start: 0.75rem;
}
.\[\&\>th\:last-child\]\:oui-pe-3>th:last-child {
  padding-inline-end: 0.75rem;
}
.\[\&_\.oui-h-10\.oui-w-full\]\:\!oui-mx-0 .oui-h-10.oui-w-full {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.\[\&_\.oui-scroll-indicator-leading\]\:oui-hidden .oui-scroll-indicator-leading {
  display: none;
}
.\[\&_\.oui-scroll-indicator-tailing\]\:oui-hidden .oui-scroll-indicator-tailing {
  display: none;
}
.\[\&_\.oui-table-pagination\]\:\!oui-justify-end .oui-table-pagination {
  justify-content: flex-end !important;
}
.\[\&_button\]\:oui-border-secondary\/80 button {
  border-color: rgb(var(--oui-color-secondary) / 0.8);
}
.\[\&_img\]\:\!oui-h-\[18px\] img {
  height: 18px !important;
}
.\[\&_p\]\:oui-text-base-contrast-36 p {
  color: rgb(var(--oui-color-base-foreground) / 0.36);
}
.\[\&_svg\]\:oui-text-secondary svg {
  --tw-text-opacity: 1;
  color: rgb(var(--oui-color-secondary) / var(--tw-text-opacity, 1));
}
.\[\&_td\]\:\!oui-px-3 td {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.\[\&_td\]\:oui-font-medium td {
  font-weight: 500;
}
.\[\&_td\]\:oui-tracking-\[0\.03em\] td {
  letter-spacing: 0.03em;
}
.\[\&_th\]\:\!oui-px-3 th {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.\[\&_th\]\:oui-font-semibold th {
  font-weight: 600;
}
.\[\&_th\]\:\!oui-tracking-\[0\.03em\] th {
  letter-spacing: 0.03em !important;
}
